webpackJsonp([1],Array(26).concat([
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./acne-01.jpg": 241,
	"./acne-01_a.jpg": 242,
	"./acne_scars-01.jpg": 243,
	"./active-ingr-no-01.jpg": 244,
	"./active-ingr-yes-01.jpg": 245,
	"./blackheads-01.jpg": 246,
	"./change-never-01.jpg": 247,
	"./change-often-01.jpg": 248,
	"./change-sometimes-01.jpg": 249,
	"./choose-byself-01.jpg": 250,
	"./choose-cosmetician-01.jpg": 251,
	"./choose-dermatology-01.jpg": 252,
	"./choose-esthetician-01.jpg": 253,
	"./choose-online-01.jpg": 254,
	"./cleanser-01.jpg": 255,
	"./dark_spots-01.jpg": 256,
	"./day-cream-01.jpg": 257,
	"./deep_wrinkles-01.jpg": 258,
	"./dehydration-01.jpg": 259,
	"./diffuse_pigment-01.jpg": 260,
	"./diffuse_redness-01.jpg": 261,
	"./discomfort-01.jpg": 262,
	"./dry-skin-01.jpg": 263,
	"./dull_oily-01.jpg": 264,
	"./exfoliation-01.jpg": 265,
	"./expression_wrinkles_disappear-01.jpg": 266,
	"./expression_wrinkles_stay-01.jpg": 267,
	"./eye-cream-01.jpg": 268,
	"./female2-01.jpg": 269,
	"./fine_wrinkles-01.jpg": 270,
	"./irregular_skin-01.jpg": 271,
	"./lack_of_elasticity-01.jpg": 272,
	"./large_pores-01.jpg": 273,
	"./male2-01.jpg": 274,
	"./mask-01-01.jpg": 275,
	"./mask-01.jpg": 276,
	"./multiple-brands-01.jpg": 277,
	"./no-routine-01.jpg": 278,
	"./not-satified-01.jpg": 279,
	"./oily_t_zone-01.jpg": 280,
	"./order-no-01.jpg": 281,
	"./order-yes-01.jpg": 282,
	"./peeling_skin-01.jpg": 283,
	"./photosensitive-01.jpg": 284,
	"./reactive_newproducts-01.jpg": 285,
	"./red_alcohol-01.jpg": 286,
	"./redness-01.jpg": 287,
	"./routine-01.jpg": 288,
	"./same-brands-01.jpg": 289,
	"./serum-01-01.jpg": 290,
	"./small_rash-01.jpg": 291,
	"./somewhat-satisfied-01.jpg": 292,
	"./symptoms2-01.jpg": 293,
	"./toner-01-01.jpg": 294,
	"./tugging_skin-01.jpg": 295,
	"./uneven-01.jpg": 296,
	"./uneven_skintone-01.jpg": 297,
	"./very-satisfied-01.jpg": 298,
	"./visible_veins-01.jpg": 299,
	"./withered_skin-01.jpg": 300,
	"./wrinkles-01.jpg": 301
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



// save our state (isPanel open or not) 
var store = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].observable({
    isNavOpen: false,
    onlineassessment: ''

});

// export const state = {
//     userIp: null
// }
// We call toggleNav anywhere we need it in our app
var mutations = {
    toggleNav: function toggleNav() {
        store.isNavOpen = !store.isNavOpen;
    },

    setAssessment: function setAssessment(val) {
        return store.onlineassessment = val;
    }
    // set_Ip (state, val) {
    //     state.userIp = val
    // }
};

// export const actions = {
//     async getIp({commit}){
//         await axios.get('https://api.ipify.org?format=json')
//         .then(x => {
//             const d = x.data.ip
//             commit('set_Ip', d)
//         })
//     }
// };

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./7O9A1099.jpg": 214,
	"./aesth1.jpg": 191,
	"./bi_cert.jpg": 215,
	"./bookonline.jpg": 94,
	"./event.jpg": 216,
	"./formulary.jpg": 192,
	"./idealproteinfoods.jpg": 95,
	"./inquire.jpg": 96,
	"./m_tutorial.jpg": 180,
	"./o_consultation1.jpg": 97,
	"./online_reservation_1.jpg": 217,
	"./pillowcase.jpg": 218,
	"./pillowcase2.jpg": 219,
	"./retail-clinic.jpg": 220,
	"./service_facial.jpg": 178,
	"./waiting_room_front_3.jpg": 190
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bookonline.df6d2fc.jpg";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/idealproteinfoods.9c2c4d4.jpg";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inquire.7f113f6.jpg";

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/o_consultation1.9f199dc.jpg";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/s_facial.ad31bb5.jpg";

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/s_hairremoval.520f521.jpg";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/s_hydrafacial.cd3a27a.jpg";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/s_microderm.1e99c68.jpg";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/s_microneedling.a2c2c09.jpg";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/s_peeling.d798600.jpg";

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/s_photofacial.eeb3833.jpg";

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_vue__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Sidebar_vue__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons_ChangeLocale_vue__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store_js__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header_vue__["a" /* default */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_2__components_Sidebar_vue__["a" /* default */],
    changelocale: __WEBPACK_IMPORTED_MODULE_3__components_buttons_ChangeLocale_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  methods: {
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_4__store_store_js__["a" /* mutations */].toggleNav();
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Burger_vue__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_ContactUs_vue__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons_ChangeLocale_vue__ = __webpack_require__(168);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "theader",
  components: {
    Burger: __WEBPACK_IMPORTED_MODULE_0__components_Burger_vue__["a" /* default */],
    Contactus: __WEBPACK_IMPORTED_MODULE_1__components_buttons_ContactUs_vue__["a" /* default */],
    changelocale: __WEBPACK_IMPORTED_MODULE_2__components_buttons_ChangeLocale_vue__["a" /* default */]
  },
  data: function data() {
    return {
      msg: ""
    };
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store_js__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        isBurgerActive: function isBurgerActive() {
            return __WEBPACK_IMPORTED_MODULE_0__store_store_js__["b" /* store */].isNavOpen;
        }
    },
    methods: {
        toggle: function toggle() {
            __WEBPACK_IMPORTED_MODULE_0__store_store_js__["a" /* mutations */].toggleNav();
        }
    }
});

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store_js__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            modal: true
        };
    },

    methods: {
        toggleModal: function toggleModal() {
            this.modal = !this.modal;
        },
        closeModal: function closeModal() {
            this.$root.$emit('bv::hide::modal', 'modal-tall');
        }
    }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeLocale_vue__ = __webpack_require__(169);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d16b054_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeLocale_vue__ = __webpack_require__(636);
function injectStyle (ssrContext) {
  __webpack_require__(635)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9d16b054"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeLocale_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d16b054_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeLocale_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store_js__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'changelocale',
  data: function data() {
    return {
      langs: ['en', 'fr']
    };
  },

  methods: {
    toggle: function toggle() {
      if (this.open == true) {
        __WEBPACK_IMPORTED_MODULE_0__store_store_js__["a" /* mutations */].toggleNav();
      }
    },
    switchLocale: function switchLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
      }
    }
  },
  computed: {
    otherlocale: function otherlocale() {
      if (this.$i18n.locale === 'en') {
        return 'fr';
      } else {
        return 'en';
      }
    },
    open: function open() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store_js__["b" /* store */].isNavOpen;
    }
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "tfooter",
  data: function data() {
    return {
      msg: "Welcome to Your Vue.js PWA",
      submitComplete: false,
      submitting: false,
      form: {
        language_code: this.$i18n.locale,
        email: ""
      }
    };
  },

  methods: {
    onSubmit: function onSubmit(evt) {
      var _this = this;

      evt.preventDefault();
      // let data = (JSON.stringify(this.form))
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form);
      this.submitting = true;
      axios.post("https://api.beauteintegrale.ca/submissions/newsletters", data).then(function (resp) {
        _this.submitting = false;
        _this.submitComplete = true;
        _this.form.email = "";
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store_js__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        closeSidebarPanel: __WEBPACK_IMPORTED_MODULE_0__store_store_js__["a" /* mutations */].toggleNav
    },
    computed: {
        isPanelOpen: function isPanelOpen() {
            return __WEBPACK_IMPORTED_MODULE_0__store_store_js__["b" /* store */].isNavOpen;
        }
    }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadLocaleMessages */
/* unused harmony export languages */
/* unused harmony export selectedLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(663);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(664);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}
var languages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(loadLocaleMessages());

var selectedLocale = Object({"NODE_ENV":"production"}).VUE_APP_I18N_LOCALE || 'fr';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  // locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  locale: selectedLocale,
  fallbackLocale: Object({"NODE_ENV":"production"}).VUE_APP_I18N_FALLBACK_LOCALE || 'fr',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/service_facial.6ad0b3c.jpg";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/athome2.9000ef1.jpeg";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/m_tutorial.291a007.jpg";

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function flattenRoutes(routes) {
  var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  var flattenedRoutes = [];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(routes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var route = _step.value;

      // Handle the case when route has an alias
      if (route.alias) {
        flattenedRoutes.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, route, { path: basePath + route.alias }));
      }

      var newPath = basePath + route.path;
      flattenedRoutes.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, route, { path: newPath }));

      // If the route has children, recursively flatten them
      if (route.children) {
        var childRoutes = flattenRoutes(route.children, newPath);
        flattenedRoutes.push.apply(flattenedRoutes, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(childRoutes));
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return flattenedRoutes;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "mainentrance",
  data: function data() {
    return {
      msg: "Welcome to BI",
      searchProductName: ""
    };
  },

  methods: {
    social: function social() {
      this.$router.push({ name: "social" });
    },
    searchProducts: function searchProducts() {
      window.location.href = "https://moncoachbeaute.ca/search?q=" + this.searchProductName;
      this.searchProductName = "";
    }
  },
  mounted: function mounted() {
    var routes = this.$router.options.routes;
    var flattenedRoutes = flattenRoutes(routes);
    console.log("Flattened route list:", flattenedRoutes);
  }
});

/***/ }),
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/waiting_room_front_3.8174bc1.jpg";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aesth1.529a521.jpg";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/formulary.ccf6cdd.jpg";

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "clinicmain",
  data: function data() {
    return {
      msg: "Welcome to BI",
      staff: [{ img: "car", name: "Caroline" }, { img: "Claudia", name: "Claudia" }, { img: "Emilie", name: "Emily" },
      //   {img: '3', name: "Claudia"},
      { img: "Roxanne", name: "Roxane" }, { img: "meg2", name: "Meg" }, { img: "sarah", name: "Sarah" }, { img: "Alexanne", name: "Alexanne" }, { img: "Joanie", name: "Joanie" }, { img: "Laura", name: "Laura" }, { img: "Brenda", name: "Brenda" },
      // { img: "cyndia", name: "Cydia" },
      { img: "maynika", name: "maynika" }, { img: "myrianne", name: "myrianne" }, { img: "nancy", name: "nancy" }, { img: "eve", name: "eve" }]
    };
  },

  methods: {
    getStaffImg: function getStaffImg(p) {
      var images = __webpack_require__(693);
      return images("./" + p + ".jpg");
    },
    getImg: function getImg(p) {
      var images = __webpack_require__(53);
      return images("./" + p + ".jpg");
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.7b2588b.jpg";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.a55bf5f.jpg";

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.ebd8914.jpg";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Alexanne.cac1222.jpg";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Brenda.9fe239d.jpg";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Claudia.247a366.jpg";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Emilie.e258fee.jpg";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Joanie.5561042.jpg";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Laura.10d3617.jpg";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Roxanne.80bec26.jpg";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/car.3a0422c.jpg";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cm.a0e1bf1.jpg";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cyndia.650908f.jpg";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/eve.c018c98.jpg";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/maynika.c2c6089.jpg";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/meg2.d8d82bd.jpg";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/myrianne.9a02ba8.jpg";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nancy.c43719f.jpg";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rc.f3b6f33.jpg";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sarah.a4bdc01.jpg";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7O9A1099.d59a5a7.jpg";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bi_cert.5ca5d19.jpg";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/event.5571799.jpg";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/online_reservation_1.14b9eae.jpg";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pillowcase.4d91718.jpg";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pillowcase2.3a7da8c.jpg";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/retail-clinic.fb6a4f8.jpg";

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var enData = [{ name: "Facials", desc: "The ultimate experience", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/2023/BI_petit format (5).jpg" }, { name: "Hydrafacial ", desc: "Skin transforming treatments", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/BI_petit format_3.jpg", new: "New" }, { name: "Microdermabrasion", desc: "Deeper cleaning", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/bi_facial_2024_2.jpg" }, { name: "Microneedling", desc: "Advanced technology for skin concerns", img: "s_microneedling" }, { name: "Peelings", desc: "Acids and enzymes", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/2023/BI_petit format (21).jpg" }, { name: "Hair Removal", desc: "Traditional and definitive hair removal", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/services/epilation.jpg" }, { name: "Photofacial", desc: "Advanced technology for skin concerns", img: "s_photofacial" }];

var frData = [{ name: "Les soins du visage", desc: "L’expérience ultime", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/2023/BI_petit format (5).jpg" }, { name: "Hydrafacial", desc: "Traitements de transformation", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/BI_petit format_3.jpg", new: "Nouveau" }, { name: "Microdermabrasion", desc: "Le nettoyage en profondeur", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/bi_facial_2024_2.jpg" }, { name: "Microneedling", desc: "Thérapie par micro-aiguilles", img: "s_microneedling" }, { name: "Les Peelings", desc: "Les acides et enzymes", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/2023/BI_petit format (21).jpg" }, { name: "Épilation", desc: "Traditionelle et définitive", img: "https://media.beauteintegrale.ca/beaute-integrale-web/images/services/epilation.jpg" }, { name: "Photofacial", desc: "La correction de la peau", img: "s_photofacial" }];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'clinicservicelist',
  props: {
    serviceType: String
  },
  data: function data() {
    return {
      servicePicked: '',
      serviceList: ''
    };
  },

  methods: {
    setService: function setService(n) {
      this.servicePicked = n;
    },
    getImg: function getImg(p) {
      //if imag starts with http, then it is a full url
      if (p.startsWith("http")) {
        return p;
      }

      var images = __webpack_require__(698);
      return images('./' + p + ".jpg");
    },
    getBrandUrl: function getBrandUrl(p) {
      var images = __webpack_require__(699);
      return images('./' + p + ".jpg");
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    serviceDetail: function serviceDetail(n) {
      var serv = n;
      this.$router.push({ name: 'servicedetail', params: { service: n } });
    },
    getData: function getData() {
      if (this.$i18n.locale == 'fr') {
        this.serviceList = frData;
      } else this.serviceList = enData;
    }
  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getData();
  },

  watch: {
    locale: function locale(newLocale, oldLocale) {
      this.getData();
    }
  }
});

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ldr.5c08db8.jpg";

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/vie.54e743a.jpg";

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var endata = [{
  name: "Facials",
  img: "s_facial",
  desc: "Unique experience in Quebec city, results, passion and expertise",
  types: ["Classic", "Hydration", "Anti-Aging", "Sensitive skin", "Teenager", "Acne facial"],
  cost: "Prices vary around 105 to 165$",
  extras: ["microdermabrasion", "peeling", "needleless mesotherapy", "eye-lip treatment"],
  prepare: ["Step 1: Complete the form about your skin concerns", "step 2: Choose the type of facial you would like to receive with your esthetician", "step3 Get ready to be pampered"],
  showtouchless: false
}, {
  name: "Peelings",
  img: "s_peeling",
  desc: "The variety of peelins offered at Beaute Integrale are focused on delivering a clinically proven anti-aging results.",
  types: ["Retinol", "Glyco 10", "Acid Peel 20%"],
  cost: "Prices are 125$ per peeling",
  extras: ["There is no extra that can be added to the peelings"],
  prepare: ["Step 1: Complete the form about your skin concerns", "step 2: Choose the type of facial you would like to receive with your esthetician", "step3 Get ready to be pampered"],
  showtouchless: false
}, {
  name: "Photofacial",
  img: "s_photofacial",
  desc: "BBL BroadBand Light is the world’s most powerful IPL device on the market. It sets new standards in treating skin conditions associated with aging, active life styles and sun damage. ",
  types: ["Local treatement", "Full face", "Full face, neck and hands"],
  cost: "Prices may vary from 100$ to 300$",
  extras: ["There is no extra that can be added to the photofacial treatments"],
  prepare: ["Step 1: Complete the form about your skin concerns", "step 2: Choose the type of photofacial you would like to receive with your esthetician trhough a live or online consultation", "step3: Get ready to receive your photofacial treatment"],
  showtouchless: false
}, {
  name: "Microdermabrasion",
  img: "s_microderm",
  desc: 'Recommended at each change of season, this complete "deep cleaning" treatment is designed to work the entire face, even in the smallest roots. Thanks to the corundum sandblasting technique, the skin will be freed of its impurities, regenerated and renewed.',
  types: ["Addition to your selected facial", "Microdermabrasion only"],
  cost: "prices may vary around 52.50$ to 85$",
  extras: ["Mask", "extraction", "massage"],
  prepare: ["Step 1: Complete the form about your skin concerns", "step 2: Choose the type of facial you would like to receive with your esthetician", "step3 Get ready to be pampered"],
  showtouchless: false
}, {
  name: "Hair Removal",
  img: "s_hairremoval",
  desc: "Beaute Integrale offers a variety of ways to get rid of hair, from the most traditional techniques to the most advanced and definitive",
  types: ["BBL Definitive hair removal", "Electrolysis by microcurrents ", "Wax and Soy"],
  cost: "Prices may vary for different body areas",
  extras: ["There is no extras that can be added to the different types of hair removal"],
  prepare: ["step 1: Meet an technician online or face-to-face to determine the areas of treatments, get the explanations of preparation for your first treatment and determine if you are a candidate", "step 2: Get ready for your first treatment"],
  showtouchless: false
}, {
  name: "Microneedling",
  img: "s_microneedling",
  desc: "The InnoPen was recognized as the best professional tool for skin rejuvenation. This revolutionary system is the ultimate in-clinic solution for treatments. InnoPen represents the technology of the future, it corrects the harmful effects of time on the skin while delaying the aging process. InnoPen is the most advanced device in its class and the safest for micro-perforation of the skin. It is an innovative instrument that is used in mesotherapy. ",
  types: ["Scars", "Stretch marks", "Fine lines and wrinkles", "Acne marks", "Hair restoration"],
  cost: "Prices may vary depending on the region treated $ 275 to $ 300 + tx",
  extras: ["There are no extras associated with mesotherapy treatments"],
  prepare: ["Step 1: Complete the concerns about your skin form", "Step 2: Choose the type of photofacial that best suits your problem with your esthetician via an online or in-person consultation. The consultation is essential to assess whether you are a candidate for treatment and that there are no contraindications. ", " Step 3: Be ready for your mesotherapy treatment "],
  showtouchless: false
}, {
  name: "Hydrafacial",
  img: "s_hydrafacial",
  desc: "The unique experience of Hydrafacial treatment, more than a facial, it is a hydrafacial.",
  types: ["Signature", "Deluxe", "Platinum", "Lip Perk", "Eye Perk"],
  cost: "Prices can vary from $199 to $325 +tx. It is possible to make additional additions (see the section improving your care)",
  extras: ["Lip Perk", "Eye Perk ", "Neck/Chest", "Body/back/arms", "Hands"],
  prepare: ["Step 1: Complete the health and skin concern questionnaire", "Step 2: Choose the facial that is most appropriate for your skin with your beautician", "Step 3: Be ready for the great experience of results and relaxation!"],
  showtouchless: false
}];

var frdata = [{
  name: "Les soins du visage",
  img: "s_facial",
  desc: "L’unique expérience du soin du visage à Québec. Résultats, passion et expertise",
  types: ["Le Classique", "Hydratation profonde", "Anti-Âge", "Peaux sensibles et réactives", "Adolescent", "Acné et imperfections"],
  cost: "Les prix peuvent varier de 105 à 165$",
  extras: ["Microdermabrasion", "Peeling", "Mésothérapie sans aiguilles", "Yeux-Lèvres"],
  prepare: ["Étape 1: Complétez le questionnaire sur vos préoccupations à l’égard de votre peau", "Étape 2: Choisissez le facial qui est le plus approprié pour votre peau avec votre esthéticienne", "Étape 3: Soyez prêts pour la grande expérience de résultats et détente!"],
  showtouchless: false
}, {
  name: "Les Peelings",
  img: "s_peeling",
  desc: "La variété de différents peelings offerts chez Beauté Intégrale sont à l’avant garde sur les résultats cliniques anti-âge.",
  types: ["Retinol", "Glyco 10", "Peeling acide 20%", "MEline"],
  cost: "Les prix pour les peelings sont à partir de 129$ + tx",
  extras: ["Il n’y a pas d’extras associés aux peelings"],
  prepare: ["Étape 1: Complétez le formulaire sur vos préoccupations à l’égard de votre peau", "Étape 2: Choisissez le peeling qui est le plus approprié pour votre peau avec votre esthéticienne", "Étape 3: Soyez prêts pour la grande expérience du peeling!"],
  showtouchless: false
}, {
  name: "Photofacial",
  img: "s_photofacial",
  desc: "BBL BroadBand Light est l’appareil IPL le plus puissant de sa catégorie sur le marché. Il créé les nouveaux standards pour le traitement des conditions de la peau associées à l’âge, les styles de vie actifs et les dommages causés par le soleil.",
  types: ["Traitement local", "Traitement visage complet", "Traitement visage complet, cou et mains"],
  cost: "Les prix peuvent varier en fonction de la région traitée 100$ à 300$",
  extras: ["Il n’y a pas d’extras associés aux traitements de photofacial"],
  prepare: ["Étape 1: Complétez le formulaire de préoccupations à l’égard de votre peau", "Étape 2: Choisissez le type de photofacial qui convient le plus à votre problématique avec votre esthéticienne via une consultation en ligne ou en personne. La consultation est primordiale pour évaluer si vous êtes candidat(e) à recevoir le traitement et qu’il n’y a aucune contre-indications.", "Étape 3: Soyez prêts à recevoir votre traitement de photofacial"],
  showtouchless: false
}, {
  name: "Microdermabrasion",
  img: "s_microderm",
  desc: "Recommandé à chaque changement de saison, ce soin “Grand ménage” complet est conçu pour travailler l’ensemble du visage jusque dans les plus petits racoins. Grâce à la technique du sablage au corindon, la peau se trouvera libérée de ses impuretés, régénérée et renouvelée.",
  types: ["Microdermabrasion en ajout à votre soin du visage", "Microdermasion seule"],
  cost: "Les prix peuvent varier de 52.50$ (en ajout à votre soin) à 85$ (seule)",
  extras: ["Masque", "Extraction", "Massage"],
  prepare: ["Étape 1: Complétez le formulaire des préoccupations à l’égard de votre peau", "Étape 2: Choisissez le type de microdermabrasion que vous voudriez recevoir avec votre esthéticienne", "Étape 3: Soyez prêt(e) à recevoir votre microdermabrasion"],
  showtouchless: false
}, {
  name: "Épilation",
  img: "s_hairremoval",
  desc: "Beauté Intégrale offre une large sélection de traitements pour se débarasser des poils indésirables. Des techniques plus traditionnelles aux techniques les plus avancées et définitives.",
  types: ["Épilation définitive par BBL", "Électrolyse par micro-courants", "Cire et Soya"],
  cost: "Les prix peuvent varier en fonction des régions du corps traitées",
  extras: ["Il n’y a pas de suppléments associés aux techniques d’épilation et d’épilation définitive"],
  prepare: ["Étape 1: Rencontrez une esthéticienne en ligne ou en personne pour déterminer les régions que vous voulez traiter. Recevez les explications et vos instructions de préparation pour votre premier traitement. La consutlation est primordiale pour déterminer si vous êtes candidat(e) à recevoir des traitements d’épilation définitive et qu’il n’y ait pas de contre-indications", "Étape 2: Soyez prêts à recevoir votre premier traitement d’épilation traditionnelle ou définitive!"],
  showtouchless: false
}, {
  name: "Microneedling",
  img: "s_microneedling",
  desc: "L’ InnoPen fut reconnu comme étant le meilleur instrument professionnel pour le rajeunissement cutané. Ce système révolutionnaire est la solution ultime en clinique pour des traitements. L’ InnoPen  représente la technologie de l’avenir, il corrige les effets néfastes du temps sur la peau tout en retardant le processus du vieillissement. InnoPen est le dispositif le plus avancé de sa catégorie et le plus sécuritaire en matière de micro- perforation de la peau. Il est un instrument innovant que l’on utilise en mésothérapie.",
  types: ["Cicatrices", "Vergetures", "Rides et ridules", "Traces d'acné", "Restauration des cheveux"],
  cost: "Les prix peuvent varier en fonction de la région traitée 275$ à 300$ + tx",
  extras: ["Il n’y a pas d’extras associés aux traitements de mésothérapie"],
  prepare: ["Étape 1: Complétez le formulaire de préoccupations à l’égard de votre peau", "Étape 2: Choisissez le type de photofacial qui convient le plus à votre problématique avec votre esthéticienne via une consultation en ligne ou en personne. La consultation est primordiale pour évaluer si vous êtes candidat(e) à recevoir le traitement et qu’il n’y a aucune contre-indications.", "Etape 3: Soyez prêts à recevoir votre traitement de mésothérapie"],
  showtouchless: false
}, {
  name: "Hydrafacial",
  img: "s_hydrafacial",
  desc: "L’unique expérience du soin Hydrafacial, plus qu’un facial, c’est un hydrafacial. ",
  types: ["Le Signature", "Le Deluxe", "Le Platine", "Le Lip Perk", "Le Eye Perk"],
  cost: "Les prix peuvent varier de 199$ à 325$ +tx.  Il est possible de faire des ajouts supplémentaires (voir la section bonifier votre soin)",
  extras: ["Lip Perk", "Eye Perk ", "Cou et décolleté", "Corps/dos/bras", "Mains"],
  prepare: ["Étape 1: Complétez le questionnaire de santé et sur vos préoccupations à l’égard de votre peau", "Étape 2: Choisissez le facial qui est le plus approprié pour votre peau avec votre esthéticienne", "Étape 3: Soyez prêts pour la grande expérience de résultats et détente!"],
  showtouchless: false
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "clinicservicedetail",
  prop: ["service-name"],
  data: function data() {
    return {
      msg: "Welcome to BI",
      serviceDisplay: "",
      serviceDetailList: "",
      img: ""
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getData: function getData() {
      var _this = this;

      if (this.$i18n.locale == "fr") {
        this.serviceDetailList = frdata;
        var x = this.serviceDetailList.filter(function (item) {
          return item.name === _this.service;
        });
        this.serviceDisplay = x[0];
      } else this.serviceDetailList = endata;
      var x = this.serviceDetailList.filter(function (item) {
        return item.name === _this.service;
      });
      this.serviceDisplay = x[0];
    }
  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    },
    service: function service() {
      return this.$route.params.service;
    }
  },
  mounted: function mounted() {
    this.getData();
    this.img = __webpack_require__(703)("./" + this.serviceDisplay.img + ".jpg");
  },

  watch: {
    locale: function locale(newLocale, oldLocale) {
      this.getData();
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'social',
  props: {
    serviceType: String
  },
  data: function data() {
    return {
      socialData: {},
      loading: true,
      new: null
    };
  },

  methods: {
    getSocial: function getSocial() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch('https://www.instagram.com/beauteintegrale/?__a=1', { mode: 'no-cors' });

              case 2:
                response = _context.sent;

                console.log(response.json());
                //  axios.options('https://www.instagram.com/beauteintegrale/?__a=1')
                //     .then((response) => {
                //         if(response.status === 200) {
                //             const html = response.data;
                //             // console.log(html.graphql.user.edge_owner_to_timeline_media.edges);
                //             var insta = html.graphql.user.edge_owner_to_timeline_media.edges
                //             var i = insta.length
                //             var x;
                //             // console.log(i)
                //             var dataAll = []
                //             for (x = 0; x < i; x++  ) {
                //               var data = {'name': insta[x].node.shortcode,
                //                      'pic': insta[x].node.display_url
                //               }

                //             dataAll.push(data)  
                //             }
                //             this.socialData = dataAll
                //             // console.log(this.socialData) 
                //             this.loading=false   
                //         }
                //         }, (err) => console.log(err) );

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    instagramPhotos: function instagramPhotos() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, userInfoSource, jsonObject, userInfo, mediaArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, media, node;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // It will contain our photos' links
                res = [];
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.instagram.com/beauteintegrale/');

              case 4:
                userInfoSource = _context2.sent;


                // userInfoSource.data contains the HTML from Axios
                jsonObject = userInfoSource.data.match(/<script type="text\/javascript">window\._sharedData = (.*)<\/script>/)[1].slice(0, -1);
                userInfo = JSON.parse(jsonObject);
                // Retrieve only the first 10 results

                mediaArray = userInfo.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges.splice(0, 10);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 11;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(mediaArray);

              case 13:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 22;
                  break;
                }

                media = _step.value;
                node = media.node;

                // Process only if is an image

                if (!(node.__typename && node.__typename !== 'GraphImage')) {
                  _context2.next = 18;
                  break;
                }

                return _context2.abrupt('continue', 19);

              case 18:

                // Push the thumbnail src in the array
                res.push(node.thumbnail_src);

              case 19:
                _iteratorNormalCompletion = true;
                _context2.next = 13;
                break;

              case 22:
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2['catch'](11);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 28:
                _context2.prev = 28;
                _context2.prev = 29;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 31:
                _context2.prev = 31;

                if (!_didIteratorError) {
                  _context2.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context2.finish(31);

              case 35:
                return _context2.finish(28);

              case 36:
                _context2.next = 41;
                break;

              case 38:
                _context2.prev = 38;
                _context2.t1 = _context2['catch'](1);

                console.error('Unable to retrieve photos. Reason: ' + _context2.t1.toString());

              case 41:

                _this2.new = res;

              case 42:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 38], [11, 24, 28, 36], [29,, 31, 35]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.instagramPhotos();
  }
});

/***/ }),
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var enData = [{ name: "How fast can you ship products",
    answer: "The products that we have on inventory are usually sent the same day. Depending on the carrier, it can take 2 to 3 business days to get to you in the Province of Québec. If we don’t have your product in inventory at the time, you can count add 2 to 3 more days to recieve your products."
}, { name: "Are the BBL treatments painful?",
    answer: " The treatments are comfortable although there may be some slight sensations of heat in the most sensitive places. The aesthetician who will do your treatment will ensure your comfort throughout the treatment."
}, { name: "What is the difference between regular electrolysis and electrolysis by microcurrents?",
    answer: " Regular electrolysis is only provided with 2 currents. Including a thermolysis current and a galvanic current with a frequency of 5 MHz or 13.56 MHz. The new micro current electrolysis machine uses the ULTRA-FAST radio frequency of 27.12 MHz so its power is 6 times faster than the other machines. This new GENERATION allows you to concentrate the energy more intensely at the base of the hair and thus obtain FINAL results much more quickly on all types of hair. It offers SIX hair removal modes and an unequaled level of COMFORT in permanent hair removal.These EXCLUSIVE techniques combined with new programs specially OPTIMIZED for MEN and women by choosing what is most effective depending on the area treated, the size of the hair and the appropriate filament which are allies for the effectiveness of the treatment done. In addition, this new generation can also offer adapted treatments to the electrologist with an automatic program for the performance of treatments depending on the currents and hydration of the region in order to provide SUPERIOR EFFICIENCY and more comfort."
}, { name: "What is the process of an online consultation with an esthetician? ",
    answer: "You will be asked to complete a questionnaire before your meeting. Our team will send you all the preparation instructions before your appointment. Thereafter, the esthetician will tour your current habits with you as well as your lifestyle. She wishes you to make the choice in your current products, use your current products and make some modifications or additions to optimize your routine according to your concerns. Our team will send you a checklist of your new routine and your choices of new products will be sent directly to your home."
}];

var frData = [{ name: "Combien celà prend-t’il de temps pour recevoir mes produits à la maison après avoir passsé une commande?",
    answer: "Les produits en inventaire sont normalement envoyé la journée même, tout dépendant du fournisseur de livraison, la livraison peut prendre 2 à 3 journées ouvrables pour la Province de Québec. Si nous n’avons pas votre produit en main, il faut compter 2 à 3 journées supplémentaires."
}, { name: "Est-ce que les traitements de BBL (Épiltion définitive) sont douloureux?",
    answer: "Les traitments sont confortables malgré qu’il peut y avoir quelques légères sensations de chaleur dans les endroits plus sensibles. L’esthéticienne qui fera votre traitement s’assurera de votre confort tout au long du traitement."
}, { name: "Quelle est la différence entre l’électrolyse régulière et l’électrolyse à micro-courants?",
    answer: " L'électrolyse régulière n'est fournie qu'avec 2 courants. Un courant de thermolyse et un courant galvanique avec une fréquence de 5 MHz ou 13,56 MHz. La nouvelle machine d'électrolyse à micro-courant utilise la fréquence radio ULTRA-FAST de 27,12 MHz, donc sa puissance est 6 fois plus rapide que les autres machines. Cette nouvelle GÉNÉRATION vous permet de concentrer l'énergie plus intensément à la base du cheveu et ainsi d'obtenir des résultats FINAUX beaucoup plus rapidement sur tous types de cheveux. Il offre SIX modes d'épilation et un niveau de CONFORT inégalé dans l'épilation permanente. Ces techniques EXCLUSIVES associées à de nouveaux programmes spécialement OPTIMISÉS POUR HOMMES et femmes en choisissant ce qui est le plus efficace en fonction de la zone traitée, de la taille des cheveux et du filament approprié qui sont des alliés pour l'efficacité du traitement effectué. De plus, cette nouvelle génération peut également proposer des traitements adaptés à l'électrologiste avec un programme automatique pour la réalisation de traitements en fonction des courants et de l'hydratation de la région afin d'offrir une EFFICACITÉ SUPÉRIEURE et plus de confort."
}, { name: "Comment se déroule une consultation virtuelle?",
    answer: "Vous serez invité à remplir un questionnaire avant votre rencontre. Notre équipe vous enverra toutes les instructions de préparation avant votre rendez-vous. Par la suite, l’esthéticienne fera une tournée de vos habitudes actuelles avec vous ainsi que de votre mode de vie. Elle vous aidera à faire le choix dans vos produits actuels, utiliser vos produits actuels et faire quelques modifications ou ajouts pour optimiser votre routine en fonction de vos préoccupations. Notre équipe se chargera de vous transmettre un document aide-mémoire de votre nouvelle routine et vos choix de nouveaux produits seront envoyés directement à votre domicile."
}];

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'faqs',
    data: function data() {
        return {
            faqs: ''
        };
    },

    methods: {
        goBack: function goBack() {
            this.$router.go(-1);
        },
        getData: function getData() {
            if (this.$i18n.locale == 'fr') {
                this.faqs = frData;
            } else this.faqs = enData;
        }
    },
    computed: {
        locale: function locale() {
            return this.$i18n.locale;
        }
    },
    mounted: function mounted() {
        this.getData();
    },

    watch: {
        locale: function locale(newLocale, oldLocale) {
            this.getData();
        }
    }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export butter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_buttercms__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_buttercms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_buttercms__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var butter = __WEBPACK_IMPORTED_MODULE_1_buttercms___default()('c02e20211ec08fd909ab2e9e91553eb8d35e5cff');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Blog',
  data: function data() {
    return {
      page_title: 'Blog',
      posts: []
    };
  },

  methods: {
    getPosts: function getPosts() {
      var _this = this;

      butter.post.list({
        page: 1,
        page_size: 10
      }).then(function (res) {
        _this.posts = res.data.data;
      });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.getPosts();
  },

  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    },

    postListing: function postListing() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(this.posts, ['published'], ['desc']);
    }
  },
  mounted: function mounted() {
    // this.getData() 
  },

  watch: {
    // locale: function (newLocale, oldLocale) {
    //     this.getData()
    // }
  }

});

/***/ }),
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export butter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buttercms__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buttercms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buttercms__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var butter = __WEBPACK_IMPORTED_MODULE_0_buttercms___default()('c02e20211ec08fd909ab2e9e91553eb8d35e5cff');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-post',
  data: function data() {
    return {
      post: null
    };
  },

  methods: {
    getPost: function getPost() {
      var _this = this;

      butter.post.retrieve(this.$route.params.slug).then(function (res) {
        _this.post = res.data;
      }).catch(function (res) {
        console.log(res);
      });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.getPost();
  },

  watch: {
    $route: {
      immediate: true,
      handler: function handler(to, from) {
        this.getPost();
      }
    }
  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    }
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_atHomeCard_vue__ = __webpack_require__(744);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var enData = [{
  name: "At-home waxing experience",
  desc: "We provide you everything you need to have successful waxing results at home ",
  cta: "View Kit",
  cta_link: "https://moncoachbeaute.ca/collections/essentiels-corps",
  img: "athome_waxing.png"
}, {
  name: "Accessories for the Home",
  desc: "Beautify your daily life",
  cta: "View Accessories",
  cta_link: "https://moncoachbeaute.ca/collections/essentiels-corps",
  img: "athome_waxing.png"
}];

var frData = [{
  name: "Expérience d'épilation à la maison",
  desc: "Nous vous fournissons tout ce dont vous avez besoin pour obtenir des résultats à la maison",
  cta: "Choisissez votre ensemble",
  cta_link: "https://moncoachbeaute.ca/collections/essentiels-corps",
  img: "athome_waxing.png"
}, {
  name: "Accessoires à la maison",
  desc: "Embellissez votre quotidien",
  cta: "Voir les accessoires",
  cta_link: "https://moncoachbeaute.ca/collections/produits-en-vedette/products/silvi-oreillers-anti-acne",
  img: "pillowcase.jpg"
}];


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "athome",
  components: { AtHomeCard: __WEBPACK_IMPORTED_MODULE_0__components_atHomeCard_vue__["a" /* default */] },
  data: function data() {
    return {
      data: ""
    };
  },

  methods: {
    getImgUrl: function getImgUrl(p) {
      var images = __webpack_require__(53);
      return images("./" + p + ".jpg");
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getData: function getData() {
      if (this.$i18n.locale == "fr") {
        this.data = frData;
      } else this.data = enData;
    }
  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getData();
  },

  watch: {
    locale: function locale(newLocale, oldLocale) {
      this.getData();
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["img", "title", "body", "link", "link_text"]
});

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./7O9A1099.jpg": 214,
	"./aesth1.jpg": 191,
	"./assessment/acne-01.jpg": 241,
	"./assessment/acne-01_a.jpg": 242,
	"./assessment/acne_scars-01.jpg": 243,
	"./assessment/active-ingr-no-01.jpg": 244,
	"./assessment/active-ingr-yes-01.jpg": 245,
	"./assessment/blackheads-01.jpg": 246,
	"./assessment/change-never-01.jpg": 247,
	"./assessment/change-often-01.jpg": 248,
	"./assessment/change-sometimes-01.jpg": 249,
	"./assessment/choose-byself-01.jpg": 250,
	"./assessment/choose-cosmetician-01.jpg": 251,
	"./assessment/choose-dermatology-01.jpg": 252,
	"./assessment/choose-esthetician-01.jpg": 253,
	"./assessment/choose-online-01.jpg": 254,
	"./assessment/cleanser-01.jpg": 255,
	"./assessment/dark_spots-01.jpg": 256,
	"./assessment/day-cream-01.jpg": 257,
	"./assessment/deep_wrinkles-01.jpg": 258,
	"./assessment/dehydration-01.jpg": 259,
	"./assessment/diffuse_pigment-01.jpg": 260,
	"./assessment/diffuse_redness-01.jpg": 261,
	"./assessment/discomfort-01.jpg": 262,
	"./assessment/dry-skin-01.jpg": 263,
	"./assessment/dull_oily-01.jpg": 264,
	"./assessment/exfoliation-01.jpg": 265,
	"./assessment/expression_wrinkles_disappear-01.jpg": 266,
	"./assessment/expression_wrinkles_stay-01.jpg": 267,
	"./assessment/eye-cream-01.jpg": 268,
	"./assessment/female2-01.jpg": 269,
	"./assessment/fine_wrinkles-01.jpg": 270,
	"./assessment/irregular_skin-01.jpg": 271,
	"./assessment/lack_of_elasticity-01.jpg": 272,
	"./assessment/large_pores-01.jpg": 273,
	"./assessment/male2-01.jpg": 274,
	"./assessment/mask-01-01.jpg": 275,
	"./assessment/mask-01.jpg": 276,
	"./assessment/multiple-brands-01.jpg": 277,
	"./assessment/no-routine-01.jpg": 278,
	"./assessment/not-satified-01.jpg": 279,
	"./assessment/oily_t_zone-01.jpg": 280,
	"./assessment/order-no-01.jpg": 281,
	"./assessment/order-yes-01.jpg": 282,
	"./assessment/peeling_skin-01.jpg": 283,
	"./assessment/photosensitive-01.jpg": 284,
	"./assessment/reactive_newproducts-01.jpg": 285,
	"./assessment/red_alcohol-01.jpg": 286,
	"./assessment/redness-01.jpg": 287,
	"./assessment/routine-01.jpg": 288,
	"./assessment/same-brands-01.jpg": 289,
	"./assessment/serum-01-01.jpg": 290,
	"./assessment/small_rash-01.jpg": 291,
	"./assessment/somewhat-satisfied-01.jpg": 292,
	"./assessment/symptoms2-01.jpg": 293,
	"./assessment/toner-01-01.jpg": 294,
	"./assessment/tugging_skin-01.jpg": 295,
	"./assessment/uneven-01.jpg": 296,
	"./assessment/uneven_skintone-01.jpg": 297,
	"./assessment/very-satisfied-01.jpg": 298,
	"./assessment/visible_veins-01.jpg": 299,
	"./assessment/withered_skin-01.jpg": 300,
	"./assessment/wrinkles-01.jpg": 301,
	"./athome2.jpeg": 179,
	"./athome_facial2.jpeg": 748,
	"./athome_waxing.png": 749,
	"./background1.png": 750,
	"./background2.png": 697,
	"./bi_cert.jpg": 215,
	"./bookonline.jpg": 94,
	"./brands/klapp.jpg": 222,
	"./brands/ldr.jpg": 223,
	"./brands/matis.jpg": 224,
	"./brands/ocean.jpg": 225,
	"./brands/vie.jpg": 226,
	"./carpic_1.png": 751,
	"./carpic_2.png": 752,
	"./event.jpg": 216,
	"./formulary.jpg": 192,
	"./formulary.png": 671,
	"./giftc/gc_classic.png": 302,
	"./giftc/gc_eyes.png": 303,
	"./giftc/gc_microdermabrasion.png": 304,
	"./giftc/gc_monetary.png": 305,
	"./giftc/gc_neck.png": 306,
	"./giftc/gc_peeling.png": 307,
	"./giftc/gc_personalized.png": 308,
	"./giftc/gc_specific.png": 309,
	"./idealprotein.png": 753,
	"./idealproteinfoods.jpg": 95,
	"./inquire.jpg": 96,
	"./m_tutorial.jpg": 180,
	"./o_consultation1.jpg": 97,
	"./o_consultation2.png": 754,
	"./oa_online.png": 310,
	"./oa_shop.png": 311,
	"./online_reservation_1.jpg": 217,
	"./onlineconsult.jpeg": 669,
	"./onlinestore1.jpeg": 672,
	"./onlinestore3.jpeg": 670,
	"./pillowcase.jpg": 218,
	"./pillowcase2.jpg": 219,
	"./retail-clinic.jpg": 220,
	"./service_facial.jpg": 178,
	"./services/s_facial.jpg": 98,
	"./services/s_hairremoval.jpg": 99,
	"./services/s_hydrafacial.jpg": 100,
	"./services/s_microderm.jpg": 101,
	"./services/s_microneedling.jpg": 102,
	"./services/s_peeling.jpg": 103,
	"./services/s_photofacial.jpg": 104,
	"./services/wl_1.png": 312,
	"./staff/1.jpg": 194,
	"./staff/2.jpg": 195,
	"./staff/3.jpg": 196,
	"./staff/Alexanne.jpg": 197,
	"./staff/Brenda.jpg": 198,
	"./staff/Claudia.jpg": 199,
	"./staff/Emilie.jpg": 200,
	"./staff/Joanie.jpg": 201,
	"./staff/Laura.jpg": 202,
	"./staff/Roxanne.jpg": 203,
	"./staff/car.jpg": 204,
	"./staff/cm.jpg": 205,
	"./staff/cyndia.jpg": 206,
	"./staff/eve.jpg": 207,
	"./staff/maynika.jpg": 208,
	"./staff/meg2.jpg": 209,
	"./staff/myrianne.jpg": 210,
	"./staff/nancy.jpg": 211,
	"./staff/rc.jpeg": 755,
	"./staff/rc.jpg": 212,
	"./staff/rp.jpeg": 756,
	"./staff/sarah.jpg": 213,
	"./waiting_room_front_3.jpg": 190
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/acne-01.196b2bd.jpg";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/acne-01_a.ecf9a49.jpg";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/acne_scars-01.0a03de6.jpg";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/active-ingr-no-01.73588a5.jpg";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/active-ingr-yes-01.cee8dc7.jpg";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/blackheads-01.cda224c.jpg";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/change-never-01.1984111.jpg";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/change-often-01.8bafe91.jpg";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/change-sometimes-01.ac18466.jpg";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/choose-byself-01.8043387.jpg";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/choose-cosmetician-01.d28a7d8.jpg";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/choose-dermatology-01.f7f2da8.jpg";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/choose-esthetician-01.98a8d2d.jpg";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/choose-online-01.a3db3af.jpg";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cleanser-01.20921ce.jpg";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dark_spots-01.d4a17bf.jpg";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/day-cream-01.1799242.jpg";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/deep_wrinkles-01.e61999d.jpg";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dehydration-01.e7ff6df.jpg";

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diffuse_pigment-01.b0199af.jpg";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diffuse_redness-01.5a7ced0.jpg";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/discomfort-01.879ca82.jpg";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dry-skin-01.ec0a8f2.jpg";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dull_oily-01.a5dba57.jpg";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/exfoliation-01.28817c3.jpg";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/expression_wrinkles_disappear-01.67b3679.jpg";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/expression_wrinkles_stay-01.ededd74.jpg";

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/eye-cream-01.b251f5c.jpg";

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/female2-01.3bf51bf.jpg";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fine_wrinkles-01.e514471.jpg";

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/irregular_skin-01.fe34944.jpg";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lack_of_elasticity-01.472bfd5.jpg";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/large_pores-01.7bf510b.jpg";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/male2-01.5ebbfd4.jpg";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mask-01-01.45e87f1.jpg";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mask-01.58c487c.jpg";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/multiple-brands-01.ed165c5.jpg";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/no-routine-01.1f8900c.jpg";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/not-satified-01.2af458d.jpg";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/oily_t_zone-01.b0de375.jpg";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/order-no-01.7661bca.jpg";

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/order-yes-01.3f6a4cd.jpg";

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/peeling_skin-01.d3f3f81.jpg";

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photosensitive-01.a83b2e0.jpg";

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/reactive_newproducts-01.6e35c97.jpg";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/red_alcohol-01.3bda77e.jpg";

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/redness-01.6a5c7de.jpg";

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/routine-01.5401f47.jpg";

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/same-brands-01.fe9e51f.jpg";

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/serum-01-01.3accb1a.jpg";

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/small_rash-01.2868a52.jpg";

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/somewhat-satisfied-01.7b53907.jpg";

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/symptoms2-01.d9c9961.jpg";

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/toner-01-01.9c4099d.jpg";

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tugging_skin-01.850e8e9.jpg";

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/uneven-01.6c27686.jpg";

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/uneven_skintone-01.0b8c909.jpg";

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/very-satisfied-01.0e95a8a.jpg";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/visible_veins-01.6e7f77b.jpg";

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/withered_skin-01.dc5b68e.jpg";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wrinkles-01.55fa60d.jpg";

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gc_classic.34c3c7a.png";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gc_eyes.b1b49c5.png";

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gc_microdermabrasion.7db0914.png";

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gc_monetary.a345465.png";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gc_neck.1b5424e.png";

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gc_peeling.c412d55.png";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gc_personalized.252fec4.png";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gc_specific.f14aa17.png";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/oa_online.0c6ae1e.png";

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/oa_shop.d00bb02.png";

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wl_1.abd65d7.png";

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var enData = {
  name: "Name",
  email: "Email",
  phone: "Phone Number",
  service: ["Facial", "Peelings", "Microdermabrasion", "Hair Removal", "Phototherapy", "Online Consultation", "In-Clinic Consultation"],
  notes: "Notes For Us",
  times: ["morning", "afternoon", "evening"],
  enterNotes: "Type here...",
  enterDate: "No Date Selected",
  enterName: "Enter Name",
  enterEmail: "Enter Email",
  enterPhone: "Enter Phone Number"
};

var frData = {
  name: "Nom",
  email: "Courriel",
  phone: "Numéro de téléphone",
  service: ["Facial", "Peelings", "Microdermabrasion", "Épilation traditionnelle ou définitive", "Photofacial", "Consultation en ligne", "Consultation en clinique"],
  notes: "Notes pour notre équipe",
  times: ["Matin", "Après-midi", "Soir"],
  enterNotes: "Écrivez ici...",
  enterDate: "Aucune date sélectionnée",
  enterName: "Entrez le nom",
  enterEmail: "Entrez votre e-mail",
  enterPhone: "Entrez le téléphone"
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "requestappt",
  data: function data() {
    return {
      msg: "Welcome to BI",
      show: true,
      display: "",
      form: {
        name: "",
        email: "",
        phone: "",
        service: [],
        notes: "",
        date: "",
        time: "",
        language_code: this.$i18n.locale
      },
      submitComplete: false,
      submitting: false,
      inquire: false
    };
  },


  methods: {
    ChoiceInquire: function ChoiceInquire() {
      this.inquire = !this.inquire;
    },
    GoToBookingSite: function GoToBookingSite() {
      window.location.href = "https://reservations.beauteintegrale.ca";
    },
    getImg: function getImg(p) {
      var images = __webpack_require__(53);
      return images("./" + p + ".jpg");
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    onSubmit: function onSubmit(evt) {
      var _this = this;

      evt.preventDefault();
      // let data = (JSON.stringify(this.form))
      this.form.date = new Date(this.form.date);
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form);
      this.submitting = true;
      this.show = false;
      axios.post("https://api.beauteintegrale.ca/submissions/appointments/requests", data).then(function (resp) {
        _this.submitting = false;
        _this.submitComplete = true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    onReset: function onReset(evt) {
      var _this2 = this;

      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.phone = "";
      this.form.service = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(function () {
        _this2.show = true;
      });
    },
    getData: function getData() {
      if (this.$i18n.locale == "fr") {
        this.display = frData;
      } else this.display = enData;
    }
  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    }
  },
  mounted: function mounted() {
    this.getData();
  },

  watch: {
    locale: function locale(newLocale, oldLocale) {
      this.getData();
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_general_choiceToggle__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store_js__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var enOptions = {
  productOptions: [{ text: "Cleanser", value: "cleanser", imgURL: "cleanser-01.jpg" }, { text: "Toner", value: "toner", imgURL: "toner-01-01.jpg" }, { text: "Serum", value: "serum", imgURL: "serum-01-01.jpg" }, { text: "Day-Cream", value: "daycream", imgURL: "day-cream-01.jpg" }, { text: "Night-Cream", value: "nightcream", imgURL: "day-cream-01.jpg" }, { text: "Eye Cream", value: "eyecream", imgURL: "eye-cream-01.jpg" }, { text: "Exfoliation", value: "exfoliation", imgURL: "exfoliation-01.jpg" }, { text: "Mask", value: "mask", imgURL: "mask-01.jpg" }],

  concernOptions: [{ text: "Redness", value: "Redness", imgURL: "redness-01.jpg" }, { text: "Imperfections / Acne", value: "Acne", imgURL: "acne-01_a.jpg" }, { text: "Uneven skintone", value: "Uneven", imgURL: "uneven-01.jpg" }, { text: "Wrinkles", value: "Wrinkles", imgURL: "wrinkles-01.jpg" }, { text: "Dry Skin", value: "Dry", imgURL: "dry-skin-01.jpg" }],

  symptomOptions: [{
    text: "Red when consuming alcohol",
    value: "Red when consuming alcohol",
    imgURL: "red_alcohol-01.jpg"
  }, {
    text: "Visible veins",
    value: "Visible veins",
    imgURL: "visible_veins-01.jpg"
  }, {
    text: "Diffuse Redness",
    value: "Diffuse Redness",
    imgURL: "diffuse_redness-01.jpg"
  }, {
    text: "Reactive to new products",
    value: "Reactive to new products",
    imgURL: "reactive_newproducts-01.jpg"
  }, { text: "Small rash", value: "Small rash", imgURL: "small_rash-01.jpg" }, {
    text: "Peeling Skin",
    value: "Peeling Skin",
    imgURL: "peeling_skin-01.jpg"
  }, {
    text: "Dull and oily",
    value: "Dull and oily",
    imgURL: "dull_oily-01.jpg"
  }, { text: "Blackheads", value: "Blackheads", imgURL: "blackheads-01.jpg" }, { text: "Acne", value: "Acne", imgURL: "acne-01.jpg" }, { text: "Large Pores", value: "Large Pores", imgURL: "large_pores-01.jpg" }, {
    text: 'Oily "T" zone',
    value: 'Oily "T" zone',
    imgURL: "oily_t_zone-01.jpg"
  }, { text: "Dehydration", value: "Dehydration", imgURL: "dehydration-01.jpg" }, { text: "Acne Scars", value: "Acne Scars", imgURL: "acne_scars-01.jpg" }, {
    text: "Irregular skin",
    value: "Irregular skin",
    imgURL: "irregular_skin-01.jpg"
  }, { text: "Dark Spots", value: "Dark Spots", imgURL: "dark_spots-01.jpg" }, {
    text: "Diffused Pigment",
    value: "Diffused Pigment",
    imgURL: "diffuse_pigment-01.jpg"
  }, {
    text: "Photosensitive",
    value: "Photosensitive",
    imgURL: "photosensitive-01.jpg"
  }, {
    text: "Fine Wrinkles",
    value: "Fine Wrinkles",
    imgURL: "fine_wrinkles-01.jpg"
  }, {
    text: "Deep Wrinkles",
    value: "Deep Wrinkles",
    imgURL: "deep_wrinkles-01.jpg"
  }, {
    text: "Expression Wrinkles Disappear",
    value: "Expression Wrinkles Disappear",
    imgURL: "expression_wrinkles_disappear-01.jpg"
  }, {
    text: "Expression Wrinkles Stay",
    value: "Expression Wrinkles Stay",
    imgURL: "expression_wrinkles_stay-01.jpg"
  }, { text: "Discomfort", value: "Discomfort", imgURL: "discomfort-01.jpg" }, {
    text: "Lack of elasticity",
    value: "Lack of elasticity",
    imgURL: "lack_of_elasticity-01.jpg"
  }, {
    text: "Tugging skin",
    value: "Tugging skin",
    imgURL: "tugging_skin-01.jpg"
  }, {
    text: "Withered skin",
    value: "Withered skin",
    imgURL: "withered_skin-01.jpg"
  }, {
    text: "Uneven skin Tone",
    value: "Uneven skin Tone",
    imgURL: "uneven_skintone-01.jpg"
  }],

  regularRoutineOptions: [{ text: "Yes", value: true, imgURL: "routine-01.jpg" }, { text: "No", value: false, imgURL: "no-routine-01.jpg" }],

  satisfiedOptions: [{
    text: "Very satisfied",
    value: "Very satisfied",
    imgURL: "very-satisfied-01.jpg"
  }, {
    text: "I wish it was better",
    value: "I wish it was better",
    imgURL: "somewhat-satisfied-01.jpg"
  }, {
    text: "Not satisfied at all",
    value: "Not satisfied at all",
    imgURL: "not-satified-01.jpg"
  }],

  multipleBrandsOptions: [{ text: "Yes", value: true, imgURL: "multiple-brands-01.jpg" }, { text: "No", value: false, imgURL: "same-brands-01.jpg" }],

  buyingPatternOptions: [{
    text: "Use same products all year",
    value: "Use same products all year",
    imgURL: "change-never-01.jpg"
  }, {
    text: "Change products sometimes",
    value: "Change products sometimes",
    imgURL: "change-sometimes-01.jpg"
  }, {
    text: "Change products often",
    value: "Change products often",
    imgURL: "change-often-01.jpg"
  }],

  choosingProductOptions: [{
    text: "By Yourself / Local",
    value: "By Yourself / Local",
    imgURL: "choose-byself-01.jpg"
  }, { text: "Online", value: "Online", imgURL: "choose-online-01.jpg" }, {
    text: "With Esthetician",
    value: "With Esthetician",
    imgURL: "choose-esthetician-01.jpg"
  }, {
    text: "With Cosmetician",
    value: "With Cosmetician",
    imgURL: "choose-cosmetician-01.jpg"
  }, {
    text: "With Dermatologist",
    value: "With Dermatologist",
    imgURL: "choose-dermatology-01.jpg"
  }],

  activeIngrOptions: [{ text: "Yes", value: true, imgURL: "active-ingr-yes-01.jpg" }, { text: "No", value: false, imgURL: "active-ingr-no-01.jpg" }],

  applyOrderOptions: [{ text: "Yes", value: true, imgURL: "order-yes-01.jpg" }, { text: "No", value: false, imgURL: "order-no-01.jpg" }],
  ageOptions: [{ text: "<18", value: "<18" }, { text: "18-25", value: "18-25" }, { text: "26-35", value: "26-35" }, { text: "36-45", value: "36-45" }, { text: "46-55", value: "46-55" }, { text: "56-65", value: "56-65" }, { text: "66-75", value: "66-75" }, { text: "76+", value: "76+" }],
  Picked: {
    language_code: "",
    name: "",
    email: "",
    terms: null,
    emails: null,
    age: "",
    applyOrder: null,
    activeIngr: null,
    choosingProduct: "",
    multipleBrands: null,
    buyingPattern: "",
    satisfied: "",
    regularRoutine: null,
    symptoms: [],
    concerns: [],
    products: [],
    datetime: this.datetimenow
  }
};

var frOptions = {
  checked: [],
  productOptions: [{
    text: "Nettoyant",
    value: "Nettoyant",
    i: "cleanser",
    imgURL: "cleanser-01.jpg"
  }, {
    text: "Lotion Tonique",
    value: "Lotion Tonique",
    i: "toner",
    imgURL: "toner-01-01.jpg"
  }, { text: "Sérum", value: "Sérum", i: "serum", imgURL: "serum-01-01.jpg" }, {
    text: "Crème de jour",
    value: "Crème de jour",
    i: "daycream",
    imgURL: "day-cream-01.jpg"
  }, {
    text: "Crème de nuit",
    value: "Crème de nuit",
    i: "nightcream",
    imgURL: "day-cream-01.jpg"
  }, {
    text: "Contour des yeux",
    value: "Contour des yeux",
    i: "eyecream",
    imgURL: "eye-cream-01.jpg"
  }, {
    text: "Exfoliant",
    value: "Exfoliant",
    i: "exfoliation",
    imgURL: "exfoliation-01.jpg"
  }, { text: "Masque", value: "Masque", i: "mask", imgURL: "mask-01.jpg" }],

  concernOptions: [{
    text: "Rougeurs",
    value: "Rougeurs",
    i: "Redness",
    imgURL: "redness-01.jpg"
  }, {
    text: "Imperfections / Acné",
    value: "Imperfections / Acné",
    i: "Acne",
    imgURL: "acne-01_a.jpg"
  }, {
    text: "Teint inégal",
    value: "Teint inégal",
    i: "Uneven",
    imgURL: "uneven-01.jpg"
  }, { text: "Rides", value: "Rides", i: "Wrinkles", imgURL: "wrinkles-01.jpg" }, {
    text: "Peau sèche",
    value: "Peau sèche",
    i: "Dry",
    imgURL: "dry-skin-01.jpg"
  }],

  symptomOptions: [{
    text: "Rougeurs en consommant de l’alcool",
    value: "Rougeurs en consommant de l’alcool",
    i: "Red when consuming alcohol",
    imgURL: "red_alcohol-01.jpg"
  }, {
    text: "Veines visibles",
    value: "Veines visibles",
    i: "Visible veins",
    imgURL: "visible_veins-01.jpg"
  }, {
    text: "Rougeurs diffuses",
    value: "Rougeurs diffuses",
    i: "Diffuse Redness",
    imgURL: "diffuse_redness-01.jpg"
  }, {
    text: "Réaction à de nouveaux produits",
    value: "Réaction à de nouveaux produits",
    i: "Reactive to new products",
    imgURL: "reactive_newproducts-01.jpg"
  }, {
    text: "Petits boutons",
    value: "Petits boutons",
    i: "Small rash",
    imgURL: "small_rash-01.jpg"
  }, {
    text: "Peau qui pèle",
    value: "Peau qui pèle",
    i: "Peeling Skin",
    imgURL: "peeling_skin-01.jpg"
  }, {
    text: "Teint terne et huileux",
    value: "Teint terne et huileux",
    i: "Dull and oily",
    imgURL: "dull_oily-01.jpg"
  }, {
    text: "Comédons",
    value: "Comédons",
    i: "Blackheads",
    imgURL: "blackheads-01.jpg"
  }, { text: "Acné", value: "Acné", i: "Acne", imgURL: "acne-01.jpg" }, {
    text: "Pores élargis",
    value: "Pores élargis",
    i: "Large Pores",
    imgURL: "large_pores-01.jpg"
  }, {
    text: "Zone “T” huileuse",
    value: "Zone “T” huileuse",
    i: 'Oily "T" zone',
    imgURL: "oily_t_zone-01.jpg"
  }, {
    text: "Déshydratation",
    value: "Déshydratation",
    i: "Dehydration",
    imgURL: "dehydration-01.jpg"
  }, {
    text: "Cicatrices d’acné",
    value: "Cicatrices d’acné",
    i: "Acne Scars",
    imgURL: "acne_scars-01.jpg"
  }, {
    text: "Relief irrégulier",
    value: "Relief irrégulier",
    i: "Irregular skin",
    imgURL: "irregular_skin-01.jpg"
  }, {
    text: "Taches pigmentaires",
    value: "Taches pigmentaires",
    i: "Dark Spots",
    imgURL: "dark_spots-01.jpg"
  }, {
    text: "Pigmentation diffuse",
    value: "Pigmentation diffuse",
    i: "Diffused Pigment",
    imgURL: "diffuse_pigment-01.jpg"
  }, {
    text: "Photosensibilité",
    value: "Photosensibilité",
    i: "Photosensitive",
    imgURL: "photosensitive-01.jpg"
  }, {
    text: "Rides de surface",
    value: "Rides de surface",
    i: "Fine Wrinkles",
    imgURL: "fine_wrinkles-01.jpg"
  }, {
    text: "Rides profondes",
    value: "ides profondes",
    i: "Deep Wrinkles",
    imgURL: "deep_wrinkles-01.jpg"
  }, {
    text: "Rides d’expressions disparaissent",
    value: "Rides d’expressions disparaissent",
    i: "Expression Wrinkles Disappear",
    imgURL: "expression_wrinkles_disappear-01.jpg"
  }, {
    text: "Rides d’expression restent",
    value: "Rides d’expression restent",
    i: "Expression Wrinkles Stay",
    imgURL: "expression_wrinkles_stay-01.jpg"
  }, {
    text: "Inconfort",
    value: "Inconfort",
    i: "Discomfort",
    imgURL: "discomfort-01.jpg"
  }, {
    text: "Manque d’élasticité",
    value: "Manque d’élasticité",
    i: "Lack of elasticity",
    imgURL: "lack_of_elasticity-01.jpg"
  }, {
    text: "Peau floconneuse",
    value: "Peau floconneuse",
    i: "Tugging skin",
    imgURL: "tugging_skin-01.jpg"
  }, {
    text: "Peau flétrie",
    value: "Peau flétrie",
    i: "Withered skin",
    imgURL: "withered_skin-01.jpg"
  }, {
    text: "Teint inégal",
    value: "Teint inégal",
    i: "Uneven skin Tone",
    imgURL: "uneven_skintone-01.jpg"
  }],

  regularRoutineOptions: [{ text: "Oui", value: true, imgURL: "routine-01.jpg" }, { text: "Non", value: false, imgURL: "no-routine-01.jpg" }],

  satisfiedOptions: [{
    text: "Très satisfait(e)",
    value: "Très satisfait(e)",
    i: "Very satisfied",
    imgURL: "very-satisfied-01.jpg"
  }, {
    text: "J’aimerais l’améliorer",
    value: "J’aimerais l’améliorer",
    i: "I wish it was better",
    imgURL: "somewhat-satisfied-01.jpg"
  }, {
    text: "Très insatisfait(e)",
    value: "Très insatisfait(e)",
    i: "Not satisfied at all",
    imgURL: "not-satified-01.jpg"
  }],

  multipleBrandsOptions: [{ text: "Oui", value: true, imgURL: "multiple-brands-01.jpg" }, { text: "Non", value: false, imgURL: "same-brands-01.jpg" }],

  buyingPatternOptions: [{
    text: "J’utilise les mêmes produits à l’année longue",
    value: "J’utilise les mêmes produits à l’année longue",
    i: "Use same products all year",
    imgURL: "change-never-01.jpg"
  }, {
    text: "Je change parfois de produits",
    value: "Je change parfois de produits",
    i: "Change products sometimes",
    imgURL: "change-sometimes-01.jpg"
  }, {
    text: "Je change souvent de produits",
    value: "Je change souvent de produits",
    i: "Change products often",
    imgURL: "change-often-01.jpg"
  }],

  choosingProductOptions: [{
    text: "Par moi-même",
    value: "Par moi-même",
    i: "By Yourself / Local",
    imgURL: "choose-byself-01.jpg"
  }, {
    text: "En ligne",
    value: "En ligne",
    i: "Online",
    imgURL: "choose-online-01.jpg"
  }, {
    text: "Avec une esthéticienne",
    value: "Avec une esthéticienne",
    i: "With Esthetician",
    imgURL: "choose-esthetician-01.jpg"
  }, {
    text: "Avec une cosméticienne",
    value: "Avec une cosméticienne",
    i: "With Cosmetician",
    imgURL: "choose-cosmetician-01.jpg"
  }, {
    text: "Avec un dermatologue",
    value: "Avec un dermatologue",
    i: "With Dermatologist",
    imgURL: "choose-dermatology-01.jpg"
  }],

  activeIngrOptions: [{ text: "Oui", value: true, imgURL: "active-ingr-yes-01.jpg" }, { text: "Non", value: false, imgURL: "active-ingr-no-01.jpg" }],

  applyOrderOptions: [{ text: "Oui", value: true, imgURL: "order-yes-01.jpg" }, { text: "Non", value: false, imgURL: "order-no-01.jpg" }],
  ageOptions: [{ text: "<18", value: "<18" }, { text: "18-25", value: "18-25" }, { text: "26-35", value: "26-35" }, { text: "36-45", value: "36-45" }, { text: "46-55", value: "46-55" }, { text: "56-65", value: "56-65" }, { text: "66-75", value: "66-75" }, { text: "76+", value: "76+" }],
  Picked: {
    language_code: "",
    name: "",
    email: "",
    terms: null,
    emails: null,
    age: "",
    applyOrder: null,
    activeIngr: null,
    choosingProduct: "",
    multipleBrands: null,
    buyingPattern: "",
    satisfied: "",
    regularRoutine: null,
    symptoms: [],
    concerns: [],
    products: [],
    datetime: this.datetimenow
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "online-skincare-assessment",
  components: {
    choiceToggle: __WEBPACK_IMPORTED_MODULE_0__components_general_choiceToggle__["a" /* default */]
  },
  data: function data() {
    return {
      code: "",
      validcode: false,
      submitting: false,
      current_step: 1,
      max_step: 11,
      form: ""
    };
  },

  methods: {
    getData: function getData() {
      if (this.$i18n.locale == "fr") {
        this.form = frOptions;
        this.form.language_code = "fr";
      } else this.form = enOptions;
      this.form.language_code = "en";
    },
    IsInList: function IsInList(x, l) {
      var length = l.length;
      for (var i = 0; i < length; i++) {
        if (l[i] == x.value) return true;
      }
    },
    choicePic: function choicePic(c) {
      this.productPicked.push();
    },
    checkCode: function checkCode() {
      this.validcode = true;
    },

    onClickNext: function onClickNext() {
      this.current_step++;
    },
    onClickBack: function onClickBack() {
      this.current_step--;
    },
    onClickFirst: function onClickFirst() {
      this.current_step = 1;
    },
    datetimenow: function datetimenow() {
      var currentDate = new Date();
      this.form.Picked.datetimenow = currentDate;
    },
    SubmitQuiz: function SubmitQuiz(evt) {
      evt.preventDefault();
      this.submitting = true;
      this.postAssessment();
    },
    postAssessment: function postAssessment() {
      var _this = this;

      var data = this.form.Picked;
      // axios.post('http://127.0.0.1:8000/api/assessment', data)
      axios.post("https://api.beauteintegrale.ca/submissions/assessments", data).then(function (resp) {
        __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* mutations */].setAssessment(resp.data.result);
        _this.submitting = false;
        _this.$router.push({ name: "OnlineAssessmentResults" });
      }).catch(function (e) {
        console.log(e);
      });
    }
  },

  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    },

    progress: function progress() {
      return Math.round(100 / this.max_step) * this.current_step;
    },
    buttonaction1: function buttonaction1() {
      if (this.form.Picked.name.length > 2 && this.form.Picked.terms && this.form.Picked.emails) {
        return false;
      } else return true;
    },
    buttonaction2: function buttonaction2() {
      if (this.form.Picked.products.length >= 1) {
        return false;
      } else return true;
    },
    buttonaction3: function buttonaction3() {
      if (this.form.Picked.concerns.length >= 1) {
        return false;
      } else return true;
    },
    buttonaction4: function buttonaction4() {
      if (this.form.Picked.symptoms.length >= 1) {
        return false;
      } else return true;
    },
    buttonaction5: function buttonaction5() {
      if (this.form.Picked.regularRoutine !== null) {
        return false;
      } else return true;
    },
    buttonaction6: function buttonaction6() {
      if (this.form.Picked.satisfied.length > 1) {
        return false;
      } else return true;
    },
    buttonaction7: function buttonaction7() {
      if (this.form.Picked.multipleBrands !== null) {
        return false;
      } else return true;
    },
    buttonaction8: function buttonaction8() {
      if (this.form.Picked.buyingPattern.length > 1) {
        return false;
      } else return true;
    },
    buttonaction9: function buttonaction9() {
      return false;
    },
    buttonaction10: function buttonaction10() {
      if (this.form.Picked.applyOrder !== null) {
        return false;
      } else return true;
    },
    buttonaction11: function buttonaction11() {
      if (this.form.Picked.choosingProduct.length > 1) {
        return false;
      } else return true;
    },
    buttonaction12: function buttonaction12() {
      if (this.form.Picked.age.length > 1 && this.form.Picked.email.length > 1 && this.form.Picked.email.includes("@")) {
        return false;
      } else return true;
    }
  },
  mounted: function mounted() {
    this.getData();
  },

  watch: {
    locale: function locale(newLocale, oldLocale) {
      this.getData();
      this.current_step = 1;
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "choiceToggle",
    props: ['item'],
    data: function data() {
        return {
            isActive: false
        };
    },

    methods: {
        toggleClass: function toggleClass() {
            this.isActive = !this.isActive;
        }
    }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store_js__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var enResult = {
  main: "Your answers have been submitted to our team for review. We will connect with you very shortly to discuss different options. Look in your inbox in the next days to receive a personalized message from a member of our team!",
  activeIngr: "Active ingredients play an important role in your skincare products, you should make sure to combine the appropriate ones together",
  multipleBrands: " Using different brands of products can create a confusion to your skin and end up with new concerns",
  applyOrder: " Applying your products is the right order is very important, it helps your products performing the way they should.",
  regularRoutine: " Its tough to keep a regular routine but we can help. it is important for long lasting results.",
  none: "You have a good routine but we may be able to optimize the products you use for better results"
};

var frResult = {
  main: "Vos réponses ont été soumises à notre équipe et sont présentement en révision. Nous communiquerons avec vous par courriel sous peu pour discuter des différentes options qui s'offrent à vous.  Surveillez votre boîte de courriels dans les prochains jours pour recevoir un message personnel d'un membre de notre équipe! ",
  activeIngr: "Les ingrédients actifs jouent un rôle important dans vos produits, il faut être attentif à l’utilisation et à la combinaison de ceux-ci",
  multipleBrands: " Utiliser plusieurs marques de produits peut créer une confusion à votre peau et vous pourriez avoir de nouvelles préoccupations",
  applyOrder: " L’ordre d’application des produits est importante et aide vos produits à performer sur votre peau comme ils se doivent",
  regularRoutine: " Il est difficile d’être assidu sur sa routine de soin de la peau, mais la routine est d’une importance primordiale pour avoir des résultats à long terme.",
  none: "Vous avez une bonne routine mais nous pouvons être en mesure d'optimiser les produits que vous utilisez pour de meilleurs résultats"
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "onlineassessmentresult",
  // props: ['form'],
  data: function data() {
    return {
      msg: "",
      answers: [],
      display: "",
      info: "",
      loading: true,
      errored: false,
      resultproductlink: "https://moncoachbeaute.ca/"
    };
  },

  methods: {
    setData: function setData() {
      this.answers = __WEBPACK_IMPORTED_MODULE_0__store_store_js__["b" /* store */].onlineassessment;
      if (this.$i18n.locale == "fr") {
        this.display = frResult;
      } else this.display = enResult;
      // console.log(this.answers);
    }
  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    }
  },
  mounted: function mounted() {
    this.setData();
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'online-experience-facial',
  data: function data() {
    return {
      code: '',
      validcode: false,
      current_step: 1,
      max_step: 10
    };
  },

  methods: {
    checkCode: function checkCode() {
      this.validcode = true;
    },

    onClickNext: function onClickNext() {
      this.current_step++;
    },
    onClickBack: function onClickBack() {
      this.current_step--;
    },
    onClickFirst: function onClickFirst() {
      this.current_step = 1;
    }
  },
  computed: {
    progress: function progress() {
      return Math.round(100 / this.max_step) * this.current_step;
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'onlinelanding',
  data: function data() {
    return {
      img: ''
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getImgUrl: function getImgUrl(pic) {
      return __webpack_require__(240)("./" + pic);
    }
  },
  mounted: function mounted() {

    this.img = __webpack_require__(97);
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_featured_facial__ = __webpack_require__(780);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FeaturedFacial: __WEBPACK_IMPORTED_MODULE_0__components_featured_facial__["a" /* default */] },
  data: function data() {
    return {
      slug: this.$route.params.slug
    };
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// const enData = [
//           {name: "coming soon",
//           date: "june 1, 2020",
//           type: "",
//           img: "https://placekitten.com/g/350/450",
//           desc: "thank you for your patience!",
//           link: "",
//           },
// ]

// const frData = [
//           {name: "coming soon",
//           date: "june 1, 2020",
//           type: "",
//           img: "https://placekitten.com/g/350/450",
//           desc: "thank you for your patience!",
//           link: "",
//           }
// ]


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'weightloss',
  data: function data() {
    return {
      event: '',
      wl: [],
      existingShow: true,
      existing: false,
      newclient: false
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getData: function getData() {
      if (this.$i18n.locale == 'fr') {
        this.tutorials = frData;
      } else this.tutorials = enData;
    },
    setExisting: function setExisting() {
      this.existing = true;
      this.newclient = false;
      this.existingShow = false;
    },
    setNew: function setNew() {
      this.existing = false;
      this.newclient = true;
      this.existingShow = false;
    }
    //   serviceDetail(n) {
    //       var serv = n
    //       this.$router.push({ name: 'servicedetail', params: { service: n } })
    //   }

  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    }
  },
  mounted: function mounted() {
    this.getData();
  },

  watch: {
    locale: function locale(newLocale, oldLocale) {
      this.getData();
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'shareroutine',
    data: function data() {
        return {
            msg: 'Welcome to BI',
            routines: [{
                skintype: "Red",
                title: "Best Matis Routine Ever, I Love this",
                author: "Claudia",
                location: "Quebec City",
                img: "retail-clinic.jpg", //from aws s3 link
                description: "I love this routine for my red skin",
                season: "All Seasons",
                products: {
                    cleanser: { name: "matis 123", use: "daily in morning" },
                    toner: { name: "matis 123", use: "daily in morning" },
                    serum: { name: "matis 123", use: "daily in morning" },
                    daycream: { name: "matis 123", use: "daily in morning" },
                    nightcream: { name: "matis 123", use: "daily in morning" },
                    eyecream: { name: "matis 123", use: "daily in morning" },
                    exfoliator: { name: "matis 123", use: "daily in morning" },
                    mask: { name: "matis 123", use: "daily in morning" }

                },
                howtouse: "I use this routine daily. I apply x to x and get x",
                date: '2017-03-01',
                verified: true,
                shoplink: "www.moncoachbeaute.ca",
                likes: 107 //must provide email only, this will allow verified and reduce dupicate submissions
            }, {
                skintype: "Red",
                title: "Best Matis Routine",
                author: "Claudia",
                location: "Quebec City",
                img: "retail-clinic.jpg", //from aws s3 link
                description: "I love this routine for my red skin",
                season: "All Seasons",
                products: {
                    cleanser: { name: "matis 123", use: "daily in morning" },
                    toner: { name: "matis 123", use: "daily in morning" },
                    serum: { name: "matis 123", use: "daily in morning" },
                    daycream: { name: "matis 123", use: "daily in morning" },
                    nightcream: { name: "matis 123", use: "daily in morning" },
                    eyecream: { name: "matis 123", use: "daily in morning" },
                    exfoliator: { name: "matis 123", use: "daily in morning" },
                    mask: { name: "matis 123", use: "daily in morning" }

                },
                howtouse: "I use this routine daily. I apply x to x and get x",
                date: '2017-03-01',
                verified: true,
                shoplink: "www.moncoachbeaute.ca",
                likes: 107 //must provide email only, this will allow verified and reduce dupicate submissions
            }, {
                skintype: "Red",
                title: "Best Matis Routine",
                author: "Claudia",
                location: "Quebec City",
                img: "retail-clinic.jpg", //from aws s3 link
                description: "I love this routine for my red skin",
                season: "All Seasons",
                products: {
                    cleanser: { name: "matis 123", use: "daily in morning" },
                    toner: { name: "matis 123", use: "daily in morning" },
                    serum: { name: "matis 123", use: "daily in morning" },
                    daycream: { name: "matis 123", use: "daily in morning" },
                    nightcream: { name: "matis 123", use: "daily in morning" },
                    eyecream: { name: "matis 123", use: "daily in morning" },
                    exfoliator: { name: "matis 123", use: "daily in morning" },
                    mask: { name: "matis 123", use: "daily in morning" }

                },
                howtouse: "I use this routine daily. I apply x to x and get x",
                date: '2017-03-01',
                verified: true,
                shoplink: "www.moncoachbeaute.ca",
                likes: 107 //must provide email only, this will allow verified and reduce dupicate submissions
            }, {
                skintype: "Red",
                title: "Best Matis Routine",
                author: "Claudia",
                location: "Quebec City",
                img: "retail-clinic.jpg", //from aws s3 link
                description: "I love this routine for my red skin",
                season: "All Seasons",
                products: {
                    cleanser: { name: "matis 123", use: "daily in morning" },
                    toner: { name: "matis 123", use: "daily in morning" },
                    serum: { name: "matis 123", use: "daily in morning" },
                    daycream: { name: "matis 123", use: "daily in morning" },
                    nightcream: { name: "matis 123", use: "daily in morning" },
                    eyecream: { name: "matis 123", use: "daily in morning" },
                    exfoliator: { name: "matis 123", use: "daily in morning" },
                    mask: { name: "matis 123", use: "daily in morning" }

                },
                howtouse: "I use this routine daily. I apply x to x and get x",
                date: '2017-03-01',
                verified: true,
                shoplink: "www.moncoachbeaute.ca",
                likes: 107 //must provide email only, this will allow verified and reduce dupicate submissions
            }]

        };
    },

    methods: {
        getImg: function getImg(p) {
            var images = __webpack_require__(53);
            return images('./' + p + ".jpg");
        },
        goBack: function goBack() {
            this.$router.go(-1);
        }
    }

});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'termsprivacy',
    data: function data() {
        return {
            terms: ''
        };
    },

    methods: {
        goBack: function goBack() {
            this.$router.go(-1);
        }
    },
    computed: {
        locale: function locale() {
            return this.$i18n.locale;
        }
    },
    mounted: function mounted() {}
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormCovid__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormIntake__ = __webpack_require__(798);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forms',
  components: {
    FormCovid: __WEBPACK_IMPORTED_MODULE_0__components_FormCovid__["a" /* default */],
    FormIntake: __WEBPACK_IMPORTED_MODULE_1__components_FormIntake__["a" /* default */]
  },
  data: function data() {
    return {
      msg: 'Welcome to BI',
      show: true,
      display: '',
      submitComplete: false,
      destinationForm: this.$route.params.name

    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var enData = {
    firstname: 'First Name',
    lastname: ' Last Name',
    email: 'Email',
    phone: 'Phone Number',
    notes: 'Notes For Us',
    times: ['morning', 'afternoon', 'evening'],
    enterNotes: "Type here...",
    enterDate: "No Date Selected",
    enterName: "Enter Name",
    enterEmail: "Enter Email",
    enterPhone: "Enter Phone Number",
    q1: "Avez-vous voyagé à l'extérieur du pays dans les 15 derniers jours?",
    q1a: ['Oui', 'Non'],
    q2: "Avez-vous été en contact avec une personne qui a voyagé à l'extérieur du pays dans les 15 derniers jours?",
    q2a: ['Oui', 'Non'],
    q3: "Avez-vous été en contact avec une personne infectée de la COVID-19 dans les 15 derniers jours?",
    q3a: ['Oui', 'Non'],
    q4: "Avez-vous l'un des symptômes suivants:",
    q4a: ["Toux", "Rhume", "Grippe", "Fièvre", "Infection saisonnières", "Pneumonie", "Difficulté à respirer", "Perte soudaine de l'odorat sans congestion nasale ou sans perte de goût"],
    q5: "SI oui, avez vous consulté un médecin?",
    q5a: ['Oui', 'Non'],
    q6: "Éprouvez-vous l'un des symptômes suivants qui ne sont pas liés à une cause connue, (par exemple arthrite, allergies, blessures récentes, etc.)",
    q6a: ["Mal de gorge", "Mal de tête", "Douleurs musculaires", "Fatigue intense", "Nez qui coule", "Perte importante de l'appétit", "Diharrée"]
};

var frData = {
    firstname: 'Prénom',
    lastname: 'Nom',
    email: 'Courriel',
    phone: 'Numéro de téléphone',
    notes: 'Notes pour notre équipe',
    times: ['Matin', 'Après-midi', 'Soir'],
    enterNotes: "Écrivez ici...",
    enterDate: "Aucune date sélectionnée",
    enterName: "Entrez le nom",
    enterEmail: "Entrez votre e-mail",
    enterPhone: "Entrez le téléphone",
    q1: "Avez-vous voyagé à l'extérieur du pays dans les 15 derniers jours?",
    q1a: ['Oui', 'Non'],
    q2: "Avez-vous été en contact avec une personne qui a voyagé à l'extérieur du pays dans les 15 derniers jours?",
    q2a: ['Oui', 'Non'],
    q3: "Avez-vous été en contact avec une personne infectée de la COVID-19 dans les 15 derniers jours?",
    q3a: ['Oui', 'Non'],
    q4: "Avez-vous l'un des symptômes suivants:",
    q4a: ["Toux", "Rhume", "Grippe", "Fièvre", "Infection saisonnières", "Pneumonie", "Difficulté à respirer", "Perte soudaine de l'odorat sans congestion nasale ou sans perte de goût"],
    q5: "Si oui, avez vous consulté un médecin?",
    q5a: ['Oui', 'Non'],
    q6: "Éprouvez-vous l'un des symptômes suivants qui ne sont pas liés à une cause connue, (par exemple arthrite, allergies, blessures récentes, etc.)",
    q6a: ["Mal de gorge", "Mal de tête", "Douleurs musculaires", "Fatigue intense", "Nez qui coule", "Perte importante de l'appétit", "Diharrée"]
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            show: true,
            display: '',
            form: {
                firstname: '',
                lastname: '',
                email: '',
                phone: '',
                date: '',
                q1: '',
                q1a: [],
                q2: '',
                q2a: [],
                q3: '',
                q3a: [],
                q4: '',
                q4a: [],
                q5: '',
                q5a: [],
                q6: '',
                q6a: []
            }
        };
    },

    methods: {
        onSubmit: function onSubmit(evt) {
            var _this = this;

            evt.preventDefault();
            // let data = (JSON.stringify(this.form))
            this.form.date = new Date(this.form.date);
            var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form);
            axios.post('https://beauteintegrale.ca/api/forms', data).then(function (resp) {
                _this.show = false;
            }).catch(function (error) {
                console.log(error);
            });
        },
        getData: function getData() {
            if (this.$i18n.locale == 'fr') {
                this.display = frData;
            } else this.display = enData;
        }
    },
    computed: {
        locale: function locale() {
            return this.$i18n.locale;
        },
        answers: function answers() {
            console.log(this.form.questions);
        }
    },
    mounted: function mounted() {
        this.getData();
    },

    watch: {
        locale: function locale(newLocale, oldLocale) {
            this.getData();
        }
    }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var enData = {
  title: "Pre-Consultation Questionaire",
  firstname: "First Name",
  lastname: " Last Name",
  email: "Email",
  phone: "Phone Number",
  notes: "Notes For Us",
  times: ["morning", "afternoon", "evening"],
  enterNotes: "Type here...",
  enterDate: "No Date Selected",
  enterName: "Enter Name",
  enterEmail: "Enter Email",
  enterPhone: "Enter Phone Number",

  q1: "Préoccupations Visage",
  q1a: ["Rides et ridules", "Manque de tonus", "Rougeurs", "Imperfections cutanées (comédons, acné, cicatrices, etc..)", " Teint terne sans eclat", "Inconfort", "Peau sensible ou réactive", "Contour des yeux (poches, cernes, ridules)", "Effet bonne mine / protection solaire"],
  q2: "Autres préoccupations? Spécifiez",
  q3: "Quelle est votre priorité face à votre peau? ",
  q4: "Décrivez votre routine de soins actuelle",
  q4q1: "Démaquillage des yeux:",
  q4q2: "Nettoyage du visage:",
  q4q3: "Sérum de jour/nuit:",
  q4q4: "Crème de jour/nuit:",
  q4q5: "Gommage:",
  q4q6: "Masque:",
  q4q7: "Protection solaire:",
  q4q8: "Soin des yeux:",
  q4q9: "Soin des lèvres:",
  q4q10: "Autres:",
  q5: "Aimeriez-vous partager d'autres informations avec votre esthéticienne? (Allergies, intolérances, etc?)"
};

var frData = {
  title: "QUESTIONNAIRE PRÉ-CONSULTATION",
  firstname: "Prénom",
  lastname: "Nom",
  email: "Courriel",
  phone: "Numéro de téléphone",
  notes: "Notes pour notre équipe",
  times: ["Matin", "Après-midi", "Soir"],
  enterNotes: "Écrivez ici...",
  enterDate: "Aucune date sélectionnée",
  enterName: "Entrez le nom",
  enterEmail: "Entrez votre e-mail",
  enterPhone: "Entrez le téléphone",
  q1: "Préoccupations Visage",
  q1a: ["Rides et ridules", "Manque de tonus", "Rougeurs", "Imperfections cutanées (comédons, acné, cicatrices, etc..)", " Teint terne sans eclat", "Inconfort", "Peau sensible ou réactive", "Contour des yeux (poches, cernes, ridules)", "Effet bonne mine / protection solaire"],
  q2: "Autres préoccupations? Spécifiez",
  q3: "Quelle est votre priorité face à votre peau? ",
  q4: "Décrivez votre routine de soins actuelle",
  q4q1: "Démaquillage des yeux:",
  q4q2: "Nettoyage du visage:",
  q4q3: "Sérum de jour/nuit:",
  q4q4: "Crème de jour/nuit:",
  q4q5: "Gommage:",
  q4q6: "Masque:",
  q4q7: "Protection solaire:",
  q4q8: "Soin des yeux:",
  q4q9: "Soin des lèvres:",
  q4q10: "Autres:",
  q5: "Aimeriez-vous partager d'autres informations avec votre esthéticienne? (Allergies, intolérances, etc?)"
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      show: true,
      display: "",
      form: {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        date: "",
        q1: "",
        q1a: [],
        q2: "",
        q2a: "",
        q3: "",
        q3a: "",
        q4: "",
        q4q1: "",
        q4a1: "",
        q4q2: "",
        q4a2: "",
        q4q3: "",
        q4a3: "",
        q4q4: "",
        q4a4: "",
        q4q5: "",
        q4a5: "",
        q4q6: "",
        q4a6: "",
        q4q7: "",
        q4a7: "",
        q4q8: "",
        q4a8: "",
        q4q9: "",
        q4a9: "",
        q4q10: "",
        q4a10: "",
        q5: "",
        q5a: "",
        q6a: ""
      }
    };
  },

  methods: {
    onSubmit: function onSubmit(evt) {
      var _this = this;

      evt.preventDefault();
      // let data = (JSON.stringify(this.form))
      this.form.date = new Date(this.form.date);
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form);
      console.log({ data: data });
      axios.post("https://beauteintegrale.ca/api/forms", { data: data }).then(function (resp) {
        _this.show = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getData: function getData() {
      if (this.$i18n.locale == "fr") {
        this.display = frData;
        this.form.q4q1 = this.display.q4q1;
        this.form.q4q2 = this.display.q4q2;
        this.form.q4q3 = this.display.q4q3;
        this.form.q4q4 = this.display.q4q4;
        this.form.q4q5 = this.display.q4q5;
        this.form.q4q6 = this.display.q4q6;
        this.form.q4q7 = this.display.q4q7;
        this.form.q4q8 = this.display.q4q8;
        this.form.q4q9 = this.display.q4q9;
        this.form.q4q10 = this.display.q4q10;
      } else this.display = enData;
      this.form.q4q1 = this.display.q4q1;
      this.form.q4q2 = this.display.q4q2;
      this.form.q4q3 = this.display.q4q3;
      this.form.q4q4 = this.display.q4q4;
      this.form.q4q5 = this.display.q4q5;
      this.form.q4q6 = this.display.q4q6;
      this.form.q4q7 = this.display.q4q7;
      this.form.q4q8 = this.display.q4q8;
      this.form.q4q9 = this.display.q4q9;
      this.form.q4q10 = this.display.q4q10;
    }
  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    },
    answers: function answers() {
      console.log(this.form.questions);
    }
  },
  mounted: function mounted() {
    this.getData();
  },

  watch: {
    locale: function locale(newLocale, oldLocale) {
      this.getData();
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notfound',
  data: function data() {
    return {
      data: ''
    };
  },

  methods: {
    getImgUrl: function getImgUrl(p) {
      var images = __webpack_require__(53);
      return images('./' + p + ".jpg");
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  },

  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    }
  }

});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "mainentrance",

  data: function data() {
    return {
      msg: "Welcome to BI",
      searchProductName: ""
    };
  },

  methods: {
    social: function social() {
      this.$router.push({ name: "social" });
    },
    searchProducts: function searchProducts() {
      window.location.href = "https://moncoachbeaute.ca/search?q=" + this.searchProductName;
      this.searchProductName = "";
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var endata = [{
  name: "Classic Facial",
  slug: "classique",
  img: "gc_classic.png",
  description: "\n    <p>You have received a wonderful gift, someone you love has chosen the classic facial treatment for you, it is our treatment par excellence.<p/>\n    <br/>\n    <p>This includes all the steps of the treatment, such as the welcome massage, aromatherapy, exfoliation of the skin, extraction of blackheads, massage of the feet, hands, neck , shoulders and scalp. It ends with the application of a mask and a period of relaxation.\n    <p/>\n    <br/>This treatment is mainly recognized for its moisturizing properties for the skin. This treatment lasts 1 hour 45 minutes.\n    We look forward to welcoming you and taking care of you! </p>\n    "
}, {
  name: "Personalized Facial",
  slug: "personnalise",
  img: "gc_personalized.png",
  description: "\n<p>You have received a wonderful gift, someone you love has chosen a personalized facial treatment for you, it is a treatment that is adapted to the needs of your skin.\n</p><br/><p>This includes all stages of the treatment, such as the welcome massage, aromatherapy, exfoliation of the skin, extraction of black heads, foot massage , hands, neck, shoulders and scalp. It ends with the application of essence concentrates and a mask personalized to the needs of your skin, followed by a period of relaxation. \n</p><br/><p>This treatment is mainly recognized for being adapted to the needs of your skin, whether it is sensitive, dehydrated or lacking in radiance. This treatment lasts 1 hour 45 minutes.\n</p><br/><p>We look forward to seeing you and taking care of you! <p/>\n"
}, {
  name: "Specific facial treatment",
  slug: "specifique",
  img: "gc_specific.png",
  description: "\n<p>You have received a wonderful gift, someone you love has chosen the specific facial treatment for you, it is our most advanced treatment.\n</p><br/><p>This includes all stages of the treatment, such as the welcome massage, aromatherapy, exfoliation of the skin, extraction of black heads, foot massage , hands, neck, shoulders and scalp. It ends with the application of essence concentrates and a mask personalized to the needs of your skin and a period of relaxation. This treatment is mainly recommended for skin that has a great need to regain radiance, anti-aging or for increased redness. This treatment lasts 1 hour 45 minutes.\n</p><br/><p>We look forward to seeing you and taking care of you! <p/>\n"
}, {
  name: "Teen Care",
  slug: "ado",
  image: "gc_teen.png",
  description: "\n<p>You have received a wonderful gift, someone you love has chosen for you the teenage facial treatment, it is our treatment designed for young skin.\n</p><br/><p>This includes all the steps of the treatment, the exfoliation of the skin, the extraction of black heads and the touch relaxation techniques. It ends with the application of a mask personalized to the needs of the skin of an adolescent and a period of relaxation. This treatment is mainly recognized for skins that have a great need for purification and soothing. This treatment lasts 1 hour and 15 minutes.\n</p><br/><p>We look forward to seeing you and taking care of you! <p/>\n"
}, {
  name: "Microdermabrasion",
  slug: "microdermabrasion",
  img: "gc_microdermabrasion.png",
  description: "<p>Recommended at each change of season, this complete cleaning treatment is designed to work the entire face down to the smallest corners.\n    </p><br/><p>With the corundum sandblasting technique, the skin will be freed of its impurities, regenerated and renewed.<p/>"
}, {
  name: "Eye Care",
  slug: "yeux",
  image: "gc_eyes.png",
  description: "<p>Eye care consists of the addition of a specific mask with active ingredients essentially designed for the eye contour.\n    </p><br><p>The result is smoothing of the eye contour, soothing and brightening of the eye contour.<p/> "
}, {
  name: "The Peeling",
  slug: "peeling",
  img: "gc_peeling.png",
  description: "<p>The peeling is a deep exfoliation activated by specific enzymes and chosen by our beauticians according to your skin. It provides a feeling of purity, radiance and an overall lightening of the complexion.<p/> "
}, {
  name: "Neck care",
  slug: "cou",
  image: "gc_neck.png",
  description: "<p>The addition of the neck treatment is a specific mask applied to the neck.\n    </p><br><p>This will help to restore suppleness and hydration to the skin of the neck weakened.<p/> "
}, {
  name: "Currency Value",
  slug: "valeur-monetaire",
  image: "gc_monetary.png",
  description: "<p>You have received a wonderful gift, someone you love has chosen a monetary value for you to spend at Beaut\xE9 Int\xE9grale!\n</p><br/><p>You will be spoiled for choice through our unique facial treatments, skin rejuvenation and revitalization technologies, permanent and/or traditional hair removal. \n</p><br/><p>You can also choose from a variety of professional skincare products, always with the advice and expertise of our certified beauticians.\n</p><br/><p>We look forward to welcoming you and taking care of you!</p>"
}];

var frdata = [{
  name: "Soin du visage classique",
  slug: "classique",
  img: "gc_classic.png",
  description: "\n    <p>Vous avez re\xE7u un merveilleux cadeau, une personne que vous aimez a choisi pour vous le soin du visage classique, c\u2019est notre soin par excellence.<p/> \n    <br/>\n    <p>Celui-ci comprend toutes les \xE9tapes du soin, telles que le massage de bienvenue, l\u2019aromath\xE9rapie, l\u2019exfoliation de la peau du visage, l\u2019extraction des com\xE9dons, le massage des pieds, des mains, de la nuque, des \xE9paules et du cuir chevelu. Il se termine par l\u2019application d\u2019un masque et d\u2019une p\xE9riode de relaxation. \n    </p>\n    <br/>Ce soin est principalement reconnu pour ses vertues hydratantes de la peau. Ce soin est d\u2019une dur\xE9e d\u20191h45 min.\n    Nous avons tr\xE8s h\xE2te de vous recevoir et prendre soin de vous! </p>\n    "
}, {
  name: "Soin du visage personnalisé",
  slug: "personnalise",
  img: "gc_personalized.png",
  description: "\n<p>Vous avez re\xE7u un merveilleux cadeau, une personne que vous aimez a choisi pour vous le soin du visage personnalis\xE9, c\u2019est un soin qui est adapt\xE9 aux besoins de votre peau. \n</p><br/><p>Celui-ci comprend toutes les \xE9tapes du soin, telles que le massage de bienvenue, l\u2019aromath\xE9rapie, l\u2019exfoliation de la peau du visage, l\u2019extraction des com\xE9dons, le massage des pieds, des mains, de la nuque, des \xE9paules et du cuir chevelu. \nIl se termine par l\u2019application de concentr\xE9s d\u2019essences et d\u2019un masque personnalis\xE9 aux besoins de votre peau, suivi d\u2019une p\xE9riode de relaxation. \n</p><br/><p>Ce soin est principalement reconnu pour \xEAtre adapt\xE9 aux besoins de votre peau, qu\u2019elle soit sensible, d\xE9shydrat\xE9e ou en manque d\u2019\xE9clat. Ce soin est d\u2019une dur\xE9e d\u20191h45 min.\n</p><br/><p>Nous avons tr\xE8s h\xE2te de vous recevoir et prendre soin de vous! <p/>\n"
}, {
  name: "Soin du visage spécifique",
  slug: "specifique",
  img: "gc_specific.png",
  description: "\n<p>Vous avez re\xE7u un merveilleux cadeau, une personne que vous aimez a choisi pour vous le soin du visage sp\xE9cifique, c\u2019est notre soin le plus avanc\xE9. \n</p><br/><p>Celui-ci comprend toutes les \xE9tapes du soin, telles que le massage de bienvenue, l\u2019aromath\xE9rapie, l\u2019exfoliation de la peau du visage, l\u2019extraction des com\xE9dons, le massage des pieds, des mains, de la nuque, des \xE9paules et du cuir chevelu. Il se termine par l\u2019application de concentr\xE9s d\u2019essences et d\u2019un masque personnalis\xE9 aux besoins de votre peau et d\u2019une p\xE9riode de relaxation. Ce soin est principalement recommand\xE9 pour les peaux qui ont un grand besoin de retrouver \xE9clat, l\u2019anti-\xE2ge ou pour des rougeurs accrues. Ce soin est d\u2019une dur\xE9e d\u20191h45 min.\n</p><br/><p>Nous avons tr\xE8s h\xE2te de vous recevoir et prendre soin de vous! <p/>\n"
}, {
  name: "Soin ado",
  slug: "ado",
  img: "gc_teen.png",
  description: "\n<p>Vous avez re\xE7u un merveilleux cadeau, une personne que vous aimez a choisi pour vous le soin du visage ado, c\u2019est notre soin con\xE7u pour les jeunes peaux.\n</p><br/><p>Celui-ci comprend toutes les \xE9tapes du soin, l\u2019exfoliation de la peau du visage, l\u2019extraction des com\xE9dons et les techniques d\u2019effleurement de relaxation. Il se termine par l\u2019application de masque personnalis\xE9 aux besoins de la peau d\u2019un(e) adolescent(e) et d\u2019une p\xE9riode de relaxation. Ce soin est principalement reconnu pour les peaux qui ont un grand besoin de puritfication et d\u2019apaisement. Ce soin est d\u2019une dur\xE9e d\u20191h15 min.\n</p><br/><p>Nous avons tr\xE8s h\xE2te de vous recevoir et prendre soin de vous! <p/>\n"
}, {
  name: "La microdermabrasion",
  slug: "microdermabrasion",
  img: "gc_microdermabrasion.png",
  description: "<p>Recommand\xE9e \xE0 chaque changement de saison, ce soin \u201CGrand m\xE9nage\u201D complet est con\xE7u pour travailler l\u2019ensemble du visage jusque dans les plus petits racoins. \n    </p><br/><p>Gr\xE2ce \xE0 la technique du sablage au corindon, la peau se trouvera lib\xE9r\xE9e de ses impuret\xE9s, r\xE9g\xE9n\xE9r\xE9e et renouvel\xE9e.<p/>"
}, {
  name: "Le soin des yeux",
  slug: "yeux",
  img: "gc_eyes.png",
  description: "<p>Le soin des yeux consiste \xE0 l\u2019ajout d\u2019un masque sp\xE9cifique aux actifs essentiellement con\xE7us pour le contour des yeux. \n    </p><br><p>Il en r\xE9sulte du d\xE9froissement du contour des yeux, de l\u2019apaisement et de l\u2019\xE9claircissement du regard.<p/> "
}, {
  name: "Le peeling",
  slug: "peeling",
  img: "gc_peeling.png",
  description: "<p>Le peeling est une exfoliation en profondeur activ\xE9e par des enzymes sp\xE9cifiques et choisies par notre esth\xE9ticiennes en fonction de votre peau. Il procure une sensation de puret\xE9, d\u2019\xE9clat et d\u2019un \xE9claircissement du teint en g\xE9n\xE9ral.<p/> "
}, {
  name: "Le soin du cou/décolleté",
  slug: "cou",
  img: "gc_neck.png",
  description: "<p>L\u2019ajout du soin du cou/d\xE9collet\xE9 est un masque sp\xE9cifique appliqu\xE9 au niveau du cou et du d\xE9collet\xE9. \n    </p><br><p>Celui-ci aidera \xE0 redonner souplesse et hydratation \xE0 la peau du cou et du d\xE9collet\xE9 fragilis\xE9e.<p/>  "
}, {
  name: "Valeur monétaire",
  slug: "valeur-monetaire",
  img: "gc_monetary.png",
  description: "\n<p>Vous avez re\xE7u un merveilleux cadeau, une personne que vous aimez a choisi pour vous une valeur mon\xE9taire \xE0 d\xE9penser chez Beaut\xE9 Int\xE9grale! \n<p/><br><p>Vous aurez l\u2019embarras du choix \xE0 travers nos soins du visages uniques, technologies de rajeunissement et ravivement de la peau, d\u2019\xE9pilation d\xE9finitive et/ou traditionnelle. \n<p/><br><p>Vous pouvez aussi choisir \xE0 travers une vari\xE9t\xE9 de produits professionnels de la peau, toujours avec les conseils et l\u2019expertise de nos esth\xE9ticiennes certifi\xE9es.\n<p/><br><p>Nous avons tr\xE8s h\xE2te de vous recevoir et prendre soin de vous!<p/>\n"
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "giftcardDetail",
  //   prop: ["service-name"],
  data: function data() {
    return {
      giftc_detail: "",
      giftc_detail_list: "",
      img: ""
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getData: function getData() {
      var _this = this;

      if (this.$i18n.locale == "fr") {
        this.giftc_detail_list = frdata;
      } else this.giftc_detail_list = endata;

      var x = this.giftc_detail_list.filter(function (item) {
        return item.slug === _this.giftc_slug;
      });
      if (x.length > 0) {
        this.giftc_detail = x[0];
      } else {
        this.$router.push({ name: "Main" });
      }
    }
  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    },
    giftc_slug: function giftc_slug() {
      return this.$route.params.slug;
    }
  },
  mounted: function mounted() {
    this.getData();
    if (this.giftc_detail) {
      this.img = __webpack_require__(810)("./" + this.giftc_detail.img);
    }
  },

  watch: {
    locale: function locale(newLocale, oldLocale) {
      this.getData();
    }
  }
});

/***/ }),
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "apptbutton",
  props: ["color", "block"],
  data: function data() {
    return {
      var1: "dark",
      var2: "light",
      bck: "background-color: black;"
    };
  },

  methods: {
    route: function route() {
      this.$router.push("/appointment");
      this.$emit("close");
    }
  },
  computed: {
    col: function col() {
      if (this.color === "d") {
        return this.var1;
      } else {
        return this.var2;
      }
    }
  }
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_i18n__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









// import VueFbCustomerChat from 'vue-fb-customer-chat'

// Vue.use(VueFbCustomerChat, {
//   page_id: '117562018294730', //  change 'null' to your Facebook Page ID,
//   theme_color: '#333333', // theme color in HEX
//   locale: 'fr_CA', // default 'en_US'
// })


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_8_moment___default()(String(value)).format('MM/DD/YYYY hh:mm');
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('fromNowDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_8_moment___default()(String(value)).fromNow();
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
// Install BootstrapVue
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* BootstrapVue */]);
// Optionally install the BootstrapVue icon components plugin
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["b" /* IconsPlugin */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('appt-button', __webpack_require__(850).default);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_7_axios___default.a;
var token = localStorage.getItem('token');
if (token) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http.defaults.headers.common['Authorization'] = "Token " + token;
}
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http.defaults.baseURL = Object({"NODE_ENV":"production"}).BASE_URL;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http.defaults.headers.get['Accepts'] = 'application/json';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept, X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token';

var prod = "production" === 'production';
var shouldSW = 'serviceWorker' in navigator && prod;
if (shouldSW) {
  navigator.serviceWorker.register('/service-worker.js').then(function () {
    console.log("Service Worker Registered!");
  });
}

// console.log('env', JSON.stringify(process.env))
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  i18n: __WEBPACK_IMPORTED_MODULE_6__plugins_i18n__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  },
  mounted: function mounted() {
    return document.dispatchEvent(new Event("x-app-rendered"));
  }
}).$mount('#app');

/***/ }),
/* 606 */,
/* 607 */,
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a420f67_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(654);
function injectStyle (ssrContext) {
  __webpack_require__(609)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a420f67_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */,
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4205050_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(637);
function injectStyle (ssrContext) {
  __webpack_require__(612)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a4205050"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4205050_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Burger_vue__ = __webpack_require__(158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_344d44d9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Burger_vue__ = __webpack_require__(631);
function injectStyle (ssrContext) {
  __webpack_require__(614)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Burger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_344d44d9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Burger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'active' : _vm.isBurgerActive },attrs:{"id":"burger"},on:{"click":function($event){$event.preventDefault();return _vm.toggle.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._m(0)]})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"burger-button",attrs:{"type":"button","title":"Menu"}},[_c('span',{staticClass:"hidden"},[_vm._v("Toggle menu")]),_vm._v(" "),_c('span',{staticClass:"burger-bar burger-bar--1"}),_vm._v(" "),_c('span',{staticClass:"burger-bar burger-bar--2"}),_vm._v(" "),_c('span',{staticClass:"burger-bar burger-bar--3"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUs_vue__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b8b855_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUs_vue__ = __webpack_require__(634);
function injectStyle (ssrContext) {
  __webpack_require__(633)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52b8b855"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b8b855_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contactus"}},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-tall",modifiers:{"modal-tall":true}}],attrs:{"squared":"","variant":"dark"}},[_vm._v(_vm._s(_vm.$t('contact-us.button')))]),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal-tall","title":"Contact","cancel-disabled":""},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var close = ref.close;
return [_c('div',{staticClass:"w-100"},[_c('b-button',{staticClass:"float-right",attrs:{"variant":"outline-dark","squared":"","size":"sm"},on:{"click":function($event){return close()}}},[_vm._v("\n                    Close\n                ")])],1)]}}])},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h5',[_c('i',{staticClass:"fa fa-phone fa-1x mx-1",staticStyle:{"color":"black"}}),_vm._v(_vm._s(_vm.$t('contact-us.phone')))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"dark","squared":"","href":"tel:+1418-626-8359"}},[_vm._v(" Call Us")])],1),_vm._v(" "),_c('div',[_c('h5',{staticClass:"font-weight-light"},[_vm._v("(418) 626-8359")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('h5',[_c('i',{staticClass:"fa fa-map-marker fa-1x mx-1",staticStyle:{"color":"black"}}),_vm._v(_vm._s(_vm.$t('contact-us.address'))+"\n            ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"dark","squared":"","href":"https://maps.app.goo.gl/BomTsM7BcdkP8xz69","target":"_blank"}},[_vm._v("Map\n                Address")])],1),_vm._v(" "),_c('div',[_c('h5',{staticClass:"font-weight-light"},[_vm._v("\n                Location - (Charlesbourg)"),_c('br'),_vm._v("\n                8335 Boulevard Henri-Bourassa"),_c('br'),_vm._v("\n                Québec, QC G1G 4E1\n            ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('h5',[_c('i',{staticClass:"fa fa-map-marker fa-1x mx-1",staticStyle:{"color":"black"}}),_vm._v(_vm._s(_vm.$t('contact-us.address'))+"\n            ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"dark","squared":"","href":"https://maps.app.goo.gl/crFyaCsiRshKpfhWA","target":"_blank"}},[_vm._v("Map\n                Address")])],1),_vm._v(" "),_c('div',[_c('h5',{staticClass:"font-weight-light"},[_vm._v("\n                Location - (Ste-Foy)"),_c('br'),_vm._v("\n                3100 Rue de la Forest #200"),_c('br'),_vm._v("\n                Québec City, QC G1W 1L8\n            ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('h5',[_c('i',{staticClass:"fa fa-envelope fa-1x mx-1",staticStyle:{"color":"black"}}),_vm._v(_vm._s(_vm.$t('contact-us.email')))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"dark","squared":"","href":"mailto:info@beauteintegrale.ca"}},[_vm._v("Email Us")])],1),_vm._v(" "),_c('div',[_c('h5',{staticClass:"font-weight-light"},[_vm._v("info@beauteintegrale.ca\n            ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-sm-flex flex-row justify-content-between"},[_c('h5',[_c('i',{staticClass:"fa fa-calendar fa-1x mx-1",staticStyle:{"color":"black"}}),_vm._v("Appointments")]),_vm._v(" "),_c('appt-button',{attrs:{"color":'d',"block":true},on:{"close":function($event){return _vm.closeModal()}}})],1),_vm._v(" "),_c('br')])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"changelocale"},[_c('b-btn',{style:([!_vm.open ? 'color: black':'color: white; padding-left: 0px;']),attrs:{"variant":"link"},on:{"click":function($event){return _vm.switchLocale(_vm.otherlocale)}}},[_vm._v(_vm._s(_vm.otherlocale))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('b-navbar',{staticClass:"flex-container",attrs:{"variant":"faded","type":"light"}},[_c('div',{staticClass:"burger-menu"},[_c('Burger')],1),_vm._v(" "),_c('b-navbar-brand',{staticClass:"mx-auto navbar-logo",attrs:{"href":"/"}},[_c('img',{staticClass:"d-inline-block align-top",staticStyle:{"height":"50px"},attrs:{"src":__webpack_require__(638)}})]),_vm._v(" "),_c('div',{staticClass:"header-controls ml-auto"},[_c('changelocale'),_vm._v(" "),_c('Contactus')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.6e2488f.png";

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e90c9c76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(650);
function injectStyle (ssrContext) {
  __webpack_require__(640)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e90c9c76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('b-container',{staticClass:"h-100",attrs:{"fluid":""}},[_c('b-row',{staticClass:"h-100 text-center mt-2",attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"d-flex",attrs:{"cols":"12","lg":"5"}},[(!_vm.submitComplete)?_c('b-form',{staticClass:"mx-auto mx-lg-0",attrs:{"inline":""},on:{"submit":_vm.onSubmit}},[_c('label',{staticClass:"sr-only",attrs:{"for":"input-1"}},[_vm._v(_vm._s(_vm.$t("common.enteremail")))]),_vm._v(" "),_c('b-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0 mx-lg-1",staticStyle:{"width":"300px"},attrs:{"id":"input-1","placeholder":_vm.$t('common.enteremail'),"required":"","type":"email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary tbsq mx-lg-0",attrs:{"type":"submit","id":"button-addon2"}},[_vm._v("\n            "+_vm._s(_vm.$t("main-screen.sign-up.title"))+"\n          ")])],1):_c('div',[(_vm.submitting)?_c('b-spinner',{attrs:{"label":"Spinning"}}):_c('p',[_vm._v(_vm._s(_vm.$t("common.newsletter_thank")))])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"mt-3 mt-md-1 align-items-center",attrs:{"lg":"2"}},[_c('p',{staticStyle:{"font-weight":"300","color":"lightgrey"}},[_vm._v("\n          1989 - 2023 Beaute Integrale\n        ")])]),_vm._v(" "),_c('b-col',{staticClass:"my-1 text-lg-right",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"border-0",attrs:{"variant":"outline-dark","to":"/terms-privacy"}},[_vm._v(_vm._s(_vm.$t("main-screen.terms.title")))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(176);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40af15bd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(653);
function injectStyle (ssrContext) {
  __webpack_require__(652)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40af15bd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[(_vm.isPanelOpen)?_c('div',{staticClass:"sidebar-backdrop",on:{"click":_vm.closeSidebarPanel}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[(_vm.isPanelOpen)?_c('div',{staticClass:"sidebar-panel"},[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_vm._v(" "),_c('Sidebar',[_c('ul',{staticClass:"sidebar-panel-nav"},[_c('li',{on:{"click":_vm.toggle}},[_c('router-link',{attrs:{"to":"/"},on:{"click":_vm.toggle}},[_vm._v("\n          "+_vm._s(_vm.$t("links.home"))+"\n        ")])],1),_vm._v(" "),_c('li',{on:{"click":_vm.toggle}},[_c('router-link',{attrs:{"to":"/onlineconsultation"}},[_vm._v(_vm._s(_vm.$t("links.onlineconsultation")))])],1),_vm._v(" "),_c('li',{on:{"click":_vm.toggle}},[_c('router-link',{attrs:{"to":"/online/assessment/routine"}},[_vm._v(_vm._s(_vm.$t("links.skincareassessment")))])],1),_vm._v(" "),_c('li',{on:{"click":_vm.toggle}},[_c('router-lin',[_c('a',{attrs:{"href":"https://reservations.beauteintegrale.ca/v2/#book","target":"_blank"}},[_vm._v(_vm._s(_vm.$t("links.athome")))])])],1),_vm._v(" "),_c('li',{on:{"click":_vm.toggle}},[_c('router-link',{attrs:{"to":"/clinic"}},[_vm._v(_vm._s(_vm.$t("links.retailclinic")))])],1),_vm._v(" "),_c('li',{on:{"click":_vm.toggle}},[_c('a',{attrs:{"href":"https://moncoachbeaute.ca","target":"_blank"}},[_vm._v(_vm._s(_vm.$t("links.giftcards")))])]),_vm._v(" "),_c('li',{on:{"click":_vm.toggle}},[_c('router-link',{attrs:{"to":"/faqs"}},[_vm._v(_vm._s(_vm.$t("links.faqs")))])],1),_vm._v(" "),_c('li',[_c('changelocale')],1)])]),_vm._v(" "),_c('main',{staticClass:"maincontent"},[_c('router-view')],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Main__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_ClinicMain__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_ClinicServiceList__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ClinicServiceDetail__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Social__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Faqs__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Blog__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_BlogPost__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_AtHome__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_RequestAppt__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_OnlineAssessmentRoutine__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_OnlineAssessmentResults__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_OnlineExperienceFacial__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_OnlineLanding__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_FeaturedListing__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_FeaturedDetail__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_WeightLoss__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_ShareRoutine__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_TermsPrivacy__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Forms__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_NotFound__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Main3__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_GiftCardDetail__ = __webpack_require__(808);

































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  },

  mode: 'history',
  routes: [{
    path: '/',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_24__pages_Main3__["a" /* default */]
  }, {
    path: '/onlineconsultation/',
    name: 'onlineconsultation',
    component: __WEBPACK_IMPORTED_MODULE_16__pages_OnlineLanding__["a" /* default */]
  }, {
    path: '/clinic',
    name: 'clinic',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_ClinicMain__["a" /* default */]
  }, {
    path: '/clinic/services/',
    name: 'services',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_ClinicServiceList__["a" /* default */]
  },
  // {
  //   path: '/clinic/weightloss/',
  //   name: 'weightloss',
  //   component: WeightLoss,
  // },
  {
    path: '/clinic/services/:service',
    name: 'servicedetail',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_ClinicServiceDetail__["a" /* default */]
  }, {
    path: '/clinic/forms/:name',
    name: 'FormDetail',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_Forms__["a" /* default */]
  },
  // {
  //   path: '/social',
  //   name: 'social',
  //   component: Social
  // },
  {
    path: '/faqs',
    name: 'faqs',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Faqs__["a" /* default */]
  }, {
    path: '/featured',
    name: 'featured',
    component: __WEBPACK_IMPORTED_MODULE_17__pages_FeaturedListing__["a" /* default */]
  }, {
    path: '/featured/:slug',
    name: 'featured-detail',
    component: __WEBPACK_IMPORTED_MODULE_18__pages_FeaturedDetail__["a" /* default */]
  }, {
    path: '/giftc/:slug',
    name: 'giftc-detail',
    component: __WEBPACK_IMPORTED_MODULE_25__pages_GiftCardDetail__["a" /* default */]
  },
  // {
  //   path: '/blog',
  //   name: 'blog',
  //   component: Blog
  // },
  // {
  //   path: '/blog/:slug',
  //   name: 'blog-post',
  //   component: BlogPost
  // },
  {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_RequestAppt__["a" /* default */]
  },
  // {
  //   path: '/at-home',
  //   name: 'athome',
  //   component: AtHome
  // },
  {
    path: '/online/experience/facial',
    name: 'onlineexperiencefacial',
    component: __WEBPACK_IMPORTED_MODULE_15__pages_OnlineExperienceFacial__["a" /* default */]
  }, {
    path: '/online/assessment/routine',
    name: 'OnlineAssessmentRoutine',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_OnlineAssessmentRoutine__["a" /* default */]
  }, {
    path: '/online/assessment/routine/results',
    name: 'OnlineAssessmentResults',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_OnlineAssessmentResults__["a" /* default */]
    // props: true
  }, {
    path: '/appointment',
    name: 'appointment',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_RequestAppt__["a" /* default */]
  }, {
    path: '/shareroutine',
    name: 'shareroutine',
    component: __WEBPACK_IMPORTED_MODULE_20__pages_ShareRoutine__["a" /* default */]
  }, {
    path: '/terms-privacy',
    name: 'termsprivacy',
    component: __WEBPACK_IMPORTED_MODULE_21__pages_TermsPrivacy__["a" /* default */]
  }, {
    path: '*',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_23__pages_NotFound__["a" /* default */]
  }]
});

// router.afterEach((to, from) => {
//   const data = {
//     'session': '',
//     'lang': i18n.locale,
//     'from': from.path,
//     'to': to.path,
//     'datetime': new Date()
//   }
//   console.log(data)
// })


/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": 665,
	"./fr.json": 666
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 664;

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = {"common":{"yes":"Yes","no":"No","learn-more":"Learn More","appointment":"Appointment","make-appointment":"Request Appointment","home":"Home","events":"Events","contact":"Contact Us","contact-desc":"Fill out the form to request an appointment","request-consultation":"Request Consultation","view-services":"View Services","the-team":"The Team","goback":"Go Back","next":"Next","submit":"Submit","reset":"Reset","description":"Description","types":"Types","howtoprepare":"How To Prepare","cost":"Prices","extras":"Extras","view":"View","details":"Details","form":"Form","step1":"Step 1","step2":"Step 2","step3":"Step 3","enteremail":"Enter e-mail","newsletter_thank":"Submitted. Thank you."},"main-screen":{"message":"How can we help you today?","retail":{"title":"Retail Clinic","description":"Our retail clinic in Quebec City","button_text":"Enter clinic"},"online":{"title":"Online Store","button_text":"Shop Now"},"at-home":{"title":"Online Reservations","button_text":"See Our Locations"},"search_products":{"title":"Search Products","button_text":"Search for products"},"social":{"title":"Social"},"online_consultation":{"title":"Online Consultation","button_text":"Discover Virtual"},"skincare_assessment":{"title":"Online Skincare Assessment","button_text":"Start evaluation"},"blog":{"title":"Blog","button_text":"Browse"},"gift":{"title":"Gift Card","button_text":"Shop Options"},"faqs":{"title":"Faqs","button_text":"Read"},"terms":{"title":"Terms and conditions"},"sign-up":{"title":"Sign up for offers"},"privacy":{"title":"Privacy"}},"contact-us":{"button":"Contact","title":"Contact Information","phone":"Phone","address":"Address","email":"Email","social":"Social"},"blog":{"title":"Blog","desc":"Browse our articles"},"athome":{"jumbo_title":"At-Home Skincare","jumbo_subtitle":"Do It Yourself","jumbo_desc1":"/ coaching available","jumbo_desc2":"/ professional products","waxingkitcta":"Choose Your Kit"},"clinic-main":{"jumbo-title":"Beauté Intégrale","jumbo-message1":"/ results through expertise.","jumbo-message2":"/ service with passion.","jumbo-message3":"/ helping for over 35 years.","jumbo-button":"see services","aesthetic-services":"Aesthetic Services","weight-loss":"Weight Loss","online-services":"Online Services","s_consult-title1":"Online or In-Person","s_consult-title":"Skincare Consultation","s_consult_desc":"Offering online consultation to help you determine the right skincare for your needs","the-team":"the team"},"social":{"jumbo-title":"Social","jumbo-message":"Click and browse our latest social posts or click below to view our pages"},"faqs":{"jumbo-title":"FAQs","jumbo-message":"review our most commonly asked questions"},"p-services":{"jumbo-title":"Services","jumbo-message1":"/feel at home while getting results."},"services":{"dontsee":"Don't See a Service?","help":"We will help find it for you","helpbtn":"Let Us Help"},"touchlessfacial":{"title":"Touchless Facials","description":"Our new response to help keep you safe"},"requestappt":{"jumbo_title":"Request Appointment","jumbo_desc":"/ we are here to help","q1":"What Services are You Interested In?","q2":"For When?","q3":"Choose a date & time","q4":"Contact Information","submitted":"Thank you, we will be in touch soon!","bookonline":"Book Directly Online","bookonline_desc":"Go to our booking page to book your service","inquire":"Inquire","inquire_desc":"Find out more information from us","booknow":"Book Now","form":"Contact Form"},"onlineassessment":{"title":"Welcome to the Beauté Intégrale Skincare Assessment","description":"Professional aesthetic guide to review your current skincare routine","step1":"fill out quiz","step2":"check routine","step3":"shop or consult","starteval":"Start Evaluation","terms":"Agree to Terms & Conditions","emails":"Receive Emails After Quiz","q1":"What should we call you?","q2":"What types of products do you currently use? (choose all that apply)","q3":"Which of the following concerns do you have? (choose all that apply)","q4":"Which symptoms are you experiencing? (choose all that apply)","q5":"Do you have a regular skincare routine?","q6":"How satisfied are you with your current skincare?","q7":"Does your skincare routine have multiple brands of products?","q8":"What best describes how you buy your products?","q9":"Do you pay attention to the ACTIVE ingredients in the products?","q10":"Do you care about the ORDER you apply your skincare products?","q11":"How do you choose your skincare products?","age":"what is your age?","email":"what is your email?","enteremail":"Enter Email","result_message":"We will have your customized results on the next page!","eval_transition":"We are evaluating your assessment..."},"onlineconsultation":{"jumbo_title":"Online Consultation","jumbo_desc1":"/ available for you at-home","jumbo_desc2":"/ certified aestheticians","step1":"1 / register for appointment","step1_desc":"Schedule a time and fill out pre-consultion form","step2":"2 / video chat with aesthetician","step2_desc":"Set up on your computer or phone for a private face-to-face consultation","step3":"3 / receive recommendations","step3_desc":"Your aesthetican will provide all of your recommendations","cta":"Join the hundred of satisfied clients"},"onlineassessmentresults":{"jumbo_desc":"/we will email you our suggestions soon.","thankyou":"Thank You","suggestions":"In the meantime, our algorithm says:","whilewait":"While you wait","shop":"Shop","shopskintype":"Shop your Skin Type","shop_desc":"If you do not want to wait for our recommendations, please feel free to shop our professional product lines for quality skincare","shopbutton":"Shop your Skin Type Here","results":"Results","consultation":"Consultation","consultationschedule":"Schedule a Free Online Consultation","consultation_desc":"Get a personalized recommendation from a certified aesthetican for your specific skin and lifestyle"},"weightloss":{"jumbo-title":"Weight Loss","jumbo-desc1":"/ over 16 years of results","q1":"Are you an existing Beaute Integrale Weight Loss client?","no":"No, I'd Like to Learn More","history":"History of Weight Loss","history_desc":"For over 16 years, Beaute Integrale uses a protocol called Ideal Protein. The program is an effective method for weight loss but may be tough to adhere to. Clients who are serious about weight loss can see amazing results, but to requires dedication to the program.","r1":"Over a thousand clients helped","r2":"One of the first coaches in Canada","r3":"Over 16 years of experience and coaching clients","r4":"Former North-American corporate trainer for Ideal Protein","topreasons":"Beaute Integrale top testimonials","rw1":"I helped my family changing their eating habits","rw2":"I finally can wear the clothes I like","rw3":"I played hockey with my son for the first time in 8 years","rw4":"I combatted chronic asthma","rw5":"It is not a diet for me, it’s my lifestyle","howitworks":"How It Works","h1":"Modified Ketogenic Protocol","h2":"3 Phases (Weight Loss, Stabilization, Maintenance)","h3":"Mixed Whole Foods with Ideal Protein foods","h4":"Helps preserve muscle mass","h5":"Coaching and Support Tools provided","help":"Let is help acheive your wellness goals","ctabutton":"Learn More and Get Started","orderproducts":"Order Products","orderproducts_desc":"Pre-order your products for the upcoming weeks using our contact form or feel free to call us","ordercta":"Pre-Order Foods or Supplements"},"shareroutine":{"jumbo_title":"Share Your Routine","jumbo_desc1":"/ browse other client's routines","jumbo_desc2":"/ share your own routine","sharecta":"share your own routine here"},"termsprivacy":{"jumbo_title":"Terms & Conditions / Privacy","jumbo_message":"review the policies of using our site","terms":"Terms & Conditions","privacy":"Privacy"},"links":{"home":"Home","onlineconsultation":"Online Consultation","skincareassessment":"Skincare Assessment","athome":"Online Reservations","retailclinic":"Retail Clinic","onlinestore":"Online Store","socialmedia":"Social Media","shareroutine":"Share Routine","tutorials":"Tutorials","faqs":"Faqs","giftcards":"Gift Cards"}}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = {"common":{"yes":"Oui","no":"Non","learn-more":"En savoir plus","appointment":"Rendez-vous","home":"Accueil","make-appointment":"Demande de rendez-vous","events":"Évènements","contact":"Contactez-nous","contact-desc":"Remplissez le questionnaire et demandez un rendez-vous","request-consultation":"Demande de consultation","view-services":"Voir les services","the-team":"L’équipe","goback":"Retour","next":"Suivant","submit":"Soumettre","reset":"Recommencer","description":"Description","types":"Types de soins","howtoprepare":"Comment se préparer","cost":"Prix","extras":"Bonifier votre soin","view":"Voir","details":"Détails","form":"Formulaire","step1":"Étape 1","step2":"Étape 2","step3":"Étape 3","enteremail":"Entrez votre e-mail","newsletter_thank":"Soumis, Merci."},"main-screen":{"message":"How can we help you today?","retail":{"title":"Clinique de soins","description":"Notre clinique est située à Québec","button_text":"Visiter la clinique"},"online":{"title":"Boutique en ligne","button_text":"Magasiner"},"at-home":{"title":"Réservations en ligne","button_text":"Voir Nos Succursales"},"search_products":{"title":"Produits","button_text":"Rechercher un produit"},"social":{"title":"Social"},"online_consultation":{"title":"Consultation virtuelle","button_text":"Découvrir"},"skincare_assessment":{"title":"Évaluez votre routine en ligne","button_text":"Commencer l’évaluation"},"blog":{"title":"Blog","button_text":"Rechercher"},"gift":{"title":"Cartes-Cadeaux","button_text":"Offrir un cadeau"},"faqs":{"title":"FAQ","button_text":"Lire"},"terms":{"title":"Termes and conditions"},"sign-up":{"title":"Recevoir nos promotions"},"privacy":{"title":"Politique de confidentialité"}},"contact-us":{"button":"Contact","title":"Information","phone":"Téléphone","address":"Adresse","email":"Courriel","social":"Social"},"blog":{"title":"Blog","desc":"Rechercher nos articles"},"athome":{"jumbo_title":"Soins à la maison","jumbo_subtitle":"Faites-le vous-mêmes","jumbo_desc1":"/ coaching disponible","jumbo_desc2":"/ produits professionnels","waxingkitcta":"Choisissez votre ensemble"},"clinic-main":{"jumbo-title":"Beauté Intégrale","jumbo-message1":"/ résultats basés sur l’expertise.","jumbo-message2":"/ service avec passion.","jumbo-message3":"/ plus de 35 ans d’expérience.","jumbo-button":"Voir les services","aesthetic-services":"Services esthétiques","weight-loss":"Perte de poids","online-services":"Services en ligne","s_consult-title1":"En ligne ou en personne","s_consult-title":"Consultation des soins de la peau","s_consult_desc":"Personnalisée, adaptée uniquement à vos besoins","the-team":"L’équipe"},"social":{"jumbo-title":"Social","jumbo-message":"Revoir nos plus récentes publications sur les médias sociaux"},"faqs":{"jumbo-title":"FAQ","jumbo-message":"Revoir nos questions les plus fréquemment posées"},"p-services":{"jumbo-title":"Services","jumbo-message1":"/Résultats et expertise."},"services":{"dontsee":"Vous recherchez un autre service?","help":"Nous le trouverons pour vous","helpbtn":"Laissez-nous vous aider"},"touchlessfacial":{"title":"Facial sans-contact","description":"Notre nouvelle réponse pour préserver votre sécurité"},"requestappt":{"jumbo_title":"Demande de rendez-vous","jumbo_desc":"/ nous sommes là pour aider","q1":"Quel service vous intéresse?","q2":"Quel est le meilleur moment?","q3":"Choisissez une date et une heure","q4":"Information de contact","submitted":"Merci, nous vous contactons dès que possible! ","bookonline":"Prenez rendez-vous en ligne","bookonline_desc":"Aller directement à notre page de réservation en ligne","inquire":"Faire une demande","inquire_desc":"Demandez plus d'informations","booknow":"Réserver maintenant","form":"Formulaire de contact"},"onlineassessment":{"title":"Bienvenue à notre questionnaire d’évaluation de la peau","description":"Le guide professionnel des soins esthétiques pour réviser votre routine actuelle","step1":"Remplissez le questionnaire","step2":"Révisez votre routine","step3":"Magasinez ou consultez-nous","starteval":"Commencer l'évaluation","terms":"Accepter les Termes & Conditions","emails":"Recevoir les courriels après le questionnaire","q1":"Comment vous nommez-vous?","q2":"Quels types de produits utilisez-vous actuellement? (choisir tout ceux qui s’appliquent)","q3":"Quelles sont vos préoccupations à l’égard de votre peau? (choisir toutes celles qui s’appliquent)","q4":"Quels symptômes ressentez-vous? (choisir tout ceux qui s’appliquent)","q5":"Avez-vous une routine régulière?","q6":"Êtes-vous satisfait(e) de votre routine actuelle?","q7":"Est-ce que votre routine actuelle contient plusieurs marques de produits différentes?","q8":"Qu’est-ce qui décrit le mieux vos habitudes d’achats de produits?","q9":"Portez-vous attention aux ingrédients ACTIFS de vos produits?","q10":"Portez-vous attention à l’ordre d’application de vos produits?","q11":"Comment choisissez-vous vos produits?","age":"Quel âge avez-vous?","email":"Quelle est votre adresse de courriel?","enteremail":"Entrez votre courriel","result_message":"Cliquez pour recevoir une évaluation de votre routine!","eval_transition":"Nous sommes en train de recevoir vos données..."},"onlineconsultation":{"jumbo_title":"Consultation Virtuelle","jumbo_desc1":"/ le confort de votre foyer","jumbo_desc2":"/ esthéticiennes certifiées","step1":"1 / demandez un rendez-vous","step1_desc":"Sélectionnez une plage horaire et remplissez le questionnaire d’évaluation","step2":"2 / rencontrez une spécialiste en vidéo-conférence","step2_desc":"Installez-vous devant votre ordinateur, tablette ou téléphone pour une consultation privée.","step3":"3 / recevez nos recommandations","step3_desc":"Votre spécialiste vous offira toutes ses recommandations ","cta":"Joignez-nous et tentez l’expérience"},"onlineassessmentresults":{"jumbo_desc":"/recevez de l'aide de l'une de nos esthéticiennes.","thankyou":"Merci","suggestions":"Entre temps, notre algorythme indique","whilewait":"Pendant que vous patientez","shop":"Magasiner","shopskintype":"Magasiner par type de peau","shop_desc":"Si vous ne voulez pas attendre, profitez de ce moment pour magasiner nos gammes de produits professionnels pour votre type de peau.","shopbutton":"Magasiner votre type de peau","results":"Résultats","consultation":"Consultation","consultationschedule":"Réservez votre consultation virtuelle","consultation_desc":"Recevez vos recommandations personnalisées par une esthéticienne certifiée pour votre peau et style de vie."},"weightloss":{"jumbo-title":"Perte de poids","jumbo-desc1":"/ plus de 16 années de résultats","q1":"Êtes-vous présentement un client de Beauté Intégrale?","no":"Non, j’aimerais en savoir plus","history":"Historique de la perte de poids","history_desc":" Depuis plus de 16 ans, Beauté Intégrale travaille avec le protocole appelé Ideal Protein. Cette méthode est simple à suivre mais demande une rigueur et support. Les clients qui sont sérieux par rapport à cette approche voient des résultats extraordinaires avec cette méthode. ","r1":"Plus de 1000 clients aidés","r2":"Une des premières coaches certifiée au Canada","r3":"Ancienne formatrice des professionels de la santé en Amérique du Nord pour Ideal Protein","r4":"Plus de 16 années de coaching","topreasons":"Témoignages de clients Beauté Intégrale","rw1":"Je peux enfin porter les vêtements qui me plaisent","rw2":"J’ai joué au hockey avec mon garçon pour la première fois en 8 ans","rw3":"J’ai combattu l’asthme chronique","rw4":"J’ai aidé ma famille à changer leurs habitudes alimentaires","rw5":"Ce n’est plus une diète pour moi, c’est mon mode de vie","howitworks":"Comment ça fonctionne?","h1":"Protocole cétogène modifié","h2":"3 Phases (Perte de poids, Stabilisation, Maintien)","h3":"Aliments réels combinés avec les produits Ideal Protein","h4":"Aide à prévenir la perte de la masse musculaire","h5":"Coaching et outils à la disposition des clients","help":"Laissez-nous vous aider à atteindre vos résultats","ctabutton":"En savoir plus","orderproducts":"Commander des produits","orderproducts_desc":"Pré-commandez vos produits pour les semaines à venir en utilisant notre formulaire de contact ou téléphonez-nous!","ordercta":"Pré-commander les produits et/ou suppléments"},"shareroutine":{"jumbo_title":"Partager votre routine","jumbo_desc1":"/ Rechercher une routine parmis les routines partagées","jumbo_desc2":"/ Partager votre routine","sharecta":"Partager votre routine ici"},"links":{"home":"Accueil","onlineconsultation":"Consultation virtuelle","skincareassessment":"Évaluation de la peau","athome":"Réservations en ligne","retailclinic":"Clinique de soins","onlinestore":"Boutique en ligne","socialmedia":"Médias sociaux","tutorials":"Blog","faqs":"FAQ","giftcards":"Cartes-cadeaux"}}

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(181);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69ba2076_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(690);
function injectStyle (ssrContext) {
  __webpack_require__(668)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69ba2076"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69ba2076_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/onlineconsult.394ff7c.jpeg";

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/onlinestore3.890bfb2.jpeg";

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/formulary.75b0c16.png";

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/onlinestore1.6cc55ae.jpeg";

/***/ }),
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainentrance"},[_c('div',{staticClass:"container-fluid h-100"},[_c('b-row',{staticClass:"tb"},[_c('b-col',{staticClass:"m-borders online-consultation",attrs:{"cols":"12","md":"4"}},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-sm-12 align-self-center py-3"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.online_consultation.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",attrs:{"squared":"","variant":"light","size":"md","to":"onlineconsultation/"}},[_vm._v(_vm._s(_vm.$t("main-screen.online_consultation.button_text"))+"\n              ")])],1)])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('div',{staticClass:"row h-50 background-onlinestore m-borders"},[_c('b-col',{staticClass:"col-sm-12 align-self-center py-3"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.online.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",attrs:{"squared":"","variant":"light","size":"md","href":"https://moncoachbeaute.ca","target":"_blank"}},[_vm._v(_vm._s(_vm.$t("main-screen.online.button_text")))])],1)])],1),_vm._v(" "),_c('div',{staticClass:"row h-50 background-athome m-borders"},[_c('div',{staticClass:"col-sm-12 align-self-center py-3"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.at-home.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",attrs:{"squared":"","variant":"light","size":"md","to":"at-home/"}},[_vm._v(_vm._s(_vm.$t("main-screen.at-home.button_text")))])],1)])])]),_vm._v(" "),_c('b-col',{staticClass:"m-borders retail-clinic",attrs:{"cols":"12","md":"4"}},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-sm-12 align-self-center py-3"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.retail.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",attrs:{"squared":"","variant":"light","size":"md","to":"clinic/"}},[_vm._v(_vm._s(_vm.$t("main-screen.retail.button_text")))])],1)])])])],1),_vm._v(" "),_c('b-row',{staticClass:"tb2"},[_c('b-col',{staticClass:"background-assessment m-borders",attrs:{"cols":"12","md":"4"}},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-sm-12 align-self-center py-3"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.skincare_assessment.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",attrs:{"squared":"","variant":"light","size":"md","to":"/online/assessment/routine"}},[_vm._v(_vm._s(_vm.$t("main-screen.skincare_assessment.button_text")))])],1)])])]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"row h-100 m-borders background-searchproducts",staticStyle:{"background-color":"black"}},[_c('div',{staticClass:"col-sm-12 align-self-center py-3"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.search_products.title")))]),_vm._v(" "),_c('b-form-input',{staticStyle:{"height":"35px"},attrs:{"type":"search","name":"search","placeholder":"Recherche de produits..."},model:{value:(_vm.searchProductName),callback:function ($$v) {_vm.searchProductName=$$v},expression:"searchProductName"}}),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow mt-2",attrs:{"squared":"","variant":"light","size":"md"},on:{"click":function($event){$event.preventDefault();return _vm.searchProducts()}}},[_vm._v(_vm._s(_vm.$t("main-screen.blog.button_text")))])],1)])])]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"row h-100 background-social m-borders"},[_c('div',{staticClass:"col-sm-12 align-self-center py-3"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.social.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button",attrs:{"squared":"","variant":"transparent","size":"md"},on:{"click":_vm.social}},[_c('i',{staticClass:"fa fa-facebook-official fa-2x mx-1",staticStyle:{"color":"white"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-instagram fa-2x mx-1",staticStyle:{"color":"white"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-twitter fa-2x mx-1",staticStyle:{"color":"white"}})])],1)])])]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"row h-100 background-tutorials m-borders"},[_c('div',{staticClass:"col-sm-12 align-self-center py-3"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.blog.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",attrs:{"squared":"","variant":"light","size":"md","to":"/blog/"}},[_vm._v(_vm._s(_vm.$t("main-screen.blog.button_text")))])],1)])])]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"row h-100 m-borders",staticStyle:{"background-color":"#808080"}},[_c('div',{staticClass:"col-sm-12 align-self-center py-3"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.faqs.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",attrs:{"squared":"","variant":"light","size":"md","to":"/faqs/"}},[_vm._v(_vm._s(_vm.$t("main-screen.faqs.button_text")))])],1)])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicMain_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d05263f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicMain_vue__ = __webpack_require__(694);
function injectStyle (ssrContext) {
  __webpack_require__(692)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d05263f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d05263f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.jpg": 194,
	"./2.jpg": 195,
	"./3.jpg": 196,
	"./Alexanne.jpg": 197,
	"./Brenda.jpg": 198,
	"./Claudia.jpg": 199,
	"./Emilie.jpg": 200,
	"./Joanie.jpg": 201,
	"./Laura.jpg": 202,
	"./Roxanne.jpg": 203,
	"./car.jpg": 204,
	"./cm.jpg": 205,
	"./cyndia.jpg": 206,
	"./eve.jpg": 207,
	"./maynika.jpg": 208,
	"./meg2.jpg": 209,
	"./myrianne.jpg": 210,
	"./nancy.jpg": 211,
	"./rc.jpg": 212,
	"./sarah.jpg": 213
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 693;

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clinicmain"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mycontainer-main"},[_c('b-col',{staticClass:"pl-5 leftcontent",attrs:{"cols":"12","md":"4"}},[_c('h6',{staticClass:"my-0",staticStyle:{"color":"grey"}},[_vm._v("Ville de Quebec")]),_vm._v(" "),_c('h2',[_vm._v("Beauté Intégrale")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h1',{staticClass:"pageSubtitle"},[_vm._v(_vm._s(_vm.$t("clinic-main.jumbo-message1")))]),_vm._v(" "),_c('h1',{staticClass:"pageSubtitle"},[_vm._v(_vm._s(_vm.$t("clinic-main.jumbo-message2")))]),_vm._v(" "),_c('h1',{staticClass:"pageSubtitle"},[_vm._v(_vm._s(_vm.$t("clinic-main.jumbo-message3")))]),_vm._v(" "),_c('b-button',{staticClass:"mt-3 shadow",attrs:{"squared":"","variant":"outline-dark"},on:{"click":_vm.goBack}},[_vm._v("\n          "+_vm._s(_vm.$t("common.goback")))]),_vm._v(" "),_c('appt-button',{attrs:{"color":'d'}})],1),_vm._v(" "),_c('b-col',{staticClass:"align-self-center py-3",attrs:{"cols":"12","md":"6","id":"clinicservices"}},[_c('div',{staticClass:"my-grid"},[_c('b-card',{staticClass:"shadow",attrs:{"img-top":"","img-src":"https://media.beauteintegrale.ca/beaute-integrale-web/images/bi_facial_2024_1.jpg"}},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v("\n              "+_vm._s(_vm.$t("clinic-main.aesthetic-services"))+"\n            ")]),_vm._v(" "),_c('b-button',{staticClass:"mt-2 shadow",staticStyle:{"background-color":"black"},attrs:{"squared":"","to":"/clinic/services"}},[_vm._v(_vm._s(_vm.$t("common.view-services")))])],1),_vm._v(" "),_c('b-card',{staticClass:"shadow",attrs:{"img-top":"","img-src":_vm.getImg('7O9A1099')}},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t("clinic-main.online-services"))+"\n            ")]),_vm._v(" "),_c('b-button',{staticClass:"mt-2 shadow",staticStyle:{"background-color":"black"},attrs:{"squared":"","to":"/onlineconsultation"}},[_vm._v(_vm._s(_vm.$t("common.learn-more")))])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"shadow mt-3",staticStyle:{"background-color":"black"},attrs:{"sub-title":_vm.$t('clinic-main.s_consult-title1')}},[_c('b-card-title',{staticStyle:{"font-weight":"bold","color":"white"}},[_vm._v(_vm._s(_vm.$t("clinic-main.s_consult-title"))+"\n          ")]),_vm._v(" "),_c('b-card-text',{staticStyle:{"color":"white"}},[_vm._v("\n            "+_vm._s(_vm.$t("clinic-main.s_consult_desc"))+"\n          ")]),_vm._v(" "),_c('b-button',{staticClass:"mt-2",attrs:{"squared":"","variant":"outline-light","to":"/appointment"}},[_vm._v(_vm._s(_vm.$t("common.request-consultation")))])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"align-self-center",attrs:{"cols":"12","md":"2"}},[_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"12"}},[_c('h3',[_vm._v(_vm._s(_vm.$t("common.the-team")))])]),_vm._v(" "),_vm._l((_vm.staff),function(i,index){return _c('b-col',{key:index,staticClass:"m-borders",staticStyle:{"text-align":"center"},attrs:{"cols":"6","align-self":"center"}},[_c('b-img',{attrs:{"src":_vm.getStaffImg(i.img),"fluid":"","center":""}})],1)})],2)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicServiceList_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18cc80ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicServiceList_vue__ = __webpack_require__(700);
function injectStyle (ssrContext) {
  __webpack_require__(696)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18cc80ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicServiceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18cc80ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicServiceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/background2.b2fd95f.png";

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./s_facial.jpg": 98,
	"./s_hairremoval.jpg": 99,
	"./s_hydrafacial.jpg": 100,
	"./s_microderm.jpg": 101,
	"./s_microneedling.jpg": 102,
	"./s_peeling.jpg": 103,
	"./s_photofacial.jpg": 104
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 698;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./klapp.jpg": 222,
	"./ldr.jpg": 223,
	"./matis.jpg": 224,
	"./ocean.jpg": 225,
	"./vie.jpg": 226
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 699;

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clinicservicelist"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mycontainer-main"},[_c('b-col',{staticClass:"pl-5 leftcontent main-background",attrs:{"cols":"12","lg":"4"}},[_c('h1',[_vm._v(" "+_vm._s(_vm.$t('p-services.jumbo-title'))+" ")]),_vm._v(" "),_c('h1',{staticClass:"pageSubtitle"},[_vm._v(" "+_vm._s(_vm.$t('p-services.jumbo-message1'))+" ")]),_vm._v(" "),_c('b-button',{staticClass:"mt-3 shadow",attrs:{"squared":"","variant":"outline-dark"},on:{"click":_vm.goBack}},[_vm._v(" "+_vm._s(_vm.$t('common.goback')))])],1),_vm._v(" "),_c('b-col',{staticClass:"py-3",attrs:{"cols":"12","lg":"7"}},[_c('div',{staticClass:"my-grid"},[_vm._l((_vm.serviceList),function(s,index){return _c('b-card',{key:index,staticClass:"shadow",attrs:{"img-top":"","img-src":_vm.getImg(s.img)}},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(s.name)+" "),(s.new)?_c('b-badge',{staticStyle:{"font-size":"11px","vertical-align":"top"},attrs:{"variant":"warning"}},[_vm._v(_vm._s(s.new))]):_vm._e()],1),_vm._v(" "),_c('b-card-text',{staticClass:"d-flex flex-column"},[_vm._v(" "+_vm._s(s.desc)+" ")]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow clobutton",staticStyle:{"background-color":"black"},attrs:{"squared":""},on:{"click":function($event){return _vm.serviceDetail(s.name)}}},[_vm._v(" "+_vm._s(_vm.$t('common.view'))+" "+_vm._s(s.name)+" ")])],1)}),_vm._v(" "),_c('b-card',{staticClass:"shadow"},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.$t('services.dontsee'))+" ")]),_vm._v(" "),_c('b-card-text',[_vm._v(" "+_vm._s(_vm.$t('services.help'))+" ")]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",staticStyle:{"background-color":"black"},attrs:{"squared":"","to":"/appointment"}},[_vm._v("\n              "+_vm._s(_vm.$t('services.helpbtn')))])],1)],2)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicServiceDetail_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b96c272_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicServiceDetail_vue__ = __webpack_require__(704);
function injectStyle (ssrContext) {
  __webpack_require__(702)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b96c272"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicServiceDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b96c272_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicServiceDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./s_facial.jpg": 98,
	"./s_hairremoval.jpg": 99,
	"./s_hydrafacial.jpg": 100,
	"./s_microderm.jpg": 101,
	"./s_microneedling.jpg": 102,
	"./s_peeling.jpg": 103,
	"./s_photofacial.jpg": 104
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 703;

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clinicservicedetail"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mycontainer-main"},[_c('b-col',{staticClass:"pl-5 leftcontent",style:({
        backgroundImage:
          'linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.3)), url(' +
          this.img +
          ')',
      }),attrs:{"cols":"12","md":"4"}},[_c('h1',[_vm._v(_vm._s(_vm.service))]),_vm._v(" "),_c('b-button',{staticClass:"mt-3",attrs:{"squared":"","variant":"outline-light"},on:{"click":_vm.goBack}},[_vm._v("\n          "+_vm._s(_vm.$t("common.goback"))+"\n        ")]),_vm._v(" "),_c('appt-button',{attrs:{"color":'l'}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('b-card',{staticClass:"shadow"},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v("\n            "+_vm._s(_vm.$t("common.description")))]),_vm._v(" "),_c('b-card-text',[_vm._v(" "+_vm._s(_vm.serviceDisplay.desc)+" ")])],1),_vm._v(" "),_c('b-card',{staticClass:"shadow"},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t("common.types")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-list-group',{attrs:{"flush":""}},_vm._l((_vm.serviceDisplay.types),function(e,index){return _c('b-list-group-item',{key:index},[_vm._v("\n              "+_vm._s(e))])}),1)],1),_vm._v(" "),(_vm.serviceDisplay.showtouchless === true)?_c('b-card',{staticClass:"align-self-end shadow",staticStyle:{"background-color":"black","color":"white"},attrs:{"text-variant":"white"}},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t("touchlessfacial.title"))+"\n          ")]),_vm._v(" "),_c('b-card-text',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t("touchlessfacial.description"))+"\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{attrs:{"squared":"","variant":"outline-light","href":"/clinic/services/"}},[_vm._v("\n            "+_vm._s(_vm.$t("common.learn-more"))+"\n          ")])],1):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('b-card',{staticClass:"shadow"},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t("common.howtoprepare")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('prep'),expression:"'prep'"}],staticClass:"main-button",staticStyle:{"background-color":"black"},attrs:{"squared":""}},[_vm._v("\n            "+_vm._s(_vm.$t("common.details"))+"\n          ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-3",attrs:{"id":"prep"}},[_c('ul',_vm._l((_vm.serviceDisplay.prepare),function(e,index){return _c('li',{key:index},[_vm._v("\n                "+_vm._s(e)+"\n              ")])}),0)])],1),_vm._v(" "),_c('b-card',{staticClass:"shadow"},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t("common.cost")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('cost'),expression:"'cost'"}],staticClass:"main-button",staticStyle:{"background-color":"black"},attrs:{"squared":""}},[_vm._v("\n            "+_vm._s(_vm.$t("common.details"))+"\n          ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-3",attrs:{"id":"cost"}},[_c('p',[_vm._v(_vm._s(_vm.serviceDisplay["cost"]))])])],1),_vm._v(" "),_c('b-card',{staticClass:"shadow"},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t("common.extras")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('extra'),expression:"'extra'"}],staticClass:"main-button",staticStyle:{"background-color":"black"},attrs:{"squared":""}},[_vm._v("\n            "+_vm._s(_vm.$t("common.details"))+"\n          ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-3",attrs:{"id":"extra"}},[_c('ul',_vm._l((_vm.serviceDisplay.extras),function(e,index){return _c('li',{key:index},[_vm._v("\n                "+_vm._s(e)+"\n              ")])}),0)])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Social_vue__ = __webpack_require__(228);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ca63886_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Social_vue__ = __webpack_require__(724);
function injectStyle (ssrContext) {
  __webpack_require__(706)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ca63886"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Social_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ca63886_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Social_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social"},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"mycontainer-main m-borders",attrs:{"cols":"12","md":"4"}},[_c('div',{staticClass:"row h-100 pl-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-left"},[_c('div',[_c('h1',{staticClass:"fade-in"},[_vm._v(_vm._s(_vm.$t('social.jumbo-title')))]),_vm._v(" "),_c('p',{staticClass:"fade-in"},[_vm._v(_vm._s(_vm.$t('social.jumbo-message')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('p',[_c('i',{staticClass:"fa fa-facebook-official fa-2x mx-1"},[_c('a',{attrs:{"href":"https://www.facebook.com/beauteintegrale"}},[_vm._v(" /beauteintegrale")])])])]),_vm._v(" "),_c('div',[_c('p',[_c('i',{staticClass:"fa fa-instagram fa-2x mx-1"},[_c('a',{attrs:{"href":"https://www.instagram.com/beauteintegrale/"}},[_vm._v(" #beauteintegrale")])])])])])])])]),_vm._v(" "),_c('b-col',[(_vm.loading)?_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-sm-12 align-self-center"},[_c('h3',[_vm._v("We love our community")])])]):_c('div',{staticClass:"row"},_vm._l((_vm.socialData),function(s){return _c('div',{key:s.id},[_c('a',{attrs:{"href":'https://www.instagram.com/p/' + s.name + '/'}},[_c('img',{attrs:{"src":s.pic,"height":"250x"}})])])}),0)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faqs_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14baf0ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faqs_vue__ = __webpack_require__(727);
function injectStyle (ssrContext) {
  __webpack_require__(726)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14baf0ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faqs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14baf0ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faqs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faqs"},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"mycontainer-main m-borders",attrs:{"cols":"12","md":"4"}},[_c('div',{staticClass:"row h-100 ml-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-left"},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('faqs.jumbo-title')))]),_vm._v(" "),_c('h1',{staticClass:"pageSubtitle"},[_vm._v("/ "+_vm._s(_vm.$t('faqs.jumbo-message')))]),_vm._v(" "),_c('b-button',{staticClass:"mt-3 shadow",attrs:{"squared":"","variant":"outline-dark"},on:{"click":_vm.goBack}},[_vm._v(" "+_vm._s(_vm.$t('common.goback')))])],1)])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","md":"8"}},[_c('b-row',{staticClass:"h-100 py-5"},_vm._l((_vm.faqs),function(f){return _c('b-col',{key:f.id,staticClass:"col-sm-8 py-1",attrs:{"cols":"12"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(f.name),expression:"f.name"}],staticClass:"text-left",staticStyle:{"min-width":"100%"},attrs:{"squared":"","variant":"outline-dark"}},[_vm._v("\n                        "+_vm._s(f.name)+" \n                        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":f.name}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 py-2"},[_c('p',[_vm._v(_vm._s(f.answer))])])])])],1)}),1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__ = __webpack_require__(234);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23ef6b80_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__ = __webpack_require__(738);
function injectStyle (ssrContext) {
  __webpack_require__(729)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23ef6b80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23ef6b80_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-home"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mycontainer-main"},[_c('b-col',{staticClass:"pl-5 leftcontent",attrs:{"cols":"12","md":"4"}},[_c('h1',[_vm._v(_vm._s(_vm.$t('blog.title')))]),_vm._v(" "),_c('h1',{staticClass:"pageSubtitle"},[_vm._v(" / "+_vm._s(_vm.$t('blog.desc'))+" ")]),_vm._v(" "),_c('b-button',{staticClass:"mt-3 shadow",attrs:{"squared":"","variant":"outline-dark"},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm.$t('common.goback'))+" ")])],1),_vm._v(" "),_c('b-col',{staticClass:"py-3",attrs:{"cols":"12","md":"7"}},[_c('b-card-group',{attrs:{"deck":""}},_vm._l((_vm.postListing),function(post,index){return _c('b-card',{key:post.slug + '_' + index,staticClass:"shadow",attrs:{"img-top":"","img-src":post.featured_image}},[_c('b-card-title',{staticStyle:{"font-weight":"bold","color":"black","font-size":"1.3em"}},[_vm._v(" "+_vm._s(post.title)+" ")]),_vm._v(" "),_c('b-card-text',[_vm._v(" "+_vm._s(post.summary)+" ")]),_vm._v(" "),_c('router-link',{attrs:{"to":'/blog/' + post.slug}},[_c('b-button',{staticClass:"align-self-end main-button shadow mt-2",attrs:{"squared":"","variant":"dark","size":"md"}},[_vm._v(_vm._s(_vm.$t('common.view')))])],1)],1)}),1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__ = __webpack_require__(237);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a28f13d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__ = __webpack_require__(741);
function injectStyle (ssrContext) {
  __webpack_require__(740)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a28f13d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a28f13d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-home"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mycontainer-main"},[_c('b-col',{staticClass:"pl-5 leftcontent",attrs:{"cols":"12","md":"4"}},[(_vm.post.data.featured_image)?_c('img',{staticStyle:{"width":"50%"},attrs:{"src":_vm.post.data.featured_image,"alt":""}}):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"mt-2",staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.post.data.title))]),_vm._v(" "),_c('h5',[_vm._v(" "+_vm._s(_vm.post.data.author.first_name)+"  "+_vm._s(_vm.post.data.author.last_name))]),_vm._v(" "),_c('b-button',{staticClass:"mt-3 shadow",attrs:{"squared":"","variant":"outline-dark"},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm.$t('common.goback'))+" ")])],1),_vm._v(" "),_c('b-col',{staticClass:"blog-info py-3",attrs:{"cols":"12","md":"7"}},[_c('b-card',{attrs:{"border-variant":"white"}},[_c('div',{staticClass:"mt-3",attrs:{"id":"blogdata"},domProps:{"innerHTML":_vm._s(_vm.post.data.body)}}),_vm._v(" "),_c('div',[_c('hr'),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Beauté Intégrale")])]),_c('p'),_c('p',[_vm._v("Clinique de soins professionnels de beauté, située dans la ville de Québec et spécialisée dans la consultation en ligne en télé-esthétique.")])]),_vm._v(" "),_c('b-row',{staticClass:"text-center mt-5",attrs:{"align-h":"around"}},[_c('b-col',[(_vm.post.meta.previous_post)?_c('router-link',{staticClass:"button",attrs:{"to":/blog/ + _vm.post.meta.previous_post.slug}},[_c('b-button',{staticClass:"align-self-end main-button shadow mt-2",attrs:{"squared":"","variant":"dark","size":"md"}},[_c('b-icon',{attrs:{"icon":"arrow-left","variant":"white","aria-hidden":"true"}}),_vm._v("\n                        "+_vm._s(_vm.post.meta.previous_post.title))],1)],1):_vm._e()],1),_vm._v(" "),_c('b-col',[(_vm.post.meta.next_post)?_c('router-link',{staticClass:"button",attrs:{"to":/blog/ + _vm.post.meta.next_post.slug}},[_c('b-button',{staticClass:"align-self-end main-button shadow mt-2",attrs:{"squared":"","variant":"dark","size":"md"}},[_vm._v("\n                        "+_vm._s(_vm.post.meta.next_post.title)+"\n                        "),_c('b-icon',{attrs:{"icon":"arrow-right","variant":"white","aria-hidden":"true"}})],1)],1):_vm._e()],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AtHome_vue__ = __webpack_require__(238);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e49409_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AtHome_vue__ = __webpack_require__(747);
function injectStyle (ssrContext) {
  __webpack_require__(743)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20e49409"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AtHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e49409_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AtHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_atHomeCard_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee0e4ee2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_atHomeCard_vue__ = __webpack_require__(746);
function injectStyle (ssrContext) {
  __webpack_require__(745)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ee0e4ee2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_atHomeCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee0e4ee2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_atHomeCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"h-100",attrs:{"img-src":_vm.img},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('b-button',{staticClass:"main-button",staticStyle:{"background-color":"black"},attrs:{"squared":"","href":_vm.link,"target":"_blank"}},[_vm._v("\n      "+_vm._s(_vm.link_text))])]},proxy:true}])},[_c('b-card-title',{staticClass:"mt-lg-3",staticStyle:{"font-weight":"bold","height":"60px"}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"mt-auto"},[_c('b-card-text',[_vm._v(" "+_vm._s(_vm.body)+" ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"athome"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"h-100"},[_c('b-col',{staticClass:"pl-5 leftcontent",attrs:{"cols":"12","md":"4"}},[_c('h6',{staticClass:"my-0",staticStyle:{"color":"grey"}},[_vm._v("\n            "+_vm._s(_vm.$t("athome.jumbo_subtitle"))+"\n          ")]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.$t("athome.jumbo_title")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h1',{staticClass:"pageSubtitle"},[_vm._v(_vm._s(_vm.$t("athome.jumbo_desc1")))]),_vm._v(" "),_c('h1',{staticClass:"pageSubtitle"},[_vm._v(_vm._s(_vm.$t("athome.jumbo_desc2")))]),_vm._v(" "),_c('b-button',{staticClass:"mt-3 shadow",attrs:{"squared":"","variant":"outline-dark"},on:{"click":_vm.goBack}},[_vm._v("\n            "+_vm._s(_vm.$t("common.goback")))])],1),_vm._v(" "),_c('b-col',{staticClass:"mycontainer-main m-borders",attrs:{"cols":"12","md":"8"}},[_c('div',{staticClass:"row my-3"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"col-sm-4 mt-2 mt-sm-0"},[_c('AtHomeCard',{attrs:{"img":__webpack_require__(240)("./" + (item.img)),"title":item.name,"body":item.desc,"link":item.cta_link,"link_text":item.cta}})],1)}),0)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/athome_facial2.a86c353.jpeg";

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/athome_waxing.4685332.png";

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/background1.e27e9f9.png";

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/carpic_1.9340b04.png";

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/carpic_2.63a3abd.png";

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/idealprotein.14d5f73.png";

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/o_consultation2.a7eedc3.png";

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rc.9e63b6b.jpeg";

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rp.417a20a.jpeg";

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestAppt_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4726e1c5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestAppt_vue__ = __webpack_require__(759);
function injectStyle (ssrContext) {
  __webpack_require__(758)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4726e1c5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestAppt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4726e1c5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestAppt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"requestappt"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mycontainer-main"},[_c('b-col',{staticClass:"pl-5 leftcontent",attrs:{"cols":"12","md":"4"}},[_c('h6',{staticClass:"my-0",staticStyle:{"color":"grey"}},[_vm._v(_vm._s(_vm.$t("common.form")))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.$t("requestappt.jumbo_title")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h1',{staticStyle:{"font-weight":"900","font-size":"1.9em"}},[_vm._v("\n          "+_vm._s(_vm.$t("requestappt.jumbo_desc"))+"\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"mt-3",attrs:{"squared":"","variant":"outline-dark"},on:{"click":_vm.goBack}},[_vm._v("\n          "+_vm._s(_vm.$t("common.goback"))+"\n        ")])],1),_vm._v(" "),(!_vm.submitComplete)?_c('b-col',{staticClass:"align-self-center py-3",attrs:{"cols":"12","md":"6","id":"apptform"}},[_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{staticClass:"shadow",attrs:{"img-top":"","img-src":__webpack_require__(94)}},[_c('b-card-title',[_vm._v(_vm._s(_vm.$t("requestappt.bookonline")))]),_vm._v(" "),_c('b-card-text',[_vm._v(_vm._s(_vm.$t("requestappt.bookonline_desc")))]),_vm._v(" "),_c('b-button',{staticClass:"mt-2 shadow",staticStyle:{"background-color":"black"},attrs:{"squared":""},on:{"click":_vm.GoToBookingSite}},[_vm._v(_vm._s(_vm.$t("requestappt.booknow")))])],1),_vm._v(" "),(!_vm.inquire)?_c('b-card',{staticClass:"shadow",attrs:{"img-top":"","img-src":__webpack_require__(96)}},[_c('b-card-title',[_vm._v(_vm._s(_vm.$t("requestappt.inquire")))]),_vm._v(" "),_c('b-card-text',[_vm._v(_vm._s(_vm.$t("requestappt.inquire_desc")))]),_vm._v(" "),_c('b-button',{staticClass:"mt-2 shadow",staticStyle:{"background-color":"black"},attrs:{"squared":""},on:{"click":function($event){return _vm.ChoiceInquire()}}},[_vm._v(_vm._s(_vm.$t("requestappt.form")))])],1):_vm._e()],1),_vm._v(" "),(_vm.inquire)?_c('b-card',{staticClass:"shadow mt-2"},[(_vm.show)?_c('b-form',{on:{"submit":_vm.onSubmit,"reset":_vm.onReset}},[_c('h4',[_vm._v(_vm._s(_vm.$t("requestappt.q1")))]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-5"}},[_c('b-form-checkbox-group',{attrs:{"id":"checkboxes-5","size":"lg"},model:{value:(_vm.form.service),callback:function ($$v) {_vm.$set(_vm.form, "service", $$v)},expression:"form.service"}},_vm._l((_vm.display.service),function(s,index){return _c('b-form-checkbox',{key:index,attrs:{"value":s}},[_vm._v("\n                  "+_vm._s(s)+"\n                ")])}),1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"textarea","label":_vm.display.notes + ':',"label-for":"textarea"}},[_c('b-form-textarea',{attrs:{"id":"textarea","placeholder":_vm.display.enterNotes,"rows":"3","max-rows":"6"},model:{value:(_vm.form.notes),callback:function ($$v) {_vm.$set(_vm.form, "notes", $$v)},expression:"form.notes"}})],1),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t("requestappt.q2")))]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-4"}},[_c('label',{attrs:{"for":"datepicker"}},[_vm._v(_vm._s(_vm.$t("requestappt.q3")))]),_vm._v(" "),_c('b-form-datepicker',{staticClass:"mb-2",attrs:{"id":"datepicker","placeholder":_vm.display.enterDate},model:{value:(_vm.form.date),callback:function ($$v) {_vm.$set(_vm.form, "date", $$v)},expression:"form.date"}}),_vm._v(" "),_c('b-form-radio-group',{attrs:{"id":"time","size":"lg"},model:{value:(_vm.form.time),callback:function ($$v) {_vm.$set(_vm.form, "time", $$v)},expression:"form.time"}},_vm._l((_vm.display.times),function(s,index){return _c('b-form-radio',{key:index,attrs:{"value":s}},[_vm._v("\n                  "+_vm._s(s)+"\n                ")])}),1)],1),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t("requestappt.q4"))+":")]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-2","label":_vm.display.name + ':',"label-for":"input-2"}},[_c('b-form-input',{attrs:{"id":"input-2","required":"","placeholder":_vm.display.enterName},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-1","label":_vm.display.email + ':',"label-for":"input-1"}},[_c('b-form-input',{attrs:{"id":"input-1","type":"email","required":"","placeholder":_vm.display.enterEmail},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-3","label":_vm.display.phone + ':',"label-for":"input-3"}},[_c('b-form-input',{attrs:{"id":"input-3","required":"","placeholder":_vm.display.enterPhone},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}})],1),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","squared":"","variant":"dark"}},[_vm._v(_vm._s(_vm.$t("common.submit")))]),_vm._v(" "),_c('b-button',{attrs:{"type":"reset","squared":"","variant":"outline-dark"}},[_vm._v(_vm._s(_vm.$t("common.reset")))])],1):_c('div',[_c('b-card-title',[(_vm.submitting)?_c('b-spinner'):_vm._e()],1)],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"align-self-center py-3",attrs:{"cols":"12","md":"6"}},[(_vm.submitComplete)?_c('b-card-title',[_vm._v(_vm._s(_vm.$t("requestappt.submitted")))]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnlineAssessmentRoutine_vue__ = __webpack_require__(314);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d042ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnlineAssessmentRoutine_vue__ = __webpack_require__(765);
function injectStyle (ssrContext) {
  __webpack_require__(761)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66d042ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnlineAssessmentRoutine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d042ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnlineAssessmentRoutine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_choiceToggle_vue__ = __webpack_require__(315);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5bf9b34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_choiceToggle_vue__ = __webpack_require__(764);
function injectStyle (ssrContext) {
  __webpack_require__(763)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f5bf9b34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_choiceToggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5bf9b34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_choiceToggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3 align-self-center text-center mt-4"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"online-skincare-assessment"},[_c('b-container',{attrs:{"fluid":""}},[(!_vm.validcode)?_c('b-row',[_c('b-col',{staticClass:"mycontainer-main m-borders",attrs:{"cols":"12"}},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',{staticClass:"mid"},[_c('div',{staticClass:"bar pt-5",attrs:{"id":"bar"}}),_vm._v(" "),_c('h2',{},[_vm._v(_vm._s(_vm.$t("onlineassessment.title")))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"1.2em"}},[_vm._v("\n                "+_vm._s(_vm.$t("onlineassessment.description"))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"row h-100 mt-5 main-assessment-img py-2"},[_c('b-col',{staticClass:"align-self-center text-center px-2",attrs:{"cols":"12","md":"4"}},[_c('h1',[_vm._v("1")]),_vm._v(" "),_c('h4',{staticStyle:{"font-weight":"bold","margin-top":"-2vh"}},[_vm._v("\n                    "+_vm._s(_vm.$t("onlineassessment.step1"))+"\n                  ")])]),_vm._v(" "),_c('b-col',{staticClass:"align-self-center text-center",attrs:{"cols":"12","md":"4"}},[_c('h1',[_vm._v("2")]),_vm._v(" "),_c('h4',{staticStyle:{"font-weight":"bold","margin-top":"-2vh"}},[_vm._v("\n                    "+_vm._s(_vm.$t("onlineassessment.step2"))+"\n                  ")])]),_vm._v(" "),_c('b-col',{staticClass:"align-self-center text-center",attrs:{"cols":"12","md":"4"}},[_c('h1',[_vm._v("3")]),_vm._v(" "),_c('h4',{staticStyle:{"font-weight":"bold","margin-top":"-2vh"}},[_vm._v("\n                    "+_vm._s(_vm.$t("onlineassessment.step3"))+"\n                  ")])])],1),_vm._v(" "),_c('b-button',{staticClass:"main-button fade-in my-5",staticStyle:{"background-color":"black","min-width":"250px"},attrs:{"squared":""},on:{"click":_vm.checkCode}},[_vm._v(_vm._s(_vm.$t("onlineassessment.starteval")))])],1)])])])],1):_c('b-row',[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card-style"},[_c('b-progress',{attrs:{"value":_vm.progress,"squared":"","variant":"dark"}})],1),_vm._v(" "),(_vm.current_step == 1)?_c('div',[_c('b-row',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.q1")))])])])]),_vm._v(" "),_c('b-row',{staticClass:"row",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[_c('b-form',[_c('b-form-input',{attrs:{"id":"input-1","required":""},model:{value:(_vm.form.Picked.name),callback:function ($$v) {_vm.$set(_vm.form.Picked, "name", $$v)},expression:"form.Picked.name"}}),_vm._v(" "),_c('b-form-checkbox',{staticClass:"mt-2",attrs:{"switch":"","size":"lg"},model:{value:(_vm.form.Picked.terms),callback:function ($$v) {_vm.$set(_vm.form.Picked, "terms", $$v)},expression:"form.Picked.terms"}},[_vm._v("\n                  "+_vm._s(_vm.$t("onlineassessment.terms"))+"\n                ")]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"mt-2",attrs:{"switch":"","size":"lg"},model:{value:(_vm.form.Picked.emails),callback:function ($$v) {_vm.$set(_vm.form.Picked, "emails", $$v)},expression:"form.Picked.emails"}},[_vm._v("\n                  "+_vm._s(_vm.$t("onlineassessment.emails"))+"\n                ")])],1)],1)]),_vm._v(" "),_c('b-row',{staticClass:"row mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[(_vm.current_step > 1)?_c('b-button',{staticClass:"float-left main-button",attrs:{"squared":"","variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("\n                "+_vm._s(_vm.$t("common.goback")))]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"float-right main-button",staticStyle:{"background-color":"black"},attrs:{"squared":"","disabled":_vm.buttonaction1},on:{"click":function($event){$event.preventDefault();return _vm.onClickNext.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("common.next")))])],1)])],1):_vm._e(),_vm._v(" "),(_vm.current_step == 2)?_c('div',[_c('b-row',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.q2")))])])])]),_vm._v(" "),_c('b-row',{staticClass:"row mx-5",attrs:{"align-h":"center"}},_vm._l((_vm.form.productOptions),function(x){return _c('div',{key:x.id,staticClass:"col-sm-3 align-self-center text-center mt-4",class:{ active: _vm.IsInList(x, _vm.form.Picked.products) }},[_c('label',[_c('img',{attrs:{"src":__webpack_require__(26)("./" + (x.imgURL)),"height":"150px;"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(x.text))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.Picked.products),expression:"form.Picked.products"}],staticStyle:{"display":"none"},attrs:{"type":"checkbox","id":x.id},domProps:{"value":x.value,"checked":Array.isArray(_vm.form.Picked.products)?_vm._i(_vm.form.Picked.products,x.value)>-1:(_vm.form.Picked.products)},on:{"change":function($event){var $$a=_vm.form.Picked.products,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=x.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form.Picked, "products", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form.Picked, "products", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form.Picked, "products", $$c)}}}})])])}),0),_vm._v(" "),_c('b-row',{staticClass:"row mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[(_vm.current_step > 1)?_c('b-button',{staticClass:"float-left main-button",attrs:{"squared":"","variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("\n                "+_vm._s(_vm.$t("common.goback"))+"\n              ")]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"float-right main-button",staticStyle:{"background-color":"black"},attrs:{"squared":"","disabled":_vm.buttonaction2},on:{"click":_vm.onClickNext}},[_vm._v(_vm._s(_vm.$t("common.next")))])],1)])],1):_vm._e(),_vm._v(" "),(_vm.current_step == 3)?_c('div',[_c('b-row',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.q3")))])])])]),_vm._v(" "),_c('b-row',{staticClass:"row mx-5",attrs:{"align-h":"center"}},_vm._l((_vm.form.concernOptions),function(x){return _c('div',{key:x.id,staticClass:"col-sm-3 align-self-center text-center mt-4",class:{ active: _vm.IsInList(x, _vm.form.Picked.concerns) }},[_c('label',[_c('img',{attrs:{"src":__webpack_require__(26)("./" + (x.imgURL)),"height":"150px;"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(x.text))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.Picked.concerns),expression:"form.Picked.concerns"}],staticStyle:{"display":"none"},attrs:{"type":"checkbox","id":x.id},domProps:{"value":x.value,"checked":Array.isArray(_vm.form.Picked.concerns)?_vm._i(_vm.form.Picked.concerns,x.value)>-1:(_vm.form.Picked.concerns)},on:{"change":function($event){var $$a=_vm.form.Picked.concerns,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=x.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form.Picked, "concerns", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form.Picked, "concerns", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form.Picked, "concerns", $$c)}}}})])])}),0),_vm._v(" "),_c('b-row',{staticClass:"row mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[(_vm.current_step > 1)?_c('b-button',{staticClass:"float-left main-button",attrs:{"squared":"","variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("\n                "+_vm._s(_vm.$t("common.goback")))]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"float-right main-button",staticStyle:{"background-color":"black"},attrs:{"squared":"","disabled":_vm.buttonaction3},on:{"click":_vm.onClickNext}},[_vm._v(_vm._s(_vm.$t("common.next")))])],1)])],1):_vm._e(),_vm._v(" "),(_vm.current_step == 4)?_c('div',[_c('b-row',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.q4")))])])])]),_vm._v(" "),_c('b-row',{staticClass:"row mx-5",attrs:{"align-h":"center"}},_vm._l((_vm.form.symptomOptions),function(x){return _c('div',{key:x.id,staticClass:"col-sm-3 align-self-center text-center mt-4",class:{ active: _vm.IsInList(x, _vm.form.Picked.symptoms) }},[_c('label',[_c('img',{attrs:{"src":__webpack_require__(26)("./" + (x.imgURL)),"height":"150px;"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(x.text))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.Picked.symptoms),expression:"form.Picked.symptoms"}],staticStyle:{"display":"none"},attrs:{"type":"checkbox","id":x.id},domProps:{"value":x.value,"checked":Array.isArray(_vm.form.Picked.symptoms)?_vm._i(_vm.form.Picked.symptoms,x.value)>-1:(_vm.form.Picked.symptoms)},on:{"change":function($event){var $$a=_vm.form.Picked.symptoms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=x.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form.Picked, "symptoms", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form.Picked, "symptoms", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form.Picked, "symptoms", $$c)}}}})])])}),0),_vm._v(" "),_c('b-row',{staticClass:"row mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[(_vm.current_step > 1)?_c('b-button',{staticClass:"float-left main-button",attrs:{"squared":"","variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("\n                "+_vm._s(_vm.$t("common.goback")))]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"float-right main-button",staticStyle:{"background-color":"black"},attrs:{"squared":"","disabled":_vm.buttonaction4},on:{"click":_vm.onClickNext}},[_vm._v(_vm._s(_vm.$t("common.next")))])],1)])],1):_vm._e(),_vm._v(" "),(_vm.current_step == 5)?_c('div',[_c('b-row',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.q5")))])])])]),_vm._v(" "),_c('b-row',{staticClass:"row mx-5",attrs:{"align-h":"center"}},_vm._l((_vm.form.regularRoutineOptions),function(x){return _c('div',{key:x.id,staticClass:"col-sm-3 align-self-center text-center mt-4",class:{ active: _vm.form.Picked.regularRoutine == x.value }},[_c('label',[_c('img',{attrs:{"src":__webpack_require__(26)("./" + (x.imgURL)),"height":"150px;"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(x.text))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.Picked.regularRoutine),expression:"form.Picked.regularRoutine"}],staticStyle:{"display":"none"},attrs:{"type":"radio","id":x.id},domProps:{"value":x.value,"checked":_vm._q(_vm.form.Picked.regularRoutine,x.value)},on:{"change":function($event){return _vm.$set(_vm.form.Picked, "regularRoutine", x.value)}}})])])}),0),_vm._v(" "),_c('b-row',{staticClass:"row mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[(_vm.current_step > 1)?_c('b-button',{staticClass:"float-left main-button",attrs:{"squared":"","variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("\n                "+_vm._s(_vm.$t("common.goback")))]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"float-right main-button",staticStyle:{"background-color":"black"},attrs:{"squared":"","disabled":_vm.buttonaction5},on:{"click":_vm.onClickNext}},[_vm._v(_vm._s(_vm.$t("common.next")))])],1)])],1):_vm._e(),_vm._v(" "),(_vm.current_step == 6)?_c('div',[_c('b-row',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.q6")))])])])]),_vm._v(" "),_c('b-row',{staticClass:"row mx-5",attrs:{"align-h":"center"}},_vm._l((_vm.form.satisfiedOptions),function(x){return _c('div',{key:x.id,staticClass:"col-sm-3 align-self-center text-center mt-4",class:{ active: _vm.form.Picked.satisfied == x.value }},[_c('label',[_c('img',{attrs:{"src":__webpack_require__(26)("./" + (x.imgURL)),"height":"150px;"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(x.text))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.Picked.satisfied),expression:"form.Picked.satisfied"}],staticStyle:{"display":"none"},attrs:{"type":"radio","id":x.id},domProps:{"value":x.value,"checked":_vm._q(_vm.form.Picked.satisfied,x.value)},on:{"change":function($event){return _vm.$set(_vm.form.Picked, "satisfied", x.value)}}})])])}),0),_vm._v(" "),_c('b-row',{staticClass:"row mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[(_vm.current_step > 1)?_c('b-button',{staticClass:"float-left main-button",attrs:{"squared":"","variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("\n                "+_vm._s(_vm.$t("common.goback")))]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"float-right main-button",staticStyle:{"background-color":"black"},attrs:{"squared":"","disabled":_vm.buttonaction6},on:{"click":_vm.onClickNext}},[_vm._v(_vm._s(_vm.$t("common.next")))])],1)])],1):_vm._e(),_vm._v(" "),(_vm.current_step == 7)?_c('div',[_c('b-row',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.q7")))])])])]),_vm._v(" "),_c('b-row',{staticClass:"row mx-5",attrs:{"align-h":"center"}},_vm._l((_vm.form.multipleBrandsOptions),function(x){return _c('div',{key:x.id,staticClass:"col-sm-3 align-self-center text-center mt-4",class:{ active: _vm.form.Picked.multipleBrands == x.value }},[_c('label',[_c('img',{attrs:{"src":__webpack_require__(26)("./" + (x.imgURL)),"height":"150px;"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(x.text))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.Picked.multipleBrands),expression:"form.Picked.multipleBrands"}],staticStyle:{"display":"none"},attrs:{"type":"radio","id":x.id},domProps:{"value":x.value,"checked":_vm._q(_vm.form.Picked.multipleBrands,x.value)},on:{"change":function($event){return _vm.$set(_vm.form.Picked, "multipleBrands", x.value)}}})])])}),0),_vm._v(" "),_c('b-row',{staticClass:"row mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[(_vm.current_step > 1)?_c('b-button',{staticClass:"float-left main-button",attrs:{"squared":"","variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("\n                "+_vm._s(_vm.$t("common.goback")))]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"float-right main-button",staticStyle:{"background-color":"black"},attrs:{"squared":"","disabled":_vm.buttonaction7},on:{"click":_vm.onClickNext}},[_vm._v(_vm._s(_vm.$t("common.next")))])],1)])],1):_vm._e(),_vm._v(" "),(_vm.current_step == 8)?_c('div',[_c('b-row',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.q8")))])])])]),_vm._v(" "),_c('b-row',{staticClass:"row mx-5",attrs:{"align-h":"center"}},_vm._l((_vm.form.buyingPatternOptions),function(x){return _c('div',{key:x.id,staticClass:"col-sm-3 align-self-center text-center mt-4",class:{ active: _vm.form.Picked.buyingPattern == x.value }},[_c('label',[_c('img',{attrs:{"src":__webpack_require__(26)("./" + (x.imgURL)),"height":"150px;"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(x.text))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.Picked.buyingPattern),expression:"form.Picked.buyingPattern"}],staticStyle:{"display":"none"},attrs:{"type":"radio","id":x.id},domProps:{"value":x.value,"checked":_vm._q(_vm.form.Picked.buyingPattern,x.value)},on:{"change":function($event){return _vm.$set(_vm.form.Picked, "buyingPattern", x.value)}}})])])}),0),_vm._v(" "),_c('b-row',{staticClass:"row mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[(_vm.current_step > 1)?_c('b-button',{staticClass:"float-left main-button",attrs:{"squared":"","variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("\n                "+_vm._s(_vm.$t("common.goback")))]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"float-right main-button",staticStyle:{"background-color":"black"},attrs:{"squared":"","disabled":_vm.buttonaction8},on:{"click":_vm.onClickNext}},[_vm._v(_vm._s(_vm.$t("common.next")))])],1)])],1):_vm._e(),_vm._v(" "),(_vm.current_step == 9)?_c('div',[_c('b-row',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.q9")))])])])]),_vm._v(" "),_c('b-row',{staticClass:"row mx-5",attrs:{"align-h":"center"}},_vm._l((_vm.form.activeIngrOptions),function(x){return _c('div',{key:x.id,staticClass:"col-sm-3 align-self-center text-center mt-4",class:{ active: _vm.form.Picked.activeIngr == x.value }},[_c('label',[_c('img',{attrs:{"src":__webpack_require__(26)("./" + (x.imgURL)),"height":"150px;"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(x.text))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.Picked.activeIngr),expression:"form.Picked.activeIngr"}],staticStyle:{"display":"none"},attrs:{"type":"radio","id":x.id},domProps:{"value":x.value,"checked":_vm._q(_vm.form.Picked.activeIngr,x.value)},on:{"change":function($event){return _vm.$set(_vm.form.Picked, "activeIngr", x.value)}}})])])}),0),_vm._v(" "),_c('b-row',{staticClass:"row mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[(_vm.current_step > 1)?_c('b-button',{staticClass:"float-left main-button",attrs:{"squared":"","variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("\n                "+_vm._s(_vm.$t("common.goback")))]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"float-right main-button",staticStyle:{"background-color":"black"},attrs:{"squared":"","disabled":_vm.buttonaction9},on:{"click":_vm.onClickNext}},[_vm._v(_vm._s(_vm.$t("common.next")))])],1)])],1):_vm._e(),_vm._v(" "),(_vm.current_step == 10)?_c('div',[_c('b-row',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.q10")))])])])]),_vm._v(" "),_c('b-row',{staticClass:"row mx-5",attrs:{"align-h":"center"}},_vm._l((_vm.form.applyOrderOptions),function(x){return _c('div',{key:x.id,staticClass:"col-sm-3 align-self-center text-center mt-4",class:{ active: _vm.form.Picked.applyOrder == x.value }},[_c('label',[_c('img',{attrs:{"src":__webpack_require__(26)("./" + (x.imgURL)),"height":"150px;"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(x.text))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.Picked.applyOrder),expression:"form.Picked.applyOrder"}],staticStyle:{"display":"none"},attrs:{"type":"radio","id":x.id},domProps:{"value":x.value,"checked":_vm._q(_vm.form.Picked.applyOrder,x.value)},on:{"change":function($event){return _vm.$set(_vm.form.Picked, "applyOrder", x.value)}}})])])}),0),_vm._v(" "),_c('b-row',{staticClass:"row mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[(_vm.current_step > 1)?_c('b-button',{staticClass:"float-left main-button",attrs:{"squared":"","variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("\n                "+_vm._s(_vm.$t("common.goback")))]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"float-right main-button",staticStyle:{"background-color":"black"},attrs:{"squared":""},on:{"click":_vm.onClickNext}},[_vm._v(_vm._s(_vm.$t("common.next")))])],1)])],1):_vm._e(),_vm._v(" "),(_vm.current_step == 11)?_c('div',[_c('b-row',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.q11")))])])])]),_vm._v(" "),_c('b-row',{staticClass:"row mx-5",attrs:{"align-h":"center"}},_vm._l((_vm.form.choosingProductOptions),function(x){return _c('div',{key:x.id,staticClass:"col-sm-3 align-self-center text-center mt-4",class:{ active: _vm.form.Picked.choosingProduct == x.value }},[_c('label',[_c('img',{attrs:{"src":__webpack_require__(26)("./" + (x.imgURL)),"height":"150px;"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(x.text))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.Picked.choosingProduct),expression:"form.Picked.choosingProduct"}],staticStyle:{"display":"none"},attrs:{"type":"radio","id":x.id},domProps:{"value":x.value,"checked":_vm._q(_vm.form.Picked.choosingProduct,x.value)},on:{"change":function($event){return _vm.$set(_vm.form.Picked, "choosingProduct", x.value)}}})])])}),0),_vm._v(" "),_c('b-row',{staticClass:"row mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[(_vm.current_step > 1)?_c('b-button',{staticClass:"float-left main-button",attrs:{"squared":"","variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("\n                "+_vm._s(_vm.$t("common.goback")))]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"float-right main-button",staticStyle:{"background-color":"black"},attrs:{"squared":"","disabled":_vm.buttonaction11},on:{"click":_vm.onClickNext}},[_vm._v(_vm._s(_vm.$t("common.next")))])],1)])],1):_vm._e(),_vm._v(" "),(_vm.current_step == 12)?_c('div',[_c('b-row',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.age")))])])])]),_vm._v(" "),_c('b-row',{staticClass:"row mx-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[_c('b-form-select',{attrs:{"options":_vm.form.ageOptions},model:{value:(_vm.form.Picked.age),callback:function ($$v) {_vm.$set(_vm.form.Picked, "age", $$v)},expression:"form.Picked.age"}})],1)]),_vm._v(" "),_c('b-row',{staticClass:"row mx-5 mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.email")))]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"input-1","type":"email","required":"","placeholder":_vm.$t('onlineassessment.enteremail')},model:{value:(_vm.form.Picked.email),callback:function ($$v) {_vm.$set(_vm.form.Picked, "email", $$v)},expression:"form.Picked.email"}})],1)]),_vm._v(" "),_c('b-row',{staticClass:"row mx-5 mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-8 align-self-center text-center"},[_c('h3',[_vm._v(_vm._s(_vm.$t("onlineassessment.result_message")))])])]),_vm._v(" "),_c('b-row',{staticClass:"row mt-5",attrs:{"align-h":"center"}},[_c('div',{staticClass:"col-sm-4 align-self-center text-center"},[(_vm.current_step > 1)?_c('b-button',{staticClass:"float-left main-button",attrs:{"squared":"","variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("\n                "+_vm._s(_vm.$t("common.goback")))]):_vm._e(),_vm._v(" "),(_vm.current_step == 12)?_c('b-button',{staticClass:"float-right main-button",staticStyle:{"background-color":"#36a8eb"},attrs:{"squared":"","disabled":_vm.buttonaction12},on:{"click":_vm.SubmitQuiz}},[_vm._v(_vm._s(_vm.$t("common.submit")))]):_vm._e()],1)])],1):_vm._e(),_vm._v(" "),(_vm.submitting)?_c('div',[_c('b-row',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("onlineassessment.eval_transition")))])]),_vm._v(" "),_c('div',[_c('b-spinner',{attrs:{"label":"Loading..."}})],1)])])],1):_vm._e()])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnlineAssessmentResults_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77579cee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnlineAssessmentResults_vue__ = __webpack_require__(768);
function injectStyle (ssrContext) {
  __webpack_require__(767)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77579cee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnlineAssessmentResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77579cee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnlineAssessmentResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"onlineassessmentresult"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mycontainer-main"},[_c('b-col',{staticClass:"pl-5 leftcontent",attrs:{"cols":"12","md":"4"}},[_c('h6',{staticClass:"my-0",staticStyle:{"color":"grey"}},[_vm._v("\n          "+_vm._s(_vm.$t("onlineassessmentresults.results"))+"\n        ")]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.answers.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h1',{staticStyle:{"font-weight":"900","font-size":"1.9em"}},[_vm._v("\n          "+_vm._s(_vm.$t("onlineassessmentresults.jumbo_desc"))+"\n        ")]),_vm._v(" "),_c('appt-button',{attrs:{"color":'d'}})],1),_vm._v(" "),_c('b-col',{staticClass:"mycontainer-main",attrs:{"cols":"12","md":"7"}},[_c('b-card',{staticClass:"opp"},[_c('b-card-title',[_vm._v("\n            "+_vm._s(_vm.$t("onlineassessmentresults.thankyou")))]),_vm._v(" "),_c('b-card-text',[_vm._v(_vm._s(_vm.display.main))])],1),_vm._v(" "),_c('b-card',{staticClass:"mt-3"},[_c('b-card-title',[_vm._v("\n            "+_vm._s(_vm.$t("onlineassessmentresults.suggestions")))]),_vm._v(" "),_c('b-card-text',[_c('ul',[(_vm.answers.activeIngr == false)?_c('li',[_vm._v("\n                "+_vm._s(_vm.display.activeIngr)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.answers.multipleBrands == false)?_c('li',[_vm._v("\n                "+_vm._s(_vm.display.multipleBrands)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.answers.applyOrder == false)?_c('li',[_vm._v("\n                "+_vm._s(_vm.display.applyOrder)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.answers.regularRoutine == false)?_c('li',[_vm._v("\n                "+_vm._s(_vm.display.regularRoutine)+"\n              ")]):_vm._e()])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4 mb-2"},[_c('b-col',[_c('h3',[_vm._v(_vm._s(_vm.$t("onlineassessmentresults.whilewait"))+"...")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-card',{attrs:{"img-src":__webpack_require__(311),"overlay":"","text-variant":"white"}},[_c('b-card-title',[_c('strong',[_vm._v(_vm._s(_vm.$t("onlineassessmentresults.shop")))])])],1),_vm._v(" "),_c('b-card',[_c('b-card-title',[_vm._v(_vm._s(_vm.$t("onlineassessmentresults.shopskintype")))]),_vm._v(" "),_c('b-card-text',[_vm._v(_vm._s(_vm.$t("onlineassessmentresults.shop_desc")))]),_vm._v(" "),_vm._l((_vm.answers.concerns),function(l,index){return _c('b-button',{key:index,staticClass:"main-button shadow mt-2",staticStyle:{"background-color":"black"},attrs:{"squared":"","variant":"dark","size":"md","href":'https://www.moncoachbeaute.ca/' + l}},[_vm._v("\n                "+_vm._s(_vm.$t("onlineassessmentresults.shopbutton"))+": "+_vm._s(l)+"\n              ")])})],2)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-card',{attrs:{"img-src":__webpack_require__(310),"overlay":"","text-variant":"white"}},[_c('b-card-title',[_c('strong',[_vm._v(_vm._s(_vm.$t("onlineassessmentresults.consultation")))])])],1),_vm._v(" "),_c('b-card',[_c('b-card-title',[_vm._v(_vm._s(_vm.$t("onlineassessmentresults.consultationschedule")))]),_vm._v(" "),_c('b-card-text',[_vm._v(_vm._s(_vm.$t("onlineassessmentresults.consultation_desc")))]),_vm._v(" "),_c('b-button',{staticClass:"shadow mt-2",staticStyle:{"background-color":"black"},attrs:{"squared":"","variant":"dark","size":"md","to":"/onlineconsultation/"}},[_vm._v(_vm._s(_vm.$t("common.learn-more"))+"\n              ")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnlineExperienceFacial_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2be6a578_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnlineExperienceFacial_vue__ = __webpack_require__(771);
function injectStyle (ssrContext) {
  __webpack_require__(770)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2be6a578"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnlineExperienceFacial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2be6a578_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnlineExperienceFacial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"online-experience-facial"},[_c('b-container',{attrs:{"fluid":""}},[(!_vm.validcode)?_c('b-row',[_c('b-col',{staticClass:"mycontainer-main m-borders",attrs:{"cols":"12"}},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-sm-12 align-self-center text-center"},[_c('div',[_c('div',{staticClass:"bar",attrs:{"id":"bar"}}),_vm._v(" "),_c('h2',{staticClass:"fade-in"},[_vm._v("Welcome to the Beaute Integrale Facial Experience")]),_vm._v(" "),_c('p',{staticClass:"fade-in"},[_vm._v("Enter Your Purchase Code Below")]),_vm._v(" "),_c('b-form',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"text-center",staticStyle:{"width":"300px","height":"50px"},attrs:{"type":"text","placeholder":"enter code here"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"main-button fade-in mt-3",staticStyle:{"background-color":"black"},attrs:{"squared":""},on:{"click":_vm.checkCode}},[_vm._v("start facial")])],1)],1)])])])],1):_c('b-row',[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card-style"},[_c('b-progress',{attrs:{"value":_vm.progress,"squared":"","variant":"dark"}})],1),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-12"},[(_vm.current_step==1)?_c('b-card',{staticClass:"card-style",attrs:{"title":"prepare"}},[_c('b-card-text',[_vm._v("Something for first step.")]),_vm._v(" "),_c('b-button',{staticClass:"float-right",staticStyle:{"background-color":"black"},attrs:{"squared":""},on:{"click":_vm.onClickNext}},[_vm._v("Next")])],1):_vm._e(),_vm._v(" "),(_vm.current_step==2)?_c('b-card',{staticClass:"card-style",attrs:{"title":"STEP2"}},[_c('b-card-text',[_vm._v("Do something for second step.")]),_vm._v(" "),_c('b-button',{staticClass:"float-left",attrs:{"variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("Back")]),_vm._v(" "),_c('b-button',{staticClass:"float-right",attrs:{"variant":"primary"},on:{"click":_vm.onClickNext}},[_vm._v("Next")])],1):_vm._e(),_vm._v(" "),(_vm.current_step==3)?_c('b-card',{staticClass:"card-style",attrs:{"title":"STEP3"}},[_c('b-card-text',[_vm._v("For furthermore in 3rd step.")]),_vm._v(" "),_c('b-button',{staticClass:"float-left",attrs:{"variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("Back")]),_vm._v(" "),_c('b-button',{staticClass:"float-right",attrs:{"variant":"primary"},on:{"click":_vm.onClickNext}},[_vm._v("Next")])],1):_vm._e(),_vm._v(" "),(_vm.current_step==4)?_c('b-card',{staticClass:"card-style",attrs:{"title":"STEP4"}},[_c('b-card-text',[_vm._v("Will soon finish.")]),_vm._v(" "),_c('b-button',{staticClass:"float-left",attrs:{"variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("Back")]),_vm._v(" "),_c('b-button',{staticClass:"float-right",attrs:{"variant":"primary"},on:{"click":_vm.onClickNext}},[_vm._v("Next")])],1):_vm._e(),_vm._v(" "),(_vm.current_step==5)?_c('b-card',{staticClass:"card-style",attrs:{"title":"STEP5"}},[_c('b-card-text',[_vm._v("Finished!")]),_vm._v(" "),_c('b-button',{staticClass:"float-left",attrs:{"variant":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("Back")]),_vm._v(" "),_c('b-button',{staticClass:"float-center",attrs:{"variant":"success"},on:{"click":_vm.onClickFirst}},[_vm._v("Back to first")])],1):_vm._e()],1)])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnlineLanding_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37c78c35_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnlineLanding_vue__ = __webpack_require__(774);
function injectStyle (ssrContext) {
  __webpack_require__(773)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37c78c35"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnlineLanding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37c78c35_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnlineLanding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"onlinelanding"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mycontainer-main"},[_c('b-col',{staticClass:"pl-5 leftcontent",attrs:{"cols":"12","md":"4"}},[_c('h6',{staticClass:"my-0",staticStyle:{"color":"grey"}},[_vm._v(" Beauté Intégrale ")]),_vm._v(" "),_c('h1',[_vm._v(" "+_vm._s(_vm.$t('onlineconsultation.jumbo_title'))+" ")]),_vm._v(" "),_c('h1',{staticClass:"pageSubtitle"},[_vm._v(" "+_vm._s(_vm.$t('onlineconsultation.jumbo_desc1'))+" ")]),_vm._v(" "),_c('h1',{staticClass:"pageSubtitle"},[_vm._v(" "+_vm._s(_vm.$t('onlineconsultation.jumbo_desc2'))+" ")]),_vm._v(" "),_c('b-button',{staticClass:"mt-3 shadow",attrs:{"squared":"","variant":"outline-dark"},on:{"click":_vm.goBack}},[_vm._v(" "+_vm._s(_vm.$t('common.goback'))+"\n        ")]),_vm._v(" "),_c('appt-button',{attrs:{"color":'d'}})],1),_vm._v(" "),_c('b-col',{staticClass:"py-3 centercontent",attrs:{"cols":"12","md":"7"}},[_c('div',{staticClass:"row car"},[_c('b-col',[_c('b-carousel',{staticStyle:{"text-shadow":"0px 0px 2px #000"},attrs:{"id":"carousel-no-animation","no-animation":"","indicators":"","img-width":"1024","img-height":"480"}},[_c('b-carousel-slide',{attrs:{"img-src":_vm.getImgUrl('staff/Roxanne.jpg')}}),_vm._v(" "),_c('b-carousel-slide',{attrs:{"img-src":_vm.getImgUrl('carpic_1.png')}})],1)],1)],1),_vm._v(" "),_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{staticClass:"shadow my-3",staticStyle:{"min-width":"15rem"}},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.$t('onlineconsultation.step1'))+" ")]),_vm._v(" "),_c('b-card-text',{staticClass:"small text-muted"},[_vm._v(" "+_vm._s(_vm.$t('common.step1'))+" ")]),_vm._v(" "),_c('b-card-text',[_vm._v(" "+_vm._s(_vm.$t('onlineconsultation.step1_desc')))])],1),_vm._v(" "),_c('b-card',{staticClass:"shadow my-3",staticStyle:{"min-width":"15rem"}},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.$t('onlineconsultation.step2'))+" ")]),_vm._v(" "),_c('b-card-text',{staticClass:"small text-muted"},[_vm._v(_vm._s(_vm.$t('common.step2')))]),_vm._v(" "),_c('b-card-text',[_vm._v(" "+_vm._s(_vm.$t('onlineconsultation.step2_desc'))+" ")])],1),_vm._v(" "),_c('b-card',{staticClass:"shadow my-3",staticStyle:{"min-width":"15rem"}},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.$t('onlineconsultation.step3'))+" ")]),_vm._v(" "),_c('b-card-text',{staticClass:"small text-muted"},[_vm._v(_vm._s(_vm.$t('common.step3')))]),_vm._v(" "),_c('b-card-text',[_vm._v(" "+_vm._s(_vm.$t('onlineconsultation.step3_desc'))+" ")])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"shadow",staticStyle:{"background-color":"black","color":"white"},attrs:{"text-variant":"white"}},[_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.$t('onlineconsultation.cta'))+" ")]),_vm._v(" "),_c('b-button',{staticClass:"shadow",attrs:{"squared":"","variant":"outline-light","size":"md","to":"/appointment/"}},[_vm._v(_vm._s(_vm.$t('main-screen.online_consultation.button_text'))+" ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedListing_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d99dada0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturedListing_vue__ = __webpack_require__(777);
function injectStyle (ssrContext) {
  __webpack_require__(776)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedListing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d99dada0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturedListing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("featured listing")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedDetail_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7597a1e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturedDetail_vue__ = __webpack_require__(783);
function injectStyle (ssrContext) {
  __webpack_require__(779)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7597a1e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturedDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_facial_vue__ = __webpack_require__(321);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16674683_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_facial_vue__ = __webpack_require__(782);
function injectStyle (ssrContext) {
  __webpack_require__(781)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_facial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16674683_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_facial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-facial-header-wrapper"},[_c('div',{staticClass:"d-flex flex-grow-1",staticStyle:{"height":"100%","padding":"4rem"}},[_c('b-card',{staticClass:"box-back-white",staticStyle:{"width":"100%","height":"100%"}},[_vm._v("hi")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.slug === 'facial')?_c('FeaturedFacial'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WeightLoss_vue__ = __webpack_require__(322);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_021af443_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WeightLoss_vue__ = __webpack_require__(786);
function injectStyle (ssrContext) {
  __webpack_require__(785)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-021af443"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WeightLoss_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_021af443_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WeightLoss_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weightloss"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mycontainer-main"},[_c('b-col',{staticClass:"pl-5 leftcontent",attrs:{"cols":"12","md":"4"}},[_c('h1',[_vm._v(" "+_vm._s(_vm.$t('weightloss.jumbo-title'))+" ")]),_vm._v(" "),_c('h1',{staticStyle:{"font-weight":"900","font-size":"2em"}},[_vm._v(" "+_vm._s(_vm.$t('weightloss.jumbo-desc1'))+" ")]),_vm._v(" "),_c('b-button',{staticClass:"mt-3 shadow",attrs:{"squared":"","variant":"outline-dark"},on:{"click":_vm.goBack}},[_vm._v(" "+_vm._s(_vm.$t('common.goback'))+"  ")])],1),_vm._v(" "),_c('b-col',{staticClass:"py-3",attrs:{"cols":"12","md":"7"}},[(_vm.existingShow)?_c('b-row',{staticClass:"existing",attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"align-contents-center"},[_c('b-card',{staticClass:"shadow"},[_c('b-card-title',[_vm._v(_vm._s(_vm.$t('weightloss.q1')))]),_vm._v(" "),_c('b-button',{staticClass:"mt-3 shadow",staticStyle:{"min-width":"10vw"},attrs:{"squared":"","variant":"outline-dark"},on:{"click":_vm.setExisting}},[_vm._v(_vm._s(_vm.$t('common.yes'))+" ")]),_vm._v(" "),_c('b-button',{staticClass:"mt-3 shadow",staticStyle:{"min-width":"10vw","background-color":"black"},attrs:{"squared":"","variant":"outline-light"},on:{"click":_vm.setNew}},[_vm._v(_vm._s(_vm.$t('weightloss.no'))+" ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.newclient)?_c('b-row',{staticClass:"wtsection3",attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"h-100"},[_c('b-card',{staticClass:"shadow",attrs:{"img-top":"","img-src":__webpack_require__(312)}},[_c('b-card-title',[_vm._v(_vm._s(_vm.$t('weightloss.history')))]),_vm._v(" "),_c('b-card-text',[_vm._v(_vm._s(_vm.$t('weightloss.history_desc')))])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.newclient)?_c('b-row',{staticClass:"wtsection2 mt-2 px-3",attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"col-sm-3 text-center",attrs:{"cols":"12"}},[_c('h6',{staticStyle:{"font-weight":"900","font-size":"1.3em"}},[_vm._v(_vm._s(_vm.$t('weightloss.r1')))])]),_vm._v(" "),_c('b-col',{staticClass:"col-sm-3 text-center",attrs:{"cols":"12"}},[_c('h6',{staticStyle:{"font-weight":"900","font-size":"1.3em"}},[_vm._v(_vm._s(_vm.$t('weightloss.r2')))])]),_vm._v(" "),_c('b-col',{staticClass:"col-sm-3 text-center",attrs:{"cols":"12"}},[_c('h6',{staticStyle:{"font-weight":"900","font-size":"1.3em"}},[_vm._v(_vm._s(_vm.$t('weightloss.r3')))])]),_vm._v(" "),_c('b-col',{staticClass:"col-sm-3 text-center",attrs:{"cols":"12"}},[_c('h6',{staticStyle:{"font-weight":"900","font-size":"1.3em"}},[_vm._v(_vm._s(_vm.$t('weightloss.r4')))])])],1):_vm._e(),_vm._v(" "),(_vm.newclient)?_c('b-row',{staticClass:"wtsectiontitles mt-3",attrs:{"align-v":"center"}},[_c('b-col',[_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{staticClass:"shadow"},[_c('b-card-title',[_vm._v(_vm._s(_vm.$t('weightloss.topreasons')))]),_vm._v(" "),_c('b-list-group',{attrs:{"flush":""}},[_c('b-list-group-item',[_vm._v("\""+_vm._s(_vm.$t('weightloss.rw1'))+"\"")]),_vm._v(" "),_c('b-list-group-item',[_vm._v("\""+_vm._s(_vm.$t('weightloss.rw2'))+"\"")]),_vm._v(" "),_c('b-list-group-item',[_vm._v("\""+_vm._s(_vm.$t('weightloss.rw3'))+"\"")]),_vm._v(" "),_c('b-list-group-item',[_vm._v("\""+_vm._s(_vm.$t('weightloss.rw4'))+"\"")]),_vm._v(" "),_c('b-list-group-item',[_vm._v("\""+_vm._s(_vm.$t('weightloss.rw5'))+"\"")])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"shadow"},[_c('b-card-title',[_vm._v(_vm._s(_vm.$t('weightloss.howitworks')))]),_vm._v(" "),_c('b-list-group',{attrs:{"flush":""}},[_c('b-list-group-item',[_vm._v(_vm._s(_vm.$t('weightloss.h1')))]),_vm._v(" "),_c('b-list-group-item',[_vm._v(_vm._s(_vm.$t('weightloss.h2')))]),_vm._v(" "),_c('b-list-group-item',[_vm._v(_vm._s(_vm.$t('weightloss.h3')))]),_vm._v(" "),_c('b-list-group-item',[_vm._v(_vm._s(_vm.$t('weightloss.h4')))]),_vm._v(" "),_c('b-list-group-item',[_vm._v(_vm._s(_vm.$t('weightloss.h5')))])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.newclient)?_c('b-row',{staticClass:"my-2"},[_c('b-col',{staticClass:"text-center"},[_c('h3',{staticStyle:{"font-weight":"900","font-size":"2em"}},[_vm._v(" "+_vm._s(_vm.$t('weightloss.help')))])])],1):_vm._e(),_vm._v(" "),(_vm.newclient)?_c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('b-button',{staticClass:"shadow mt-2",staticStyle:{"background-color":"black","min-width":"10vw"},attrs:{"squared":"","variant":"dark","size":"md","to":"/appointment"}},[_vm._v(_vm._s(_vm.$t('weightloss.ctabutton')))])],1)],1):_vm._e(),_vm._v(" "),(_vm.existing)?_c('b-row',{staticClass:"newclient",attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"col-sm-12",attrs:{"cols":"12"}},[_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{attrs:{"img-top":"","img-src":__webpack_require__(95)}},[_c('b-card-title',[_vm._v(" "+_vm._s(_vm.$t('weightloss.orderproducts')))]),_vm._v(" "),_c('b-card-text',[_vm._v(_vm._s(_vm.$t('weightloss.orderproducts_desc')))]),_vm._v(" "),_c('b-button',{staticClass:"shadow mt-2",staticStyle:{"background-color":"black","min-width":"10vw"},attrs:{"squared":"","variant":"dark","size":"md","to":"/appointment"}},[_vm._v(_vm._s(_vm.$t('weightloss.ordercta')))])],1)],1)],1),_vm._v(" "),_c('b-col')],1):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareRoutine_vue__ = __webpack_require__(323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73bf9bab_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareRoutine_vue__ = __webpack_require__(789);
function injectStyle (ssrContext) {
  __webpack_require__(788)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73bf9bab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareRoutine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73bf9bab_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareRoutine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shareroutine"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mycontainer-main"},[_c('b-col',{staticClass:"pl-5 leftcontent",attrs:{"cols":"12","md":"4"}},[_c('h6',{staticClass:"my-0",staticStyle:{"color":"grey"}},[_vm._v(" Results ")]),_vm._v(" "),_c('h2',[_vm._v(" "+_vm._s(_vm.$t('shareroutine.jumbo_title'))+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h1',{staticStyle:{"font-weight":"900","font-size":"1.9em"}},[_vm._v(" "+_vm._s(_vm.$t('shareroutine.jumbo_desc1'))+" ")]),_vm._v(" "),_c('h1',{staticStyle:{"font-weight":"900","font-size":"1.9em"}},[_vm._v(" "+_vm._s(_vm.$t('shareroutine.jumbo_desc2'))+" ")]),_vm._v(" "),_c('appt-button',{attrs:{"color":'d'}})],1),_vm._v(" "),_c('b-col',{staticClass:"align-self-center py-3r",attrs:{"cols":"12","md":"7","id":"clinicservices"}},[_c('b-card-group',{attrs:{"deck":""}},_vm._l((_vm.routines),function(r,index){return _c('b-card',{key:index,staticClass:"shadow my-2",staticStyle:{"min-width":"20rem","max-width":"20rem"},attrs:{"img-top":"","img-src":__webpack_require__(179)},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h5',{staticClass:"mb-0",staticStyle:{"font-weight":"600","font-size":"1em"}},[_vm._v(_vm._s(r.skintype)+" Skin for "+_vm._s(r.season))])]},proxy:true},{key:"footer",fn:function(){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-button',{staticClass:"shadow",staticStyle:{"background-color":"black"},attrs:{"squared":"","to":"/clinic/services"}},[_vm._v("View Routine")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Verifed\n                                          "),_c('b-avatar',{attrs:{"icon":"star-fill","variant":"info","size":"sm"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_vm._v("                                      \n                                          Likes "),_c('b-badge',{attrs:{"variant":"light"}},[_vm._v(_vm._s(r.likes))])],1)],1)])]},proxy:true}],null,true)},[_vm._v(" "),_c('b-card-title',{staticStyle:{"font-weight":"bold"}},[_vm._v("\""+_vm._s(r.title)+"\"")]),_vm._v(" "),_c('b-card-sub-title',{staticClass:"pb-2 text-muted"},[_vm._v(_vm._s(r.author))]),_vm._v(" "),_c('b-card-text',[_vm._v("  "+_vm._s(r.description))])],1)}),1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsPrivacy_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6bcbb1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsPrivacy_vue__ = __webpack_require__(792);
function injectStyle (ssrContext) {
  __webpack_require__(791)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b6bcbb1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsPrivacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6bcbb1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsPrivacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"termsprivacy"},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"mycontainer-main m-borders",attrs:{"cols":"12","md":"4"}},[_c('div',{staticClass:"row h-100 ml-5"},[_c('div',{staticClass:"col-sm-12 align-self-start text-left"},[_c('div',{staticClass:"mt-5"},[_c('h1',[_vm._v(_vm._s(_vm.$t('main-screen.terms.title')))]),_vm._v(" "),_c('h1',{staticStyle:{"font-weight":"900","font-size":"2em"}},[_vm._v("/ ")]),_vm._v(" "),_c('b-button',{staticClass:"mt-3 shadow",attrs:{"squared":"","variant":"outline-dark"},on:{"click":_vm.goBack}},[_vm._v(" "+_vm._s(_vm.$t('common.goback')))])],1)])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","md":"8"}},[_c('b-row',{staticClass:"h-100 py-5"},[_c('b-col',{staticClass:"col-sm-8 py-1",attrs:{"cols":"12"}},[_c('h1',[_vm._v(" "+_vm._s(_vm.$t('main-screen.terms.title'))+" ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("CONDITIONS GÉNÉRALES D'UTILISATION"),_c('br'),_vm._v(" DE: www.beauteintegrale.ca")])]),_vm._v(" "),_c('p',[_vm._v("Date de dernière mise à jour : 24 septembre 2020"),_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" PRIÈRE DE LIRE LES CONDITIONS GÉNÉRALES AVANT D'UTILISER LE SITE")])]),_vm._v(" "),_c('p',[_c('br'),_vm._v(" Les conditions générales qui suivent gouvernent et s'appliquent à votre utilisation ou recours au site maintenu par Institut Beauté Intégrale (le \"site\").")]),_vm._v(" "),_c('p',[_vm._v("En accédant au site ou en y navigant, vous déclarez avoir lu et compris les conditions générales d'utilisation et déclarez être liés par ces conditions. Veuillez noter que nous pouvons modifier les conditions d'utilisation à tout moment et sans préavis. Votre utilisation continue du site sera considérée comme votre acceptation des conditions générales révisées.")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("PROPRIÉTÉ INTELLECTUELLE")])]),_vm._v(" "),_c('p',[_vm._v("Toute propriété intellectuelle sur le site, à l'exception du contenu généré par les utilisateurs tel que défini ci-dessous, est possédée par nous ou nos concédants et inclut tout élément protégé par droits d'auteur, marque de commerce ou brevet. Toutes les marques déposées sont possédées, enregistrées et/ou sous licence par nous. Tout le contenu sur le site, à l'exception du contenu généré par les utilisateurs tel que défini ci-dessous, y compris, mais sans s'y limiter, le texte, le logiciel, le code, la conception, les graphiques, les photos, les sons, la musique, les vidéos, les applications, les fonctionnalités interactives ainsi que tout autre contenu, est une ouvre collective sous le droit canadien ou sous tout autre droit des droits d'auteur et est la propriété de Institut Beauté Intégrale. Les éléments figurant sur ce site ne peuvent être copiés, reproduits, publiés de nouveau, téléchargés, affichés, transmis, distribués, ni modifiés, en totalité ou en partie, que ce soit sous forme textuelle, graphique, audio, vidéo ou exécutable, sans notre autorisation écrite.")]),_vm._v(" "),_c('p',[_vm._v("Tous droits réservés.")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("UTILISATION DU CONTENU DE L'ENTREPRISE")])]),_vm._v(" "),_c('p',[_vm._v("Nous pouvons vous fournir certaines informations en raison de votre utilisation du site, y compris, sans s'y limiter, des documents, des données ou des informations développés par nous, ou tout autre élément qui pourrait vous aider dans l'utilisation du site ou des services (le \"Contenu de l'Entreprise\"). Le Contenu de l'Entreprise ne peut être utilisé pour aucun autre objet que l'utilisation du site et des services offerts sur le site. Rien dans les présentes ne peut être interprété comme vous attribuant une licence ou des droits de propriété intellectuelle.")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("CONTENU GÉNÉRÉ PAR LES UTILISATEURS")]),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Le \"contenu généré par les utilisateurs\" inclut les communications, éléments, informations, données, opinions, photos, profils, messages, notes, hyperliens, informations textuelles, conceptions, graphiques, sons ou tout autre contenu que vous et/ou d'autres utilisateurs du site publient ou rendent disponibles sur ou à travers le site, à l'exception du contenu qui est notre propriété.")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("PAIEMENT")])]),_vm._v(" "),_c('p',[_vm._v("Lorsque vous effectuez un achat sur le site, vous acceptez de fournir un instrument de paiement valide. Faites attention aux détails de la transaction puisque le prix total peut inclure taxes, frais et coûts d'envoi pour lesquels vous êtes responsables."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Lorsque vous nous fournissez un instrument de paiement, vous déclarez avoir la permission d'utiliser cet instrument de paiement. Lorsque vous effectuez un paiement, vous nous autorisez, ainsi que le service de paiement que nous utilisons, à charger le montant total sur l'instrument de paiement que vous avez désigné pour la transaction. Vous nous autorisez également à recueillir et enregistrer cet instrument de paiement ainsi que toute autre information reliée à la transaction."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Si vous payez par carte de débit ou de crédit, nous pouvons obtenir de l'émetteur de la carte une préautorisation d'un montant allant jusqu'au montant total de la transaction. Si vous choisissez d'annuler une transaction avant qu'elle soit complétée, les fonds utilisés pour la préautorisation peuvent ne pas être disponibles immédiatement sur votre compte."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Nous nous réservons le droit d'annuler toute transaction si nous sommes d'avis que la transaction enfreint les présentes conditions générales d'utilisation ou si nous sommes d'avis qu'en agissant ainsi nous pouvons prévenir une perte financière."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Afin de prévenir toute perte financière, nous pouvons contacter l'émetteur de votre instrument de paiement, les autorités policières ou toute tierce partie atteinte (incluant d'autres utilisateurs) et pouvons partager les détails de tout paiement auquel vous êtes associé(e) si nous sommes d'avis qu'une telle action puisse prévenir une perte financière ou une infraction à la loi.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" VENTE DE PRODUITS ET/OU SERVICES")])]),_vm._v(" "),_c('p',[_vm._v("Nous pouvons vendre des biens ou services. Nous nous engageons à être aussi exacts que possible en ce qui a trait à toute information au sujet des biens et des services, incluant les descriptions de produits et les images de produits. Cependant, nous ne garantissons pas l'exactitude ou la fiabilité de toute information ayant trait à un produit et vous reconnaissez et convenez que l'achat de tels produits est à vos propres risques.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" EXPÉDITION, LIVRAISON ET POLITIQUE DE RETOUR")])]),_vm._v(" "),_c('p',[_vm._v("Vous acceptez d'assurer le paiement de tous les articles que vous pourriez acheter sur le site, et vous reconnaissez et convenez que les prix sont sujets à changement. Lorsque vous achetez un produit physique, vous acceptez de nous fournir une adresse courriel et une adresse de livraison valides ainsi que des données de facturation valides. Nous nous réservons le droit de refuser ou d'annuler une commande pour quelque raison que ce soit, incluant une erreur ou omission dans les données que vous nous fournissez. Le cas échéant, si le paiement a déjà été traité, nous effectuerons un remboursement du prix d'achat. Nous pouvons vous exiger des informations additionnelles avant de confirmer la vente et nous nous réservons le droit de placer toute restriction additionnelle sur la vente de nos produits. Pour la vente de biens physiques, nous pouvons préautoriser votre carte de débit ou de crédit au moment où vous passez la commande, ou nous pouvons charger votre carte au moment de l'expédition de la commande. Vous acceptez de surveiller votre instrument de paiement. Les coûts d'expédition et de livraison ainsi que les dates prévues de livraison peuvent être modifiées en raison de circonstances imprévues."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Pour toute question ou tout litige, vous acceptez de nous contacter en temps opportun à l'adresse courriel suivante :")]),_vm._v(" "),_c('p',[_vm._v("info@moncoachbeaute.ca")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("UTILISATION ACCEPTABLE DU SITE")])]),_vm._v(" "),_c('p',[_vm._v("Vous acceptez de ne pas utiliser le site pour des fins illicites ou toute autre fin interdite en vertu de la présente clause. Vous acceptez de ne pas utiliser le site de quelconque façon qui pourrait nuire au site, aux services ou à l'activité commerciale de Institut Beauté Intégrale."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Vous acceptez également de ne pas utiliser le site pour les fins suivantes :")]),_vm._v(" "),_c('p',[_vm._v("a) harceler, abuser ou menacer autrui ou autrement violer les droits d'une personne ;")]),_vm._v(" "),_c('p',[_vm._v("b) violer la propriété intellectuelle de Institut Beauté Intégrale ou de toute autre tierce partie ;")]),_vm._v(" "),_c('p',[_vm._v("c) télécharger ou transmettre des virus informatiques ou tout autre logiciel qui pourrait endommager la propriété de Institut Beauté Intégrale ou d'autrui ;")]),_vm._v(" "),_c('p',[_vm._v("d) commettre une fraude ;")]),_vm._v(" "),_c('p',[_vm._v("e) créer des activités de jeu, de la loterie ou un système pyramidal illicite ou y participer ;")]),_vm._v(" "),_c('p',[_vm._v("f) publier ou distribuer du matériel obscène ou diffamatoire ;")]),_vm._v(" "),_c('p',[_vm._v("g) publier ou distribuer tout matériel qui incite è la violence, à la haine, ou à la discrimination de quelque groupe que ce soit ; et/ou")]),_vm._v(" "),_c('p',[_vm._v("h) recueillir illicitement des informations sur autrui.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" PROTECTION DE LA VIE PRIVÉE")])]),_vm._v(" "),_c('p',[_vm._v("En utilisant notre site, il est possible que vous nous fournissiez certaines informations. En utilisant le site, vous nous autorisez à utiliser vos informations au Canada et dans tout pays dans lequel nous pourrions opérer.")]),_vm._v(" "),_c('p',[_vm._v("Nous pouvons recevoir de l'information d'applications externes que vous utilisez pour accéder à notre site ou nous pouvons recevoir de l'information sur vous par diverses technologies du web telles que les cookies, les historiques, les pixels invisibles (aussi appelés \"GIF invisibles\"), les balises et autres."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Nous utilisons l'information recueillie auprès de vous pour vous assurer une bonne expérience sur le site. Nous pouvons aussi tracer certaines informations passives reçues pour améliorer notre marketing et analytique et, pour ce faire, il se peut que nous travaillions avec des fournisseurs tiers, incluant d'autres commerçants."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Si vous désirez bloquer notre accès à toute information passive que nous recevons de l'utilisation de diverses technologies, vous pouvez choisir d'inactiver les cookies dans votre navigateur web.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" DÉGAGEMENT DE RESPONSABILITÉ")]),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Notre site existe pour des fins de communications seulement. Vous reconnaissez et convenez que toute information publiée sur notre site n'est pas destinée à être un avis juridique, médical ou financier et aucun rapport fiduciaire n'a été créé entre vous et Institut Beauté Intégrale. Vous convenez également que votre achat de produits ou services sur le site est à vos propres risques. Nous ne sommes responsables en aucun cas des conseils ou de toute autre information véhiculés sur le site.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" INGÉNIERIE INVERSE ET SÉCURITÉ")])]),_vm._v(" "),_c('p',[_vm._v("Vous ne pouvez entreprendre aucune des actions qui suivent :")]),_vm._v(" "),_c('p',[_vm._v("a) utiliser l'ingénierie inverse ou désassembler tout code ou logiciel sur ou de ce site ;")]),_vm._v(" "),_c('p',[_vm._v("b) violer ou tenter de violer la sécurité du site par tout accès non autorisé, le contournement du cryptage ou de tout autre outil de sécurité, l'exploitation des données ou l'interférence avec tout hôte, utilisateur ou réseau.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" INDEMNISATION")]),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Vous convenez de défendre, dédommager et de tenir indemne Institut Beauté Intégrale et ses entreprises affiliées contre toute réclamation, poursuite ou demande, incluant les frais d'avocats, qui pourrait découler de ou qui se rapporte à votre utilisation ou votre abus du site, votre violation des présentes ou votre conduite et vos actions. Si nous choisissons de le faire, nous choisirons notre avocat et participerons à notre propre défense.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" POLITIQUE CONCERNANT LES POURRIELS")])]),_vm._v(" "),_c('p',[_vm._v("Il vous est strictement interdit d'utiliser le site ou tout service offert sur le site à des fins d'activités illégales reliées aux pourriels, incluant la collecte d'adresses et d'informations personnelles d'autrui ou l'envoi de courriels commerciaux de masse.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" LIENS ET CONTENU DE TIERS")])]),_vm._v(" "),_c('p',[_vm._v("Nous pouvons publier des liens menant à des sites ou services de tiers. Nous ne sommes aucunement responsables de dommages ou pertes liés à l'utilisation des services de tiers dont le lien se trouve sur notre site.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" INDÉPENDANCE DES CLAUSES")])]),_vm._v(" "),_c('p',[_vm._v("Si une des présentes clauses est reconnue comme illégale, déclarée nulle ou inapplicable, en tout ou en partie, la portion inapplicable n'affectera pas la validité et l'applicabilité des autres clauses des présentes conditions d'utilisation.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" INTERRUPTIONS DE SERVICE")]),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Il se peut que nous ayons à interrompre votre accès au site afin d'effectuer des travaux de maintenant ou des travaux d'urgence non planifiés. Vous convenez que votre accès au site peut être affecté par une indisponibilité non planifiée ou non anticipée, pour quelque raison que ce soit, et que nous ne serons en aucun cas tenus responsables de dommages ou de pertes découlant de cette indisponibilité.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" AUCUNE GARANTIE")]),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Bien que nous ayons déployé des efforts raisonnables pour nous assurer que le contenu du présent site est exact, nous ne pouvons garantir que ledit contenu soit exempt d'erreurs, à jour ou exhaustif. En aucun cas, nous ne pourrons être tenus responsables de tout dommage pouvant découler d'une erreur se trouvant sur le site.")]),_vm._v(" "),_c('p',[_vm._v("Nous n'assumons aucune responsabilité quant à tout dommage découlant de la mauvaise utilisation du contenu du site. Nous ne pouvons non plus garantir que le site soit disponible sans interruption, sans erreur ni omission, ni que les défauts soient corrigés. Il n'est pas non plus possible de garantir que le site et les serveurs qui le rendent disponible sont exempts de virus ou de composantes nuisibles. Le site et son contenu sont fournis \"tels quels\" et \"selon la disponibilité\" sans déclaration, garantie ou condition de quelque nature que ce soit, expresse ou implicite.")]),_vm._v(" "),_c('p',[_vm._v("Si vous décidez de vous abonner à des services ou à des fonctions du site qui nécessitent un abonnement, vous acceptez de fournir des renseignements exacts et à jour à votre sujet comme l'exige le processus d'inscription ou d'abonnement pertinent, et de vous assurer de leur exactitude en effectuant les mises à jour nécessaires dès que possible. Vous acceptez d'assurer la confidentialité de tous les mots de passe ou autres identificateurs de compte que vous aurez choisis ou qui vous seront attribués au moment d'une inscription ou d'un abonnement sur Institut Beauté Intégrale ou ses partenaires et d'assumer la responsabilité à l'égard de toutes les activités reliées à l'utilisation de ces mots de passe ou de ces comptes. De plus, vous acceptez de nous prévenir de toute utilisation non autorisée de votre mot de passe ou de votre compte de membre. Nous ne pouvons aucunement être tenus responsables, directement ou indirectement, des pertes ou dommages de quelque nature que ce soit découlant du défaut de vous conformer à la présente disposition ou liés à un tel défaut.")]),_vm._v(" "),_c('p',[_vm._v("Vous reconnaissez que nous pouvons, à notre seule et absolue discrétion, et ce, sans préavis, suspendre, annuler ou mettre fin à votre compte, à votre utilisation ou à votre accès au site ou à un de ses services, et retirer et supprimer tout renseignement ou contenu se rapportant au site ou à un des services offerts (et mettre fin à l'utilisation que vous en faites), pour quelque motif que ce soit, y compris si nous croyons que vous avez violé les présentes conditions. En outre, vous reconnaissez que nous ne serons aucunement responsables envers vous ou envers quiconque à la suite d'une telle suspension, annulation ou fin. Si vous êtes insatisfait de Institut Beauté Intégrale ou d'un de ses services, ou d'une des présentes conditions, des règles, des politiques, des lignes directrices ou de nos pratiques relativement à l'exploitation de Institut Beauté Intégrale ou d'un de ses services, votre seul recours consiste à cesser d'utiliser le site ou le service en question.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" CONFIDENTIALITÉ")])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("a)")]),_vm._v(" "),_c('strong',[_vm._v("Renseignements personnels collectés, renseignements personnels traités et mode de collection des renseignements personnels")])]),_vm._v(" "),_c('p',[_vm._v("Conformément aux dispositions de l'article 5 du Règlement européen 2016/679, la collecte et le traitement de vos renseignements personnels respectent les principes suivants :")]),_vm._v(" "),_c('p',[_vm._v("Licéité, loyauté et transparence : les renseignements personnels ne peuvent être collectés et traités qu'avec votre consentement. À chaque fois que des renseignements personnels seront collectés, il vous sera indiqué que vos renseignements personnels sont collectés, et pour quelles raisons vos renseignements personnels sont collectés ;")]),_vm._v(" "),_c('p',[_vm._v("Finalités limitées : la collecte et le traitement des renseignements personnels sont exécutés pour répondre à un ou plusieurs objectifs déterminés dans les présentes conditions générales d'utilisation ;")]),_vm._v(" "),_c('p',[_vm._v("Minimisation de la collecte et du traitement des renseignements personnels : seuls les renseignements personnels nécessaires à la bonne exécution des objectifs poursuivis par le site sont collectés ;")]),_vm._v(" "),_c('p',[_vm._v("Conservation des renseignements personnels réduite dans le temps : les renseignements personnels sont conservés pour une durée limitée, dont vous est informé(e) ;")]),_vm._v(" "),_c('p',[_vm._v("Intégrité et confidentialité des renseignements personnels collectés et traités : le responsable du traitement des renseignements personnels s'engage à garantir l'intégrité et la confidentialité des renseignements personnels collectés.")]),_vm._v(" "),_c('p',[_c('br'),_vm._v(" Afin d'être licites, et ce conformément aux exigences de l'article 6 du règlement européen 2016/679, la collecte et le traitement des renseignements personnels ne pourront intervenir que s'ils respectent au moins l'une des conditions ci-après énumérées :")]),_vm._v(" "),_c('p',[_vm._v("Vous avez expressément consenti au traitement ;")]),_vm._v(" "),_c('p',[_vm._v("Le traitement est nécessaire à la bonne exécution d'un contrat ;")]),_vm._v(" "),_c('p',[_vm._v("Le traitement répond à une obligation légale ;")]),_vm._v(" "),_c('p',[_vm._v("Le traitement s'explique par une nécessité liée à la sauvegarde des intérêts vitaux de la personne concernée ou d'une autre personne physique ;")]),_vm._v(" "),_c('p',[_vm._v("Le traitement peut s'expliquer par une nécessité liée à l'exécution d'une mission d'intérêt public ou qui relève de l'exercice de l'autorité publique ;")]),_vm._v(" "),_c('p',[_vm._v("Le traitement et la collecte des données à caractère personnel sont nécessaires aux fins des intérêts légitimes et privés poursuivis par le responsable du traitement ou par un tiers.")]),_vm._v(" "),_c('p',[_c('br'),_vm._v(" Les renseignements personnels collectés sur le site sont les suivants :")]),_vm._v(" "),_c('p',[_vm._v("Nom"),_c('br'),_vm._v(" Prénom"),_c('br'),_vm._v(" Adresse de courriel"),_c('br'),_vm._v(" Préoccupations"),_c('br'),_vm._v(" Symptômes relatifs à l'état de la peau"),_c('br'),_vm._v(" Habitudes d'achats de produits de beauté"),_c('br'),_vm._v(" Habitudes de routine"),_c('br'),_vm._v(" Type de peau"),_c('br'),_vm._v(" Âge"),_c('br'),_vm._v(" Courriel"),_c('br'),_vm._v(" Sexe"),_c('br'),_vm._v(" Recommandations professionnelles")]),_vm._v(" "),_c('p',[_c('br'),_vm._v(" Ces renseignements personnels sont collectés lorsque vous effectuez l'une des opérations suivantes sur le site :")]),_vm._v(" "),_c('p',[_vm._v("Entrées de données dans le questionnaire des préoccupations de la peau et questionnaire préparatoire à une consultation virtuelle ou physique")]),_vm._v(" "),_c('p',[_c('br'),_vm._v(" Par ailleurs, lors de l'achat d'un produit sur le site, il est porté à votre connaissance que le vendeur conservera dans ses systèmes informatiques une preuve de la transaction comprenant le bon de commande et la facture.")]),_vm._v(" "),_c('p',[_vm._v("Le responsable du traitement conservera dans ses systèmes informatiques du site et dans des conditions raisonnables de sécurité l'ensemble des renseignements personnels collectés pour une durée de : ________, à moins que vous n'en demandiez la suppression avant l'expiration de cette durée.")]),_vm._v(" "),_c('p',[_vm._v("Lorsque les renseignements personnels sont enregistrés, vous êtes informé(e) de la durée pour laquelle vos renseignements personnels seront conservés, et lorsque cette durée ne peut être précisée, l'entité propriétaire du site vous informera des critères utilisés pour la déterminer.")]),_vm._v(" "),_c('p',[_vm._v("La collecte et le traitement des renseignements personnels répondent aux finalités suivantes :")]),_vm._v(" "),_c('p',[_vm._v("Les données sont récupérées afin de connaître les préoccupations générales des clients en fonction de leur peau. Les bases de recommandations sont associées aux préoccupations. L'âge et la condition de la peau sont des facteurs qui sont récolletés afin de prédire les prochaines recommandations.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" b) Hébergement des données")])]),_vm._v(" "),_c('p',[_vm._v("Le site est hébergé par : Godaddy, dont le siège est situé à l'adresse ci-après :")]),_vm._v(" "),_c('p',[_vm._v("________")]),_vm._v(" "),_c('p',[_vm._v("L'hébergeur peut être contacté au numéro de téléphone suivant : 1 (866) 938-1119")]),_vm._v(" "),_c('p',[_vm._v("Les renseignements personnels collectés et traités par le site sont transférés vers le(s) pays suivant(s) : Canada. Ce transfert de renseignements personnels en dehors de l'Union européenne se justifie par les raisons ci-après :")]),_vm._v(" "),_c('p',[_vm._v("N'est pas le pays habité par l'entité")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" c) Responsable du traitement des renseignements personnels")])]),_vm._v(" "),_c('p',[_vm._v("Le responsable du traitement des renseignements personnels à caractère personnel est : Claudia McKenny, travaillant au sein de : Institut Beauté Intégrale. Il peut être contacté de la manière suivante :")]),_vm._v(" "),_c('p',[_vm._v("info@beauteintegrale.com"),_c('br'),_vm._v(" 418-626-8359"),_c('br'),_vm._v(" 8335 Boul. Henri-bourassa"),_c('br'),_vm._v(" Québec, QC, G1G 4E1")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" d) Renseignements personnels de personnes mineures")])]),_vm._v(" "),_c('p',[_vm._v("Conformément aux dispositions de l'article 8 du règlement européen 2016/679, seuls les mineurs âgés de 15 ans ou plus peuvent consentir au traitement de leurs renseignements personnels.")]),_vm._v(" "),_c('p',[_vm._v("Si vous êtes un mineur de moins de 15 ans, l'accord d'un représentant légal est requis afin que vos renseignements personnels puissent être collectés et traités.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" e) Droits et procédures de mise en oeuvre de vos droits")])]),_vm._v(" "),_c('p',[_vm._v("Conformément à la réglementation concernant le traitement des renseignements personnels, vous possédez les droits ci-après énumérés.")]),_vm._v(" "),_c('p',[_vm._v("Afin que le responsable du traitement des renseignements personnels fasse droit à votre demande, vous est tenu de lui communiquer : vos prénom et nom ainsi que votre adresse courriel.")]),_vm._v(" "),_c('p',[_vm._v("Le responsable du traitement des renseignements personnels est tenu de vous répondre dans un délai de 30 (trente) jours maximum.")]),_vm._v(" "),_c('p',[_vm._v("Droit d'accès, de rectification et droit à l'oubli")]),_vm._v(" "),_c('p',[_vm._v("Vous pouvez prendre connaissance, mettre à jour, modifier ou demander la suppression des renseignements personnels vous concernant, en respectant la procédure ci-après énoncée :")]),_vm._v(" "),_c('p',[_vm._v("L'utilisateur peut envoyer une demande en utilisant l'information de contact ci-haut pour demander de retirer les informations personnelles de nos bases de données.")]),_vm._v(" "),_c('p',[_vm._v("Droit à la portabilité des renseignements personnels")]),_vm._v(" "),_c('p',[_vm._v("Vous avez le droit de demander la portabilité de vos renseignements personnels détenus par le site vers un autre site, en vous conformant à la procédure ci-après :")]),_vm._v(" "),_c('p',[_vm._v("L'utilisateur doit faire la demande en utilisant le contact ci-haut pour demander de retirer ses données personnelles de notre base de données.")]),_vm._v(" "),_c('p',[_vm._v("III. Droit à la limitation et à l'opposition du traitement des renseignements personnels")]),_vm._v(" "),_c('p',[_vm._v("Vous avez le droit de demander la limitation ou de vous opposer au traitement de vos renseignements personnels par le site, sans que le site puisse refuser, sauf à démontrer l'existence de motifs légitimes et impérieux, pouvant prévaloir sur vos intérêts, vos droits et vos libertés.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" f) Obligations du responsable du traitement des renseignements personnels")])]),_vm._v(" "),_c('p',[_vm._v("Le responsable du traitement s'engage à protéger les renseignements personnels collectés, à ne pas les transmettre à des tiers sans que vous n'en ait été informé et à respecter les finalités pour lesquelles ces renseignements personnels ont été collectés."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Le site dispose d'un certificat SSL afin de garantir que les informations et le transfert des renseignements personnels transitant par le site sont sécurisés.")]),_vm._v(" "),_c('p',[_vm._v("De plus, le responsable du traitement des renseignements personnels s'engage à vous notifier en cas de rectification ou de suppression des renseignements personnels, à moins que cela n'entraîne pour lui des formalités, coûts et démarches disproportionnés.")]),_vm._v(" "),_c('p',[_vm._v("Dans le cas où l'intégrité, la confidentialité ou la sécurité de vos renseignements personnels est compromise, le responsable du traitement s'engage à vous en informer par tout moyen.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" COOKIES")])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("a) Consentement à l'utilisation de fichiers \"cookies\" par le site")])]),_vm._v(" "),_c('p',[_vm._v("Le site a éventuellement recours aux techniques de \"cookies\" lui permettant de traiter des statistiques et des informations sur le trafic, de faciliter la navigation et d'améliorer le service pour votre confort. Pour l'utilisation de fichiers \"cookies\" impliquant la sauvegarde et l'analyse de renseignements personnels, votre consentement est nécessairement demandé.")]),_vm._v(" "),_c('p',[_vm._v("Ce consentement est considéré comme valide pour une durée de 13 (treize) mois maximum. À l'issue de cette période, le site demandera à nouveau votre autorisation pour enregistrer des fichiers \"cookies\" sur votre disque dur.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" b) Opposition à l'utilisation de fichiers \"cookies\" par le site")])]),_vm._v(" "),_c('p',[_vm._v("Vous pouvez vous opposer à l'enregistrement de ces \"cookies\" en configurant votre logiciel de navigation.")]),_vm._v(" "),_c('p',[_vm._v("Dans le cas où vous décideriez de désactiver les fichiers \"cookies\", vous pourrez poursuivre votre navigation sur le site. Toutefois, tout dysfonctionnement du site provoqué par cette manipulation ne pourrait être considéré comme étant de notre fait.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" c) Description des fichiers \"cookies\" utilisés par le site")])]),_vm._v(" "),_c('p',[_vm._v("Les cookies suivants sont utilisés lors de votre navigation :")]),_vm._v(" "),_c('p',[_vm._v("________")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" LIMITATION DE LA RESPONSABILITÉ")]),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Nous ne sommes en aucun cas responsables des dommages que vous pourriez subir découlant de votre utilisation du site, dans la pleine mesure de la loi. La responsabilité maximale de Institut Beauté Intégrale découlant de votre utilisation du site est limitée à cent (100) dollars canadiens ou le montant payé à Institut Beauté Intégrale dans les six derniers mois, en retenant le montant le plus élevé. Ceci est valable pour toute réclamation incluant, sans s'y limiter, la perte de profits ou de revenus, les dommages indirects ou punitifs, la négligence, la responsabilité civile ou la fraude de toute sorte.")]),_vm._v(" "),_c('p',[_c('strong',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" QUESTIONS ET INFORMATIONS ADDITIONNELLES")]),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Pour toute question ou pour obtenir de plus amples renseignements, nous vous prions de communiquer avec nous à l'adresse suivante: info@beauteintegrale.ca")])])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forms_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_313c325d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forms_vue__ = __webpack_require__(801);
function injectStyle (ssrContext) {
  __webpack_require__(794)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-313c325d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_313c325d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCovid_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68874d02_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCovid_vue__ = __webpack_require__(797);
function injectStyle (ssrContext) {
  __webpack_require__(796)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68874d02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCovid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68874d02_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCovid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"shadow mt-2"},[(_vm.show)?_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('h4',[_vm._v(" Information importante en relation avec le COVID-19 ")]),_vm._v(" "),_c('h5',{staticStyle:{"color":"red"}},[_vm._v(" Questionnaire obligatoire ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-2","label":_vm.display.firstname + ':',"label-for":"input-2"}},[_c('b-form-input',{attrs:{"id":"input-2","required":"","placeholder":_vm.display.firstName},model:{value:(_vm.form.firstname),callback:function ($$v) {_vm.$set(_vm.form, "firstname", $$v)},expression:"form.firstname"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-2b","label":_vm.display.lastname + ':',"label-for":"input-2b"}},[_c('b-form-input',{attrs:{"id":"input-2b","required":"","placeholder":_vm.display.lastName},model:{value:(_vm.form.lastname),callback:function ($$v) {_vm.$set(_vm.form, "lastname", $$v)},expression:"form.lastname"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-3","label":_vm.display.phone + ':',"label-for":"input-3"}},[_c('b-form-input',{attrs:{"id":"input-3","required":"","placeholder":_vm.display.enterPhone},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-email","label":_vm.display.email+ ':',"label-for":"input-email"}},[_c('b-form-input',{attrs:{"id":"input-email","type":"email","required":"","placeholder":_vm.display.enterEmail},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-5","label":_vm.display.q1}},[_c('b-form-radio-group',{attrs:{"id":"checkboxes-5","size":"lg","stacked":""}},_vm._l((_vm.display.q1a),function(s,index){return _c('b-form-radio',{key:index,attrs:{"value":s},model:{value:(_vm.form.q1a),callback:function ($$v) {_vm.$set(_vm.form, "q1a", $$v)},expression:"form.q1a"}},[_vm._v(" "+_vm._s(s)+"                                \n            ")])}),1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-6","label":_vm.display.q2}},[_c('b-form-radio-group',{attrs:{"id":"checkboxes-6","size":"lg","stacked":""}},_vm._l((_vm.display.q2a),function(s,index){return _c('b-form-radio',{key:index,attrs:{"value":s},model:{value:(_vm.form.q2a),callback:function ($$v) {_vm.$set(_vm.form, "q2a", $$v)},expression:"form.q2a"}},[_vm._v(" "+_vm._s(s)+"                                \n            ")])}),1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-7","label":_vm.display.q3}},[_c('b-form-radio-group',{attrs:{"id":"checkboxes-7","size":"lg","stacked":""}},_vm._l((_vm.display.q3a),function(s,index){return _c('b-form-radio',{key:index,attrs:{"value":s},model:{value:(_vm.form.q3a),callback:function ($$v) {_vm.$set(_vm.form, "q3a", $$v)},expression:"form.q3a"}},[_vm._v(" "+_vm._s(s)+"                                \n            ")])}),1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-8","label":_vm.display.q4}},[_c('b-form-checkbox-group',{attrs:{"id":"checkboxes-8","size":"lg","stacked":""}},_vm._l((_vm.display.q4a),function(s,index){return _c('b-form-checkbox',{key:index,attrs:{"value":s},model:{value:(_vm.form.q4a),callback:function ($$v) {_vm.$set(_vm.form, "q4a", $$v)},expression:"form.q4a"}},[_vm._v(" "+_vm._s(s)+"                                \n            ")])}),1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-9","label":_vm.display.q5}},[_c('b-form-radio-group',{attrs:{"id":"checkboxes-9","size":"lg","stacked":""}},_vm._l((_vm.display.q5a),function(s,index){return _c('b-form-radio',{key:index,attrs:{"value":s},model:{value:(_vm.form.q5a),callback:function ($$v) {_vm.$set(_vm.form, "q5a", $$v)},expression:"form.q5a"}},[_vm._v(" "+_vm._s(s)+"                                \n            ")])}),1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-10","label":_vm.display.q6}},[_c('b-form-checkbox-group',{attrs:{"id":"checkboxes-10","size":"lg","stacked":""}},_vm._l((_vm.display.q6a),function(s,index){return _c('b-form-checkbox',{key:index,attrs:{"multiple":"","value":s},model:{value:(_vm.form.q6a),callback:function ($$v) {_vm.$set(_vm.form, "q6a", $$v)},expression:"form.q6a"}},[_vm._v(" "+_vm._s(s)+"                                \n            ")])}),1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Merci de votre collaboration")]),_vm._v(" "),_c('p',[_vm._v("Nous vous prions de bien vouloir suivre nos protocoles de contrôles des infections lors de votre visite. \n            Respecter l'hygiène des mains, apportez votre propre masque (couvre-visage) si possible et suivre l'étiquette respiratoire. \n            Vous êtes invité(e) à apporter votre propre bouteille d'eau au besoin car nous ne pouvons plus servir de breuvages.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Responsabilité")]),_vm._v(" "),_c('p',[_vm._v("En soumettant ce questionnaire, je déclare avoir répondu au questionnaire au meilleur de ma connaissance. \n            Il est de ma responsabilité d'aviser l'esthéticienne/électrolyste/technicienne de tout changement.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","squared":"","variant":"dark"}},[_vm._v(_vm._s(_vm.$t('common.submit')))])],1):_vm._e()],1),_vm._v(" "),(!_vm.show)?_c('b-card',[_c('h4',[_vm._v("Merci / Thank You")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormIntake_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a69b1388_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormIntake_vue__ = __webpack_require__(800);
function injectStyle (ssrContext) {
  __webpack_require__(799)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a69b1388"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormIntake_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a69b1388_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormIntake_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"shadow mt-2"},[(_vm.show)?_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('h4',[_vm._v(" "+_vm._s(_vm.display.title)+" ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-2","label":_vm.display.firstname + ':',"label-for":"input-2"}},[_c('b-form-input',{attrs:{"id":"input-2","required":"","placeholder":_vm.display.firstName},model:{value:(_vm.form.firstname),callback:function ($$v) {_vm.$set(_vm.form, "firstname", $$v)},expression:"form.firstname"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-2b","label":_vm.display.lastname + ':',"label-for":"input-2b"}},[_c('b-form-input',{attrs:{"id":"input-2b","required":"","placeholder":_vm.display.lastName},model:{value:(_vm.form.lastname),callback:function ($$v) {_vm.$set(_vm.form, "lastname", $$v)},expression:"form.lastname"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-3","label":_vm.display.phone + ':',"label-for":"input-3"}},[_c('b-form-input',{attrs:{"id":"input-3","required":"","placeholder":_vm.display.enterPhone},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-email","label":_vm.display.email+ ':',"label-for":"input-email"}},[_c('b-form-input',{attrs:{"id":"input-email","type":"email","required":"","placeholder":_vm.display.enterEmail},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.display.q1))]),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox-group',{staticClass:"ml-5",attrs:{"id":"checkboxes-5","size":"lg","stacked":"","multiple":true}},_vm._l((_vm.display.q1a),function(s,index){return _c('b-form-checkbox',{key:index,staticClass:"my-2",attrs:{"value":s},model:{value:(_vm.form.q1a),callback:function ($$v) {_vm.$set(_vm.form, "q1a", $$v)},expression:"form.q1a"}},[_vm._v(" "+_vm._s(s)+"                                \n            ")])}),1)],1),_vm._v(" "),_c('b-form-group',{staticClass:"mt-4",attrs:{"id":"input-group-email","label":_vm.display.q2+ ':',"label-for":"input-email"}},[_c('b-form-textarea',{attrs:{"id":"q2a","rows":"3"},model:{value:(_vm.form.q2a),callback:function ($$v) {_vm.$set(_vm.form, "q2a", $$v)},expression:"form.q2a"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.display.q3))]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"q3a","rows":"3"},model:{value:(_vm.form.q3a),callback:function ($$v) {_vm.$set(_vm.form, "q3a", $$v)},expression:"form.q3a"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.display.q4))]),_vm._v(" "),_c('label',{staticClass:"mt-4",attrs:{"for":"q4q1"}},[_vm._v(_vm._s(_vm.display.q4q1))]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"q4q1"},model:{value:(_vm.form.q4a1),callback:function ($$v) {_vm.$set(_vm.form, "q4a1", $$v)},expression:"form.q4a1"}}),_vm._v(" "),_c('label',{staticClass:"mt-4",attrs:{"for":"q4q2"}},[_vm._v(_vm._s(_vm.display.q4q2))]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"q4q2"},model:{value:(_vm.form.q4a2),callback:function ($$v) {_vm.$set(_vm.form, "q4a2", $$v)},expression:"form.q4a2"}}),_vm._v(" "),_c('label',{staticClass:"mt-4",attrs:{"for":"q4q3"}},[_vm._v(_vm._s(_vm.display.q4q3))]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"q4q3"},model:{value:(_vm.form.q4a3),callback:function ($$v) {_vm.$set(_vm.form, "q4a3", $$v)},expression:"form.q4a3"}}),_vm._v(" "),_c('label',{staticClass:"mt-4",attrs:{"for":"q4q4"}},[_vm._v(_vm._s(_vm.display.q4q4))]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"q4q4"},model:{value:(_vm.form.q4a4),callback:function ($$v) {_vm.$set(_vm.form, "q4a4", $$v)},expression:"form.q4a4"}}),_vm._v(" "),_c('label',{staticClass:"mt-4",attrs:{"for":"q4q5"}},[_vm._v(_vm._s(_vm.display.q4q5))]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"q4q5"},model:{value:(_vm.form.q4a5),callback:function ($$v) {_vm.$set(_vm.form, "q4a5", $$v)},expression:"form.q4a5"}}),_vm._v(" "),_c('label',{staticClass:"mt-4",attrs:{"for":"q4q6"}},[_vm._v(_vm._s(_vm.display.q4q6))]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"q4q6"},model:{value:(_vm.form.q4a6),callback:function ($$v) {_vm.$set(_vm.form, "q4a6", $$v)},expression:"form.q4a6"}}),_vm._v(" "),_c('label',{staticClass:"mt-4",attrs:{"for":"q4q7"}},[_vm._v(_vm._s(_vm.display.q4q7))]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"q4q7"},model:{value:(_vm.form.q4a7),callback:function ($$v) {_vm.$set(_vm.form, "q4a7", $$v)},expression:"form.q4a7"}}),_vm._v(" "),_c('label',{staticClass:"mt-4",attrs:{"for":"q4q8"}},[_vm._v(_vm._s(_vm.display.q4q8))]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"q4q8"},model:{value:(_vm.form.q4a8),callback:function ($$v) {_vm.$set(_vm.form, "q4a8", $$v)},expression:"form.q4a8"}}),_vm._v(" "),_c('label',{staticClass:"mt-4",attrs:{"for":"q4q9"}},[_vm._v(_vm._s(_vm.display.q4q9))]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"q4q9"},model:{value:(_vm.form.q4a9),callback:function ($$v) {_vm.$set(_vm.form, "q4a9", $$v)},expression:"form.q4a9"}}),_vm._v(" "),_c('label',{staticClass:"mt-4",attrs:{"for":"q4q10"}},[_vm._v(_vm._s(_vm.display.q4q10))]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"q4q10"},model:{value:(_vm.form.q4a10),callback:function ($$v) {_vm.$set(_vm.form, "q4a10", $$v)},expression:"form.q4a10"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-9","label":_vm.display.q5}},[_c('b-form-textarea',{attrs:{"rows":"3"},model:{value:(_vm.form.q5a),callback:function ($$v) {_vm.$set(_vm.form, "q5a", $$v)},expression:"form.q5a"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Merci de votre collaboration")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","squared":"","variant":"dark"}},[_vm._v(_vm._s(_vm.$t('common.submit')))])],1):_vm._e()],1),_vm._v(" "),(!_vm.show)?_c('b-card',[_c('h4',[_vm._v("Merci / Thank You")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forms"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mycontainer-main"},[_c('b-col',{staticClass:"pl-5 leftcontent",attrs:{"cols":"12","md":"4"}},[_c('h6',{staticClass:"my-0",staticStyle:{"color":"grey"}},[_vm._v(" "+_vm._s(_vm.$t('common.form'))+" ")]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.destinationForm)))]),_vm._v(" "),_c('br'),_vm._v(" "),(this.destinationForm == 'covid19')?_c('h1',{staticStyle:{"font-weight":"900","font-size":"1.9em"}},[_vm._v("Questionnaire de préparation")]):_vm._e(),_vm._v(" "),(this.destinationForm == 'intake')?_c('h1',{staticStyle:{"font-weight":"900","font-size":"1.9em"}},[_vm._v("Questionnaire de préparation")]):_vm._e()]),_vm._v(" "),(!_vm.submitComplete)?_c('b-col',{staticClass:"align-self-center py-3",attrs:{"cols":"12","md":"6","id":"apptform"}},[(this.destinationForm == 'covid19')?_c('FormCovid'):_vm._e(),_vm._v(" "),(this.destinationForm == 'intake')?_c('FormIntake'):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.submitComplete)?_c('b-col',{staticClass:"align-self-center py-3",attrs:{"cols":"12","md":"6"}},[_c('b-card',[_c('b-card-title',[_vm._v(_vm._s(_vm.$t('requestappt.submitted')))])],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5157b531_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__(804);
function injectStyle (ssrContext) {
  __webpack_require__(803)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5157b531"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5157b531_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"h-100"},[_c('b-col',{staticClass:"pl-5 leftcontent",attrs:{"cols":"12","md":"4"}},[_c('h6',{staticClass:"my-0",staticStyle:{"color":"grey"}},[_vm._v(" Oops! Not Found ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"mt-3 shadow",attrs:{"squared":"","variant":"outline-dark"},on:{"click":_vm.goBack}},[_vm._v(" "+_vm._s(_vm.$t('common.goback')))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main3_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29b27f72_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main3_vue__ = __webpack_require__(807);
function injectStyle (ssrContext) {
  __webpack_require__(806)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29b27f72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29b27f72_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainentrance"},[_c('b-container',[_c('b-row',{},[_c('b-col',{staticClass:"d-flex align-items-center",attrs:{"cols":"12","md":"5","order":"2","order-md":"1"}},[_c('div',{staticClass:"my-5 px-3 w-100"},[_c('h6',{staticClass:"my-0",staticStyle:{"color":"grey"}},[_vm._v("Ville de Quebec")]),_vm._v(" "),_c('h2',{staticClass:"font-weight-bold",staticStyle:{"color":"black"}},[_vm._v("\n            Beauté Intégrale\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.$t("clinic-main.jumbo-message1")))]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.$t("clinic-main.jumbo-message2")))]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.$t("clinic-main.jumbo-message3")))]),_vm._v(" "),_c('div',{staticClass:"my-3"},[_c('appt-button',{attrs:{"color":'d'}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"ml-md-auto mt-3 mt-md-2"},[_c('a',{attrs:{"href":"https://www.facebook.com/beauteintegrale"}},[_c('i',{staticClass:"fa fa-facebook-official fa-2x mx-3",staticStyle:{"color":"black"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/beauteintegrale/"}},[_c('i',{staticClass:"fa fa-instagram fa-2x mx-3",staticStyle:{"color":"black"}})])])])])]),_vm._v(" "),_c('b-col',{staticClass:"d-flex align-items-center px-0 m-borders",attrs:{"cols":"12","md":"7","order":"1","order-md":"2"}},[_c('div',{staticClass:"video-container"},[_c('video',{staticClass:"video",attrs:{"playsinline":"","autoplay":"","muted":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":"https://media.milligram-health.com/beaute-integrale-web/videos/BI_Facial_Video_2.mp4","type":"video/mp4"}})])])])],1),_vm._v(" "),_c('b-row',{staticClass:"tb"},[_c('b-col',{staticClass:"m-borders retail-clinic bi-col",attrs:{"cols":"12","md":"8"}},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-sm-12 align-self-end py-3"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.retail.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",attrs:{"squared":"","variant":"outline-light","size":"md","to":"clinic/"}},[_vm._v(_vm._s(_vm.$t("main-screen.retail.button_text"))+"\n                "),_c('b-icon',{attrs:{"icon":"chevron-right","font-scale":"0.95","aria-hidden":"true"}})],1)],1)])])]),_vm._v(" "),_c('b-col',{staticClass:"bi-col",attrs:{"cols":"12","md":"4"}},[_c('div',{staticClass:"row h-100 background-giftcard m-borders"},[_c('div',{staticClass:"col-sm-12 align-self-end py-3"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.gift.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",attrs:{"squared":"","variant":"outline-light","size":"md","href":"https://moncoachbeaute.ca/","target":"_blank"}},[_vm._v(_vm._s(_vm.$t("main-screen.gift.button_text"))+"\n                        "),_c('b-icon',{attrs:{"icon":"chevron-right","font-scale":"0.95","aria-hidden":"true"}})],1)],1)])])]),_vm._v(" "),_c('b-col',{staticClass:"m-borders online-consultation bi-col",attrs:{"cols":"12","md":"6"}},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-sm-12 align-self-end py-3"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.online_consultation.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",attrs:{"squared":"","variant":"outline-light","size":"md","to":"onlineconsultation/"}},[_vm._v(_vm._s(_vm.$t("main-screen.online_consultation.button_text"))+"\n                "),_c('b-icon',{attrs:{"icon":"chevron-right","font-scale":"0.95","aria-hidden":"true"}})],1)],1)])])]),_vm._v(" "),_c('b-col',{staticClass:"bi-col",attrs:{"cols":"12","md":"6"}},[_c('div',{staticClass:"row h-100 background-athome m-borders"},[_c('div',{staticClass:"col-sm-12 align-self-end py-3 bi-card"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.at-home.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",attrs:{"squared":"","variant":"outline-light","size":"md","href":"https://reservations.beauteintegrale.ca/v2/#book"}},[_vm._v(_vm._s(_vm.$t("main-screen.at-home.button_text"))+"\n            \n                "),_c('b-icon',{attrs:{"icon":"chevron-right","font-scale":"0.95","aria-hidden":"true"}})],1)],1)])])])],1),_vm._v(" "),_c('b-row',{staticClass:"tb2"},[_c('b-col',{staticClass:"background-assessment m-borders bi-col",attrs:{"cols":"12","md":"8"}},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-sm-12 align-self-end py-3"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("main-screen.skincare_assessment.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",attrs:{"squared":"","variant":"outline-light","size":"md","to":"/online/assessment/routine"}},[_vm._v(_vm._s(_vm.$t("main-screen.skincare_assessment.button_text"))+"\n                "),_c('b-icon',{attrs:{"icon":"chevron-right","font-scale":"0.95","aria-hidden":"true"}})],1)],1)])])]),_vm._v(" "),_c('b-col',{staticClass:"bi-col",attrs:{"cols":"12","md":"4"}},[_c('div',{staticClass:"row h-50 background-social m-borders"},[_c('div',{staticClass:"col-sm-12 align-self-center py-3"},[_c('div',{staticClass:"d-flex justify-content-around"},[_c('a',{attrs:{"href":"https://www.facebook.com/beauteintegrale"}},[_c('i',{staticClass:"fa fa-facebook-official fa-2x mx-3",staticStyle:{"color":"white","font-size":"60px"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/beauteintegrale/"}},[_c('i',{staticClass:"fa fa-instagram fa-2x mx-3",staticStyle:{"color":"white","font-size":"60px"}})])])])]),_vm._v(" "),_c('div',{staticClass:"row h-50 m-borders",staticStyle:{"background-color":"#e8e8e8"}},[_c('div',{staticClass:"col-sm-12 align-self-center py-3"},[_c('div',[_c('h2',{staticStyle:{"color":"black"}},[_vm._v(_vm._s(_vm.$t("main-screen.faqs.title")))]),_vm._v(" "),_c('b-button',{staticClass:"main-button shadow",attrs:{"squared":"","variant":"dark","size":"md","to":"/faqs/"}},[_vm._v(_vm._s(_vm.$t("main-screen.faqs.button_text"))+"\n                "),_c('b-icon',{attrs:{"icon":"chevron-right","font-scale":"0.95","aria-hidden":"true"}})],1)],1)])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GiftCardDetail_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f07318a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GiftCardDetail_vue__ = __webpack_require__(811);
function injectStyle (ssrContext) {
  __webpack_require__(809)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f07318a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GiftCardDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f07318a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GiftCardDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./gc_classic.png": 302,
	"./gc_eyes.png": 303,
	"./gc_microdermabrasion.png": 304,
	"./gc_monetary.png": 305,
	"./gc_neck.png": 306,
	"./gc_peeling.png": 307,
	"./gc_personalized.png": 308,
	"./gc_specific.png": 309
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 810;

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clinicservicedetail"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mycontainer-main"},[_c('b-col',{staticClass:"pl-5 leftcontent",style:({
          backgroundImage:
            'linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.3)), url(' +
            this.img +
            ')',
        }),attrs:{"cols":"12","md":"4"}},[_c('h1',[_vm._v(_vm._s(_vm.giftc_detail.name))]),_vm._v(" "),_c('b-button',{staticClass:"mt-3",attrs:{"squared":"","variant":"outline-light"},on:{"click":_vm.goBack}},[_vm._v("\n          "+_vm._s(_vm.$t("common.home"))+"\n        ")]),_vm._v(" "),_c('appt-button',{attrs:{"color":'l'}})],1),_vm._v(" "),(_vm.giftc_detail)?_c('b-col',{staticClass:"align-center",attrs:{"cols":"12","md":"6"}},[_c('div',{staticClass:"p-3"},[_c('h3',[_vm._v(_vm._s(_vm.giftc_detail.name))]),_vm._v(" "),_c('p',{staticStyle:{"color":"black"},domProps:{"innerHTML":_vm._s(_vm.giftc_detail.description)}})])]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 471,
	"./af.js": 471,
	"./ar": 472,
	"./ar-dz": 473,
	"./ar-dz.js": 473,
	"./ar-kw": 474,
	"./ar-kw.js": 474,
	"./ar-ly": 475,
	"./ar-ly.js": 475,
	"./ar-ma": 476,
	"./ar-ma.js": 476,
	"./ar-sa": 477,
	"./ar-sa.js": 477,
	"./ar-tn": 478,
	"./ar-tn.js": 478,
	"./ar.js": 472,
	"./az": 479,
	"./az.js": 479,
	"./be": 480,
	"./be.js": 480,
	"./bg": 481,
	"./bg.js": 481,
	"./bm": 482,
	"./bm.js": 482,
	"./bn": 483,
	"./bn.js": 483,
	"./bo": 484,
	"./bo.js": 484,
	"./br": 485,
	"./br.js": 485,
	"./bs": 486,
	"./bs.js": 486,
	"./ca": 487,
	"./ca.js": 487,
	"./cs": 488,
	"./cs.js": 488,
	"./cv": 489,
	"./cv.js": 489,
	"./cy": 490,
	"./cy.js": 490,
	"./da": 491,
	"./da.js": 491,
	"./de": 492,
	"./de-at": 493,
	"./de-at.js": 493,
	"./de-ch": 494,
	"./de-ch.js": 494,
	"./de.js": 492,
	"./dv": 495,
	"./dv.js": 495,
	"./el": 496,
	"./el.js": 496,
	"./en-au": 497,
	"./en-au.js": 497,
	"./en-ca": 498,
	"./en-ca.js": 498,
	"./en-gb": 499,
	"./en-gb.js": 499,
	"./en-ie": 500,
	"./en-ie.js": 500,
	"./en-il": 501,
	"./en-il.js": 501,
	"./en-in": 502,
	"./en-in.js": 502,
	"./en-nz": 503,
	"./en-nz.js": 503,
	"./en-sg": 504,
	"./en-sg.js": 504,
	"./eo": 505,
	"./eo.js": 505,
	"./es": 506,
	"./es-do": 507,
	"./es-do.js": 507,
	"./es-us": 508,
	"./es-us.js": 508,
	"./es.js": 506,
	"./et": 509,
	"./et.js": 509,
	"./eu": 510,
	"./eu.js": 510,
	"./fa": 511,
	"./fa.js": 511,
	"./fi": 512,
	"./fi.js": 512,
	"./fil": 513,
	"./fil.js": 513,
	"./fo": 514,
	"./fo.js": 514,
	"./fr": 515,
	"./fr-ca": 516,
	"./fr-ca.js": 516,
	"./fr-ch": 517,
	"./fr-ch.js": 517,
	"./fr.js": 515,
	"./fy": 518,
	"./fy.js": 518,
	"./ga": 519,
	"./ga.js": 519,
	"./gd": 520,
	"./gd.js": 520,
	"./gl": 521,
	"./gl.js": 521,
	"./gom-deva": 522,
	"./gom-deva.js": 522,
	"./gom-latn": 523,
	"./gom-latn.js": 523,
	"./gu": 524,
	"./gu.js": 524,
	"./he": 525,
	"./he.js": 525,
	"./hi": 526,
	"./hi.js": 526,
	"./hr": 527,
	"./hr.js": 527,
	"./hu": 528,
	"./hu.js": 528,
	"./hy-am": 529,
	"./hy-am.js": 529,
	"./id": 530,
	"./id.js": 530,
	"./is": 531,
	"./is.js": 531,
	"./it": 532,
	"./it-ch": 533,
	"./it-ch.js": 533,
	"./it.js": 532,
	"./ja": 534,
	"./ja.js": 534,
	"./jv": 535,
	"./jv.js": 535,
	"./ka": 536,
	"./ka.js": 536,
	"./kk": 537,
	"./kk.js": 537,
	"./km": 538,
	"./km.js": 538,
	"./kn": 539,
	"./kn.js": 539,
	"./ko": 540,
	"./ko.js": 540,
	"./ku": 541,
	"./ku.js": 541,
	"./ky": 542,
	"./ky.js": 542,
	"./lb": 543,
	"./lb.js": 543,
	"./lo": 544,
	"./lo.js": 544,
	"./lt": 545,
	"./lt.js": 545,
	"./lv": 546,
	"./lv.js": 546,
	"./me": 547,
	"./me.js": 547,
	"./mi": 548,
	"./mi.js": 548,
	"./mk": 549,
	"./mk.js": 549,
	"./ml": 550,
	"./ml.js": 550,
	"./mn": 551,
	"./mn.js": 551,
	"./mr": 552,
	"./mr.js": 552,
	"./ms": 553,
	"./ms-my": 554,
	"./ms-my.js": 554,
	"./ms.js": 553,
	"./mt": 555,
	"./mt.js": 555,
	"./my": 556,
	"./my.js": 556,
	"./nb": 557,
	"./nb.js": 557,
	"./ne": 558,
	"./ne.js": 558,
	"./nl": 559,
	"./nl-be": 560,
	"./nl-be.js": 560,
	"./nl.js": 559,
	"./nn": 561,
	"./nn.js": 561,
	"./oc-lnc": 562,
	"./oc-lnc.js": 562,
	"./pa-in": 563,
	"./pa-in.js": 563,
	"./pl": 564,
	"./pl.js": 564,
	"./pt": 565,
	"./pt-br": 566,
	"./pt-br.js": 566,
	"./pt.js": 565,
	"./ro": 567,
	"./ro.js": 567,
	"./ru": 568,
	"./ru.js": 568,
	"./sd": 569,
	"./sd.js": 569,
	"./se": 570,
	"./se.js": 570,
	"./si": 571,
	"./si.js": 571,
	"./sk": 572,
	"./sk.js": 572,
	"./sl": 573,
	"./sl.js": 573,
	"./sq": 574,
	"./sq.js": 574,
	"./sr": 575,
	"./sr-cyrl": 576,
	"./sr-cyrl.js": 576,
	"./sr.js": 575,
	"./ss": 577,
	"./ss.js": 577,
	"./sv": 578,
	"./sv.js": 578,
	"./sw": 579,
	"./sw.js": 579,
	"./ta": 580,
	"./ta.js": 580,
	"./te": 581,
	"./te.js": 581,
	"./tet": 582,
	"./tet.js": 582,
	"./tg": 583,
	"./tg.js": 583,
	"./th": 584,
	"./th.js": 584,
	"./tk": 585,
	"./tk.js": 585,
	"./tl-ph": 586,
	"./tl-ph.js": 586,
	"./tlh": 587,
	"./tlh.js": 587,
	"./tr": 588,
	"./tr.js": 588,
	"./tzl": 589,
	"./tzl.js": 589,
	"./tzm": 590,
	"./tzm-latn": 591,
	"./tzm-latn.js": 591,
	"./tzm.js": 590,
	"./ug-cn": 592,
	"./ug-cn.js": 592,
	"./uk": 593,
	"./uk.js": 593,
	"./ur": 594,
	"./ur.js": 594,
	"./uz": 595,
	"./uz-latn": 596,
	"./uz-latn.js": 596,
	"./uz.js": 595,
	"./vi": 597,
	"./vi.js": 597,
	"./x-pseudo": 598,
	"./x-pseudo.js": 598,
	"./yo": 599,
	"./yo.js": 599,
	"./zh-cn": 600,
	"./zh-cn.js": 600,
	"./zh-hk": 601,
	"./zh-hk.js": 601,
	"./zh-mo": 602,
	"./zh-mo.js": 602,
	"./zh-tw": 603,
	"./zh-tw.js": 603
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 849;

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApptButton_vue__ = __webpack_require__(604);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395f031d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApptButton_vue__ = __webpack_require__(852);
function injectStyle (ssrContext) {
  __webpack_require__(851)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApptButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395f031d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApptButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":"apptbutton"}},[_c('b-button',{staticClass:"mt-3 shadow",attrs:{"squared":"","block":_vm.block,"variant":_vm.col},on:{"click":_vm.route}},[_vm._v("\n    "+_vm._s(_vm.$t("common.make-appointment"))+"\n    "),_c('b-icon',{attrs:{"icon":"chevron-right","font-scale":"0.95","aria-hidden":"true"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]),[605]);


// WEBPACK FOOTER //
// static/js/app.3f40662ce3f88dd7b85c.js